import ablution from "./Images/Ablution.png"
import adhaan from "./Images/Adhaan.png"
import akhirah from "./Images/Akhirah.png"
import alayn from "./Images/Al-Ayn.png"
import amazement from "./Images/Amazement.png"
import anger from "./Images/Anger.png"
import anxiety from "./Images/Anxiety.png"
import arafah from "./Images/Arafah.png"
import darood from "./Images/darood-e-ibrahim.png"
import death from "./Images/Death.png"
import debts from "./Images/Debts.png"
import decision from "./Images/Decision.png"
import food from "./Images/Food.png"
import garment from "./Images/Garments.png"
import home from "./Images/home.png"
import mosque from "./Images/Mosque.png"
import knowledge from "./Images/Knowledge.png"
import nature from "./Images/Nature.png"
import patience from "./Images/Patience.png"
import protection from "./Images/Protection.png"
import qunoot from "./Images/qunoot.png"
import rabbana from "./Images/rabbana.png"
import ramandan from "./Images/Ramadan.png"
import repentance from "./Images/Repentance.png"
import sacrifice from "./Images/SACRIFICE.png"
import shirk from "./Images/Shirk.png"
import sleep from "./Images/Sleep.png"
import toilet from "./Images/Toilet.png"
import travel from "./Images/travel.png"
import health from "./Images/health.png"
import successfailure from "./Images/successfailure.png"
import family from "./Images/family.png"
import faith from "./Images/faith.png"
import haaj from "./Images/hajj.png"
import pain from "./Images/Pain.png"
import Ettiquette from "./Images/good.png"
const duas = {
        "rabbana duas": [
                {
                        "icon": rabbana,
                        "title": "Rabbana - 1",
                        "arabic": "رَبَّنَا تَقَبَّلْ مِنَّا إِنَّكَ أَنْتَ السَّمِيعُ العَلِيمُ",
                        "english": "Rabbana taqabbal minna innaka antas Sameeaul Aleem",
                        "titleDua": {
                                "Tamil": "ரப்பனா துவா",
                                "English": "rabbana duas",
                                "Urdu": "ربنا دعا"
                        },
                        "titleName": {
                                "Tamil": "ரப்பனா-1",
                                "English": "Rabbana - 1",
                                "Urdu": "ربنا-1"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Yaa Allah! Accept (this service) from us: For Thou art the All-Hearing, the All-knowing."
                                },
                                "Tamil": {
                                        "meaning": "எங்கள் இறைவனே! எங்களிடமிருந்து (இப்பணியை) ஏற்றுக் கொள்வாயாக; நிச்சயமாக நீயே (யாவற்றையும்) கேட்பவனாகவும் அறிபவனாகவும் இருக்கின்றாய்"
                                },
                                "Urdu": {
                                        "meaning": "پروردگار! ہم سے (اس خدمت کو) قبول کرو: کیونکہ تو ہی سننے والا ، جاننے والا ہے۔"
                                }
                        }
                },
                {
                        "title": "Rabbana - 2",
                        "arabic": "رَبَّنَا وَاجْعَلْنَا مُسْلِمَيْنِ لَكَ وَمِن ذُرِّيَّتِنَا أُمَّةً مُّسْلِمَةً لَّكَ وَأَرِنَا مَنَاسِكَنَا وَتُبْ عَلَيْنَآ إِنَّكَ أَنتَ التَّوَّابُ الرَّحِيمُ",
                        "english": "Rabbana wa-j'alna Muslimayni laka wa min Dhurriyatina 'Ummatan Muslimatan laka wa 'Arina Manasikana wa tub 'alayna 'innaka 'antat-Tawwabu-Raheem",
                        "titleName": {
                                "Tamil": "ரப்பனா-2",
                                "English": "Rabbana - 2",
                                "Urdu": "ربنا-2"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Ya Allah! Make of us Muslims, bowing to Thy (Will), and of our progeny a people Muslim, bowing to Thy (will); and show us our place for the celebration of (due) rites; and turn unto us (in Mercy); for Thou art the Oft-Returning, Most Merciful."
                                },
                                "Tamil": {
                                        "meaning": "எங்கள் இறைவா! எங்களை உனக்குக் கட்டுப்பட்டோராகவும், எங்கள் வழித் தோன்றல்களை உனக்குக் கட்டுப்பட்டு நடக்கும் சமுதாயமாகவும் ஆக்குவாயாக! எங்கள் வழிபாட்டு முறைகளை எங்களுக்குக் காட்டித் தருவாயாக! எங்களை மன்னிப்பாயாக! நீ மன்னிப்பை ஏற்பவன்; நிகரற்ற அன்புடையோன்."
                                },
                                "Urdu": {
                                        "meaning": "ہمارے رب! ہم کو مسلمان بنادے ، تیری رضا کے آگے جھکاؤ ، اور ہماری اولاد میں سے ایک مسلمان ، تیرے (اپنی مرضی) کے سامنے جھکے ہوئے۔ اور ہمیں (مقررہ) رسومات منانے کے لئے اپنی جگہ دکھائیں۔ اور ہماری طرف رجوع کریں (رحمت میں)۔ بےشک تو ہی بخشنے والا مہربان ہے"
                                }
                        }
                },
                {
                        "title": "Rabbana - 3",
                        "arabic": "رَبَّنَآ اٰتِنَا فِي الدُّنْيَا حَسَنَةً وَّفِي الْاٰخِرَةِ حَسَـنَةً وَّقِنَا عَذَابَ النَّارِ",
                        "english": "Rabbanaaa Aatinaa Fiddunyaa H’asanata Wa Fil Aakhirati H’asanata Wa Qinaa A’d’aaban Naar",
                        "titleName": {
                                "Tamil": "ரப்பனா-3",
                                "English": "Rabbana - 3",
                                "Urdu": "ربنا-3"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Ya Allah! Give us in this world that which is good and in the Hereafter that which is good, and save us from the torment of the Fire!"
                                },
                                "Tamil": {
                                        "meaning": "எங்கள் இறைவனே! எங்களுக்கு இவ்வுலகில் நற்பாக்கியங்களைத் தந்தருள்வாயாக; மறுமையிலும் நற்பாக்கியங்களைத் தந்தருள்வாயாக; இன்னும் எங்களை(நரக) நெருப்பின் வேதனையிலிருந்தும் காத்தருள்வாயாக. "
                                },
                                "Urdu": {
                                        "meaning": "ہمارے رب! ہمیں دنیا میں جو بھلائی ہے اور آخرت میں بھی جو بھلائی عطا فرما ، اور ہمیں دوزخ کے عذاب سے بچا!"
                                }
                        }
                },
                {
                        "title": "Rabbana - 4",
                        "arabic": "رَبَّنَا أَفْرِغْ عَلَيْنَا صَبْراً وَثَبِّتْ أَقْدَامَنَا وَانصُرْنَا عَلَى القَوْمِ الكَافِرِينَ",
                        "english": "Rabbana afrigh 'alayna sabran wa thabbit aqdamana wansurna 'alal-qawmil-kafirin",
                        "titleName": {
                                "Tamil": "ரப்பனா-4",
                                "English": "Rabbana - 4",
                                "Urdu": "ربنا-4"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Ya Allah! Bestow on us endurance, make our foothold sure, and give us help against the disbelieving folk."
                                },
                                "Tamil": {
                                        "meaning": "எங்கள் இறைவா! எங்களுக்குப் பொறுமையைத் தந்தருள்வாயாக! எங்கள் பாதங்களை உறுதியாக்குவாயாக! மறுக்கும் கூட்டத்திற்கு எதிராக எங்களுக்கு  உதவி செய்வாயாக"
                                },
                                "Urdu": {
                                        "meaning": "ہمارے رب! ہمیں صبر عطا کریں ، اپنے قدموں کو یقینی بنائیں ، اور کافروں کے خلاف ہماری مدد کریں۔"
                                }
                        }
                },
                {
                        "title": "Rabbana - 5",
                        "arabic": "رَبَّنَا لَا تُؤَاخِذْنَآ اِنْ نَّسِيْنَآ اَوْ اَخْطَاْنَا ۚ رَبَّنَا وَلَا تَحْمِلْ عَلَيْنَآ اِصْرًا كَمَا حَمَلْتَهٗ عَلَي الَّذِيْنَ مِنْ قَبْلِنَا ۚ رَبَّنَا وَلَا تُحَمِّلْنَا مَا لَا طَاقَةَ لَنَا بِهٖ ۚ وَاعْفُ عَنَّا ۪ وَاغْفِرْ لَنَا ۪ وَارْحَمْنَا ۪ اَنْتَ مَوْلٰىنَا فَانْــصُرْنَا عَلَي الْقَوْمِ الْكٰفِرِيْنَ",
                        "english": "Rabbanaa laa tu'aakhiznaaa in naseenaaa aw akhtaanaa",
                        "titleName": {
                                "Tamil": "ரப்பனா-5",
                                "English": "Rabbana - 5",
                                "Urdu": "ربنا-5"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Our Lord! Condemn us not if we forget or fall into error"
                                },
                                "Tamil": {
                                        "meaning": "எங்கள் இறைவா! நாங்கள் மறந்து விட்டாலோ, தவறு செய்து விட்டாலோ எங்களைத் தண்டித்து விடாதே."
                                },
                                "Urdu": {
                                        "meaning": "ہمارے رب! اگر ہم بھول گئے یا غلطی میں پڑ گئے تو ہماری مذمت نہ کریں"
                                }
                        }
                },
                {
                        "title": "Rabbana - 6",
                        "arabic": "رَبَّنَا وَلاَ تَحْمِلْ عَلَيْنَا إِصْرًا كَمَا حَمَلْتَهُ عَلَى الَّذِينَ مِن قَبْلِنَا",
                        "english": "Rabbanaa wa laa tahmil-'alainaaa isran kamaa hamaltahoo 'alal-lazeena min qablinaa",
                        "titleName": {
                                "Tamil": "ரப்பனா-6",
                                "English": "Rabbana - 6",
                                "Urdu": "ربنا-6"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Our Lord! Lay not on us a burden Like that which Thou didst lay on those before us"
                                },
                                "Tamil": {
                                        "meaning": "எங்கள் இறைவா! எங்களுக்கு முன் சென்றோர் மீது சிரமத்தைச் சுமத்தியது போல் எங்கள் மீது சுமத்தி விடாதே."
                                },
                                "Urdu": {
                                        "meaning": "ہمارے رب! ہم پر اس طرح بوجھ نہ ڈالو جس طرح تو نے ہم سے پہلے لوگوں پر ڈالا تھا"
                                }
                        }
                },
                {
                        "title": "Rabbana - 7",
                        "arabic": "رَبَّنَا وَلاَ تُحَمِّلْنَا مَا لاَ طَاقَةَ لَنَا بِهِ وَاعْفُ عَنَّا وَاغْفِرْ لَنَا وَارْحَمْنَا أَنتَ مَوْلاَنَا فَانصُرْنَا عَلَى الْقَوْمِ الْكَافِرِينَ"
                        , "english": "Rabbanaa wa laa tuhammilnaa maa laa taaqata lanaa bih; wa'fu 'annaa waghfir lanaa warhamnaa; Anta mawlaanaa fansurnaa 'alal qawmil kaafireen",
                        "titleName": {
                                "Tamil": "ரப்பனா-7",
                                "English": "Rabbana - 7",
                                "Urdu": "ربنا-7"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Our Lord! Lay not on us a burden greater than we have strength to bear. Blot out our sins, and grant us forgiveness. Have mercy on us. Thou art our Protector; Help us against those who stand against faith"
                                },
                                "Tamil": {
                                        "meaning": "எங்கள் இறைவா! எங்களுக்கு வலிமையில்லாததை எங்கள் மீது சுமத்தி விடாதே! எங்கள் பிழைகளைப் பொறுத்து எங்களை மன்னிப்பாயாக! அருள் புரிவாயாக! நீயே எங்கள் அதிபதி. (உன்னை) மறுக்கும் கூட்டத்திற்கு எதிராக எங்களுக்கு நீ உதவுவாயாக!."
                                },
                                "Urdu": {
                                        "meaning": "ہمارے رب! ہم پر اتنا بوجھ نہ ڈالو کہ ہمارے پاس قوت برداشت ہے۔ ہمارے گناہوں کو مٹا دو ، اور ہمیں مغفرت عطا فرما۔ ہم پر رحم فرما۔ تو ہمارا محافظ ہے۔ ان لوگوں کے خلاف جو ہماری مدد کریں"
                                }
                        }
                },
                {
                        "title": "Rabbana - 8",
                        "arabic": "رَبَّنَا لاَ تُزِغْ قُلُوبَنَا بَعْدَ إِذْ هَدَيْتَنَا وَهَبْ لَنَا مِن لَّدُنكَ رَحْمَةً إِنَّكَ أَنتَ الْوَهَّابُ"
                        , "english": "Rabbanaa laa tuzigh quloobanaa ba'da iz hadaitanaa wa hab lanaa mil ladunka rahmah; innaka antal Wahhaab",
                        "titleName": {
                                "Tamil": "ரப்பனா-8",
                                "English": "Rabbana - 8",
                                "Urdu": "ربنا-8"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Our Lord! (they say), Let not our hearts deviate now after Thou hast guided us, but grant us mercy from Thine own Presence; for Thou art the Grantor of bounties without measure"
                                },
                                "Tamil": {
                                        "meaning": "எங்கள் இறைவா! எங்களுக்கு நேர் வழி காட்டிய பின் எங்கள் உள்ளங்களைத் தடம் புரளச் செய்து விடாதே!  எங்களுக்கு உன் அருளை வழங்குவாயாக! நீ மாபெரும் வள்ளல். "
                                },
                                "Urdu": {
                                        "meaning": "ہمارے رب! (وہ کہتے ہیں کہ) اگر آپ ہماری رہنمائی کرنے کے بعد ہمارے دلوں کو اب انحراف نہ کریں بلکہ اپنی موجودگی سے ہمیں رحمت عطا کریں۔ کیونکہ تو بےپناہ فضلات دینے والا ہے"
                                }
                        }
                },
                {
                        "title": "Rabbana - 9",
                        "arabic": "رَبَّنَا إِنَّكَ جَامِعُ النَّاسِ لِيَوْمٍ لاَّ رَيْبَ فِيهِ إِنَّ اللّهَ لاَ يُخْلِفُ الْمِيعَادَ",
                        "english": "Rabbana innaka jami'unnasi li-Yawmil la raiba fi innallaha la yukhliful mi'aad",
                        "titleName": {
                                "Tamil": "ரப்பனா-9",
                                "English": "Rabbana - 9",
                                "Urdu": "ربنا-9"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Our Lord! Thou art He that will gather mankind Together against a day about which there is no doubt; for Allah never fails in His promise."
                                },
                                "Tamil": {
                                        "meaning": "எங்கள் இறைவா! எந்தச் சந்தேகமும் இல்லாத நாளில்  எங்களை நீ ஒன்று திரட்டுபவன். அல்லாஹ் வாக்கு மீற மாட்டான்."
                                },
                                "Urdu": {
                                        "meaning": "ہمارے رب! تو ہی وہ شخص ہے جو انسانوں کو اس دن کے لئے جمع کرے گا جس میں کوئی شک نہیں۔ اللہ کبھی بھی اپنے وعدے میں ناکام نہیں ہوتا"
                                }
                        }
                },
                {
                        "title": "Rabbana - 10",
                        "arabic": "رَبَّنَا إِنَّنَا آمَنَّا فَاغْفِرْ لَنَا ذُنُوبَنَا وَقِنَا عَذَابَ النَّارِ",
                        "english": " Rabbanaaa innanaaa aamannaa faghfir lanaa zunoobanaa wa qinaa 'azaaban Naar",
                        "titleName": {
                                "Tamil": "ரப்பனா-10",
                                "English": "Rabbana - 10",
                                "Urdu": "ربنا-10"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Our Lord! We have indeed believed: forgive us, then, our sins, and save us from the agony of the Fire"
                                },
                                "Tamil": {
                                        "meaning": "எங்கள் இறைவா! நம்பிக்கை கொண்டோம். எனவே எங்கள் பாவங்களை மன்னிப்பாயாக! நரக வேதனையிலிருந்து எங்களைக் காப்பாயாக!."
                                },
                                "Urdu": {
                                        "meaning": "ہمارے رب! ہم نے یقین کیا ہے: تو ہمارے گناہوں کو معاف فرما ، اور ہمیں آگ کے عذاب سے بچا"
                                }
                        }
                },
                {
                        "title": "Rabbana - 11",
                        "arabic": "رَبَّنَآ ءَامَنَّا بِمَآ أَنزَلْتَ وَٱتَّبَعْنَا ٱلرَّسُولَ فَٱكْتُبْنَا مَعَ ٱلشَّٰهِدِينَ",
                        "english": "Rabbanaaa aamannaa bimaaa anzalta wattaba'nar Rasoola faktubnaa ma'ash shaahideen",
                        "titleName": {
                                "Tamil": "ரப்பனா-11",
                                "English": "Rabbana - 11",
                                "Urdu": "ربنا-11"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Our Lord! We believe in what Thou hast revealed, and we follow the Messenger. Then write us down among those who bear witness"
                                },
                                "Tamil": {
                                        "meaning": "எங்கள் இறைவா! நீ அருளியதை நம்பினோம். இத்தூதரைப் பின்பற்றினோம். எங்களை இதற்கு சாட்சிகளாகப் பதிவு செய்து கொள். "
                                },
                                "Urdu": {
                                        "meaning": "ہمارے رب! ہم آپ کے انکشاف پر یقین رکھتے ہیں ، اور ہم رسول کی پیروی کرتے ہیں۔ پھر ہمیں گواہوں میں لکھیں"
                                }
                        }
                },
                {
                        "title": "Rabbana - 12",
                        "arabic": "ربَّنَا اغْفِرْ لَنَا ذُنُوبَنَا وَإِسْرَافَنَا فِي أَمْرِنَا وَثَبِّتْ أَقْدَامَنَا وانصُرْنَا عَلَى الْقَوْمِ الْكَافِرِينَِ"
                        , "english": "Rabbanagh fir lanaa zunoobanaa wa israafanaa feee amirnaa wa sabbit aqdaamanaa wansurnaa 'alal qawmil kaafireen",
                        "titleName": {
                                "Tamil": "ரப்பனா-12",
                                "English": "Rabbana - 12",
                                "Urdu": "ربنا-12"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Our Lord! Forgive us our sins and anything We may have done that transgressed our duty: Establish our feet firmly, and help us against those that resist Faith"
                                },
                                "Tamil": {
                                        "meaning": "எங்கள் இறைவா! எங்கள் பாவங்களையும், எங்கள் காரியங்களில் நாங்கள் வரம்பு மீறியதையும் மன்னிப்பாயாக! எங்கள் பாதங்களை உறுதிப்படுத்துவாயாக! (உன்னை) மறுக்கும் கூட்டத்திற்கு எதிராக எங்களுக்கு உதவுவாயாக."
                                },
                                "Urdu": {
                                        "meaning": "ہمارے رب! ہمارے گناہوں اور جو کچھ بھی ہم نے کیا ہے اس سے معافی مانگیں جس نے ہمارے فرض کو پامال کیا: اپنے پیروں کو مضبوطی سے قائم کرو اور ان لوگوں کے خلاف ہماری مدد کرو جو ایمان کا مقابلہ نہیں کرتے ہیں۔"
                                }
                        }
                },
                {
                        "title": "Rabbana - 13",
                        "arabic": "رَبَّنَا مَا خَلَقْتَ هَذا بَاطِلاً سُبْحَانَكَ فَقِنَا عَذَابَ النَّارِ",
                        "english": "Rabbanaa maa khalaqta haaza baatilan Subhaanaka faqinaa 'azaaban Naar",
                        "titleName": {
                                "Tamil": "ரப்பனா-13",
                                "English": "Rabbana - 13",
                                "Urdu": "ربنا-13"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Our Lord! Not for naught Hast Thou created (all) this! Glory to Thee! Give us salvation from the penalty of the Fire"
                                },
                                "Tamil": {
                                        "meaning": "எங்கள் இறைவனே! இவற்றையெல்லாம் நீ வீணாகப் படைக்கவில்லை; நீ மகா தூய்மையானவன்; (நரக) நெருப்பின் வேதனையிலிருந்து எங்களைக் காத்தருள்வாயாக."
                                },
                                "Urdu": {
                                        "meaning": "ہمارے رب! یہ سب کچھ آپ نے پیدا نہیں کیا۔ پاک ہے تیری ہمیں آگ کے عذاب سے نجات عطا فرما"
                                }
                        }
                },
                {
                        "title": "Rabbana - 14",
                        "arabic": "رَبَّنَا إِنَّكَ مَن تُدْخِلِ النَّارَ فَقَدْ أَخْزَيْتَهُ وَمَا لِلظَّالِمِينَ مِنْ أَنصَارٍ",
                        "english": "Rabbanaaa innaka man tudkhilin Naara faqad akhzai tahoo wa maa lizzaalimeena min ansaar",
                        "titleName": {
                                "Tamil": "ரப்பனா-14",
                                "English": "Rabbana - 14",
                                "Urdu": "ربنا-14"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Our Lord! Any whom Thou dost admit to the Fire, Truly Thou coverest with shame, and never will wrong-doers Find any helpers!"
                                },
                                "Tamil": {
                                        "meaning": "எங்கள் இறைவா! நீ நரகத்திற்கு அனுப்புபவனை இழிவுபடுத்திவிட்டாய். அநீதி இழைத்தோருக்கு எந்த உதவியாளரும் இல்லை. "
                                },
                                "Urdu": {
                                        "meaning": "ہمارے رب! جس کو بھی تم دوزخ میں داخل کرو گے ، بے شک تم شرم سے ڈوب گئے ہو اور ظالموں کو کوئی مددگار نہیں ملے گا۔"
                                }
                        }
                },
                {
                        "title": "Rabbana - 15",
                        "arabic": "رَّبَّنَا إِنَّنَا سَمِعْنَا مُنَادِيًا يُنَادِي لِلإِيمَانِ أَنْ آمِنُواْ بِرَبِّكُمْ فَآمَنَّا",
                        "english": "Rabbanaaa innanaa sami'naa munaadiyai yunaadee lil eemaani an aaminoo bi Rabbikum fa aamannaa",
                        "titleName": {
                                "Tamil": "ரப்பனா-15",
                                "English": "Rabbana - 15",
                                "Urdu": "ربنا-15"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Our Lord! We have heard the call of one calling (Us) to Faith, 'Believe ye in the Lord,' and we have believed "
                                },
                                "Tamil": {
                                        "meaning": "எங்கள் இறைவனே! உங்கள் இறைவன் மீது நம்பிக்கை கொள்ளுங்கள் என்று ஈமானின் பக்கம் அழைத்தவரின் அழைப்பைச் செவிமடுத்து நாங்கள் திடமாக ஈமான் கொண்டோம்;"
                                },
                                "Urdu": {
                                        "meaning": "ہمارے رب! ہم نے ایک اعتقاد کی آواز کو (ہمارے) فرشتہ کو سنا ہے ، 'خداوند پر یقین کرو' اور ہم ایمان لا چکے ہیں"
                                }
                        }
                },
                {
                        "title": "Rabbana - 16",
                        "arabic": "رَبَّنَا فَاغْفِرْ لَنَا ذُنُوبَنَا وَكَفِّرْ عَنَّا سَيِّئَاتِنَا وَتَوَفَّنَا مَعَ الأبْرَارِ",
                        "english": "Rabbanaa faghfir lanaa zunoobanaa wa kaffir 'annaa saiyi aatina wa tawaffanaa ma'al abraar",
                        "titleName": {
                                "Tamil": "ரப்பனா-16",
                                "English": "Rabbana - 16",
                                "Urdu": "ربنا-16"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Our Lord! Forgive us our sins, blot out from us our iniquities, and take to Thyself our souls in the company of the righteous"
                                },
                                "Tamil": {
                                        "meaning": "எங்கள் இறைவனே! எங்களுக்கு, எங்கள் பாவங்களை மன்னிப்பாயாக! எங்கள் தீமைகளை எங்களை விட்டும் அகற்றி விடுவாயாக; இன்னும், எங்க(ளுடைய ஆன்மாக்க)ளைச் சான்றோர்களு(டைய ஆன்மாக்களு)டன் கைப்பற்றுவாயாக."
                                },
                                "Urdu": {
                                        "meaning": "ہمارے رب! ہمارے گناہوں کو بخش دے ، ہماری خطا کو مٹا دو ، اور اپنی جانوں کو نیک لوگوں کی صحبت میں رکھو۔"
                                }
                        }
                },
                {
                        "title": "Rabbana - 17",
                        "arabic": " رَبَّنَا وَآتِنَا مَا وَعَدتَّنَا عَلَى رُسُلِكَ وَلاَ تُخْزِنَا يَوْمَ الْقِيَامَةِ إِنَّكَ لاَ تُخْلِفُ الْمِيعَاد",
                        "english": "Rabbana wa 'atina ma wa'adtana 'ala rusulika wa la tukhzina yawmal-Qiyamah innaka la tukhliful mi'aad",
                        "titleName": {
                                "Tamil": "ரப்பனா-17",
                                "English": "Rabbana - 17",
                                "Urdu": "ربنا-17"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Our Lord! Grant us what Thou didst promise unto us through Thine apostles, and save us from shame on the Day of Judgment: For Thou never breakest Thy promise"
                                },
                                "Tamil": {
                                        "meaning": "எங்கள் இறைவா! உன் தூதர்கள் வழியாக நீ எங்களுக்கு வாக்களித்ததை எங்களுக்கு வழங்குவாயாக! கியாமத் நாளில் எங்களை இழிவுபடுத்தாதே! நீ வாக்கு மீறமாட்டாய். "
                                },
                                "Urdu": {
                                        "meaning": "ہمارے رب! ہمیں اپنے رسولوں کے توسط سے ہم سے وعدہ کیا ہے ، اور ہمیں قیامت کے دن شرم سے بچا ، کیونکہ تو نے کبھی اپنا وعدہ نہیں توڑا۔"
                                }
                        }
                },
                {
                        "title": "Rabbana - 18",
                        "arabic": "رَبَّنَا آمَنَّا فَاكْتُبْنَا مَعَ الشَّاهِدِينَ",
                        "english": "Rabbana aamana faktubna ma' ash-shahideen",
                        "titleName": {
                                "Tamil": "ரப்பனா-18",
                                "English": "Rabbana - 18",
                                "Urdu": "ربنا-18"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Our Lord! We believe; write us down among the witnesses"
                                },
                                "Tamil": {
                                        "meaning": "எங்கள் இறைவா! நம்பிக்கை கொண்டோம். எனவே சான்று கூறுவோருடன் எங்களைப் பதிவு செய்வாயாக."
                                },
                                "Urdu": {
                                        "meaning": "ہمارے رب! ہم یقین رکھتے ہیں؛ ہمیں گواہوں کے درمیان لکھ دو"
                                }
                        }
                },
                {
                        "title": "Rabbana - 19",
                        "arabic": "رَبَّنَا أَنزِلْ عَلَيْنَا مَآئِدَةً مِّنَ السَّمَاء تَكُونُ لَنَا عِيداً لِّأَوَّلِنَا وَآخِرِنَا وَآيَةً مِّنكَ وَارْزُقْنَا وَأَنتَ خَيْرُ الرَّازِقِينَ ",
                        "arabic": "رَبَّنَا إِنَّكَ تَعْلَمُ مَا نُخْفِي وَمَا نُعْلِنُ وَمَا يَخْفَى عَلَى اللّهِ مِن شَيْءٍ فَي الأَرْضِ وَلاَ فِي السَّمَاء",
                        "english": "Rabbana anzil 'alaina ma'idatam minas-Samai takunu lana 'idal li-awwa-lina wa aakhirna wa ayatam-minka war-zuqna wa anta Khayrul-Raziqeen",
                        "titleName": {
                                "Tamil": "ரப்பனா-19",
                                "English": "Rabbana - 19",
                                "Urdu": "ربنا-19"
                        },
                        "language": {
                                "English": {
                                        "meaning": "O Allah our Lord! Send us from heaven a table set (with viands), that there may be for us - for the first and the last of us - a solemn festival and a sign from thee; and provide for our sustenance, for thou art the best Sustainer (of our needs) "
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வே! வானத்திலிருந்து எங்கள் மீது ஓர் உணவு மரவையை இறக்குவாயாக; அது எங்களுக்கு – எங்களில் முன்னவர்களுக்கும், எங்களில் பின் வருபவர்களுக்கும் ஒரு பெருநாளாகவும், உன்னிலிருந்து ஓர் அத்தாட்சியாகவும் இருக்கும்; இன்னும் எங்களுக்கு உணவுப் பொருட்களை அளிப்பாயாக; நீயே உணவளிப்பவர்களில் மேலானவனாக இருக்கிறாய். "
                                },
                                "Urdu": {
                                        "meaning": "اے اللہ ہمارے رب! ہمیں جنت سے ایک دسترخوان بھیجیں (تاکہ ہمارا پہلا اور آخری) ہم سے ہو اور ایک تہوار اور نشان آپ کی طرف سے ہو۔ اور ہمارے رزق کی فراہمی کرو ، کیونکہ تو بہترین رزق دار ہے (ہماری ضروریات کا)"
                                }
                        }
                },
                {
                        "title": "Rabbana - 20",
                        "arabic": "رَبَّنَا ظَلَمْنَا أَنفُسَنَا وَإِن لَّمْ تَغْفِرْ لَنَا وَتَرْحَمْنَا لَنَكُونَنَّ مِنَ الْخَاسِرِينَ",
                        "english": "Rabbana zalamna anfusina wa il lam taghfir lana wa tarhamna lanakoonanna minal khaasireen",
                        "titleName": {
                                "Tamil": "ரப்பனா-20",
                                "English": "Rabbana - 20",
                                "Urdu": "ربنا-20"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Our Lord! We have wronged our own souls: If thou forgive us not and bestow not upon us Thy Mercy, we shall certainly be lost "
                                },
                                "Tamil": {
                                        "meaning": "எங்கள் இறைவனே! எங்களுக்கு நாங்களே தீங்கிழைத்துக் கொண்டோம் – நீ எங்களை மன்னித்துக் கிருபை செய்யாவிட்டால், நிச்சயமாக நாங்கள் நஷ்டமடைந்தவர்களாகி விடுவோம்."
                                },
                                "Urdu": {
                                        "meaning": "ہمارے رب! ہم نے اپنی جانوں پر ظلم کیا ہے: اگر تو ہمیں معاف نہ کرے اور اپنی رحمت ہمیں عطا نہ کرے تو ہم یقینا گم ہوجائیں گے۔"
                                }
                        }
                }
        ],
        "Darood-e-Ibraheem": [
                {
                        "icon": darood,
                        "title": "Darood-e-Ibraheem",
                        "arabic": "اللَّهُمَّ صَلِّ عَلَى مُحَمَّدٍ وَعَلَى آلِ مُحَمَّدٍ كَمَا صَلَّيْتَ عَلَى إِبْرَاهِيمَ وَعَلَى آلِ إِبْرَاهِيمَ، إِنَّكَ حَمِيدٌ مَجِيدٌ، اللَّهُمَّ بَارِكَ عَلَى مُحَمَّدٍ وَعَلَى آلِ مُحَمَّدٍ كَمَا بَارَكْتَ عَلَى إِبْرَاهِيمَ وَعَلَى آلِ إِبْرَاهِيمَ، إِنَّكَ حَمِيدٌ مَجِيدٌ",
                        "english": "Allaahumma salli 'alaa Muhammadin wa 'alaa 'aali Muhammadin, kamaa sallayta 'alaa 'Ibraaheema wa 'alaa 'aali 'Ibraaheema, 'innaka Hameedun Majeed. Allaahumma baarik 'alaa Muhammadin wa 'alaa 'aali Muhammadin, kamaa baarakta 'alaa 'Ibraaheema wa 'alaa 'aali 'Ibraaheema, 'innaka Hameedun Majeed",
                        "titleDua": {
                                "Tamil": "தரூத்-இ-இப்ராஹீம்",
                                "English": "Darood-e-Ibraheem",
                                "Urdu": "درود e ابرہیم"
                        },
                        "titleName": {
                                "Tamil": "தரூத்-இ-இப்ராஹீம்",
                                "English": "Darood-e-Ibraheem",
                                "Urdu": "درود e ابرہیم"
                        },
                        "language": {
                                "English": {
                                        "meaning": "O Allah, bestow Your favor on Muhammad and on the family of Muhammad as You have bestowed Your favor on Ibrahim and on the family of Ibrahim, You are Praiseworthy, Most Glorious. O Allah, bless Muhammad and the family of Muhammad as You have blessed Ibrahim and the family of Ibrahim, You are Praiseworthy, Most Glorious."
                                },
                                "Tamil": {
                                        "meaning": "யா அல்லாஹ்! இப்ராஹிம்(அலை) அவர்களுக்கும் அவர்களின் குடும்பத்தினருக்கும் நீஅருள் புரிந்ததைப் போல், முஹம்மது(ஸல்) அவர்கள் மீதும், அவர்களின் குடும்பத்தினர் மீதும் நீ அருள் புரிவாயாக"
                                },
                                "Urdu": {
                                        "meaning": "اے اللہ ، اپنے احسان محمد پر اور محمد کے گھر والوں پر عطا کرو ، جیسا کہ تو نے اپنا احسان ابراہیم اور کنبہ پر کیا ابراہیم ، آپ قابل ستائش اور قابل رحم ہیں۔ اے اللہ ، محمد کو اور آل کے گھر والوں کو بھی اسی طرح برکت دو جس طرح تو نے ابراہیم کو اور آل ابراہیم کو برکت بخشی ہے ، آپ قابل ستائش اور قابل رحم ہیں۔"
                                }
                        }
                }
        ],
        "Good Ettiquette": [
                {
                        "icon": Ettiquette,
                        "title": "For greeting people ",
                        "arabic": "السلام عليكم ورحمة الله وبركاته",
                        "english": "Assalamu ‘alaikum wa rahmatullahi wa barakatuh",
                        "titleDua": {
                                "Tamil": "நல்ல ஆசாரம்",
                                "English": "Good Ettiquette",
                                "Urdu": "اچھ ے آداب"
                        },
                        "titleName": {
                                "Tamil": "மக்களை வாழ்த்துவதற்காக",
                                "English": "For greeting people ",
                                "Urdu": "لوگوں کو سلام کرنے کے لئے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "May the peace, mercy, and blessings of Allah be upon you"
                                },
                                "Tamil": {
                                        "meaning": "சாந்தியும் அல்லாஹ்வின் அருளும், ஆசீர்வாதமும் உங்கள் மீது உண்டாவதாக"
                                },
                                "Urdu": {
                                        "meaning": "اللہ پاک کا سلامتی ، رحمت اور رحمت ہو"
                                }
                        }
                },
                {
                        "title": "When responding to Salam ",
                        "arabic": "و عليكم السلام والرحمة الله وبركاته",
                        "english": "Wa’alaikum assalam wa rahmatullahi wa barakatuh",
                        "titleName": {
                                "Tamil": "சலாமுக்கு பதிலளிக்கும் போது",
                                "English": "When responding to Salam ",
                                "Urdu": "سلام کا جواب دیتے وقت"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Peace and mercy and blessings of Allah be upon you"
                                },
                                "Tamil": {
                                        "meaning": "உங்கள் மீதும் சாந்தி உண்டாகட்டும்"
                                },
                                "Urdu": {
                                        "meaning": "السلام علیکم ورحم. اللہ وبرکاتہ"
                                }
                        }
                },
                {
                        "title": "Upon sneezing ",
                        "arabic": "اَلْحَمْدُ لِلَّهِ",
                        "english": "Alhamdu lillaahi",
                        "titleName": {
                                "Tamil": "தும்மும்போது",
                                "English": "Upon sneezing",
                                "Urdu": "چھیںکنے پر"
                        },
                        "language": {
                                "English": {
                                        "meaning": "All praise is for Allah."
                                },
                                "Tamil": {
                                        "meaning": "எல்லா புகழும் அல்லாஹ்வுக்கே."
                                },
                                "Urdu": {
                                        "meaning": "تمام تعریفیں اللہ کے لئے ہیں۔"
                                }
                        }
                },
                {
                        "title": "When One Sees Someone Sneezing",
                        "arabic": "يَرْحَمُكَ اللَّهُ",
                        "english": "Yar hamu kal-laahu.",
                        "titleName": {
                                "Tamil": "ஒருவர் தும்முவதைப் பார்க்கும்போது",
                                "English": "When One Sees Someone Sneezing",
                                "Urdu": "جب کوئی دیکھتا ہے کسی کو چھینک آتی ہے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "May Allah have mercy upon you"
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ் உங்களுக்கு இரக்கம் காட்டட்டும்"
                                },
                                "Urdu": {
                                        "meaning": "اللہ آپ پر رحم کرے"
                                }
                        }
                },
                {
                        "title": "Sneezers replies back",
                        "arabic": "يَهْدِيكُمُ اللَّهُ وَيُصْلِحُ بَالَكُمْ",
                        "english": "Yahdeekumul-lahu wayuslihu balakum",
                        "titleName": {
                                "Tamil": "தும்மல் பதிலளிக்கிறது",
                                "English": "Sneezers replies back",
                                "Urdu": "چھینکوں نے جواب دیا"
                        },
                        "language": {
                                "English": {
                                        "meaning": "May Allah guide you and rectify your condition."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ் உங்களுக்கு வழிகாட்டி, உங்கள் நிலையை சரிசெய்யட்டும்."
                                },
                                "Urdu": {
                                        "meaning": "اللہ آپ کی رہنمائی کرے اور آپ کی حالت بہتر کرے۔"
                                }
                        }
                },
                {
                        "title": "For thanking someone",
                        "arabic": "جَزاكَ اللهُ خَـيْراً",
                        "english": "Jazaakallaahu khayran",
                        "titleName": {
                                "Tamil": "ஒருவருக்கு நன்றி தெரிவித்ததற்காக",
                                "English": "For thanking someone",
                                "Urdu": "کسی کا شکریہ ادا کرنے کے لئے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "May Allah reward you with good."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ் உங்களுக்கு நல்ல பலனைத் தருவான்."
                                },
                                "Urdu": {
                                        "meaning": "اللہ آپ کو جزائے خیر عطا کرے۔"
                                }
                        }
                }
        ],
        "Home": [
                {
                        "icon": home,
                        "title": "When Leaving Home-1",
                        "arabic": "بِسْمِ اللَّهِ تَوَكَّلْـتُ عَلَى اللَّهِ، وَلاَ حَوْلَ وَلاَ قُـوَّةَ إِلاَّ بِاللَّهِ.",
                        "english": "Bismil-lah, tawakkaltu AAalal-lah, wala hawla wala quwwata illa billah.",
                        "titleDua": {
                                "Tamil": "வீடு",
                                "English": "Home",
                                "Urdu": "گھر"
                        },
                        "titleName": {
                                "Tamil": "வீட்டை விட்டு வெளியேறும்போது -1",
                                "English": "When Leaving Home-1 ",
                                "Urdu": "جب گھر چھوڑتے ہو-1"
                        },
                        "language": {
                                "English": {
                                        "meaning": "In the name of Allah, I place my trust in Allah, and there is no might nor power except with Allah."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வின் பெயரால், நான் அல்லாஹ்வின் மீது நம்பிக்கை வைக்கிறேன், அல்லாஹ்வைத் தவிர வேறு எந்த சக்தியும் இல்லை."
                                },
                                "Urdu": {
                                        "meaning": "اللہ کے نام پر ، میں اللہ پر بھروسہ کرتا ہوں ، اور اللہ کے سوا کوئی طاقت اور طاقت نہیں ہے۔"
                                }
                        }
                },
                {
                        "title": "When Leaving Home - 2",
                        "arabic": "اَللَّهُـمَّ إِنِّي أَعُـوذُ بِكَ أَنْ أَضِـلَّ أَوْ أُضَـلَّ، أَوْ أَزِلَّ أَوْ أُزَلَّ، أَوْ أَظْلِـمَ أَوْ أَُظْلَـمَ، أَوْ أَجْهَلَ أَوْ يُـجْهَلَ عَلَـيَّ .",
                        "english": "Allahumma innee aAAoothu bika an adilla aw odal, aw azilla aw ozall, aw athlima aw othlam, aw ajhala aw yujhala AAalay.",
                        "titleName": {
                                "Tamil": "வீட்டை விட்டு வெளியேறும்போு -2",
                                "English": "When Leaving Home-2 ",
                                "Urdu": "جب گھر چھوڑتے ہو-2"
                        },
                        "language": {
                                "English": {
                                        "meaning": "O Allah, I take refuge with You lest I should stray or be led astray, or slip or be tripped, or oppress or be oppressed, or behave foolishly or be treated foolishly.’ slip: i.e. to commit a sin unintentionally"
                                },
                                "Tamil": {
                                        "meaning": "யா அல்லாஹ்! நான் வழி தவறி போவதில் இருந்தும் அல்லது நான் வழிகெடுக்கபடுவதில் இருந்தும் அல்லது நான் வழிசருகுவதில் இருந்தும் அல்லது வழிசருக்கச் செய்யப்படுவதில் இருந்தும் அல்லது நான் பிறர் மீது அநீதி இழைப்பதில் இருந்தும் பிறர் என் மீது அநீதி இழைப்பதில் இருந்தும் அல்லது நான் பிறரிடம் அறியத்தனமாக நடப்பதில் இருந்தும் அல்லது என்னிடம் பிறர் அறியத்தனமாக நடப்பதில் இருந்தும் உன்னிடம் பாதுகாவல் தேடுகிறேன்."
                                },
                                "Urdu": {
                                        "meaning": "اے اللہ میں آپ سے پناہ لیتا ہوں ایسا نہ ہو کہ میں گمراہ ہو جاؤں یا گمراہ ہو جاؤں ، یا پھسل جاؤں یا پھنس جائے ، یا ظلم و ستم کا مظاہرہ کیا جا or یا بے وقوفانہ سلوک کیا جائے یا بے وقوف سلوک کیا جائے۔ ’پرچی: یعنی غیر ارادی طور پر گناہ کرنا۔"
                                }
                        }
                },
                {
                        "title": "Upon Entering Home ",
                        "arabic": "بِسْـمِ اللّهِ وَلَجْنـَا، وَبِسْـمِ اللّهِ خَـرَجْنـَا، وَعَلَـى رَبِّنـَا تَوَكّلْـنَا.",
                        "english": "Bismil-lahi walajna, wabismil-lahi kharajna, waAAala rabbina tawakkalna.",
                        "titleName": {
                                "Tamil": "வீட்டிற்குள் நுழைந்தவுடன்",
                                "English": "Upon Entering Home",
                                "Urdu": "گھر میں داخل ہونے پر"
                        },
                        "language": {
                                "English": {
                                        "meaning": "In the name of Allah we enter and in the name of Allah we leave, and upon Ya Allah we place our trust."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வின் பெயரால் நாம் நுழைகிறோம், அல்லாஹ்வின் பெயரால் நாங்கள் புறப்படுகிறோம், எங்கள் இறைவன் மீது நம்பிக்கை வைக்கிறோம்."
                                },
                                "Urdu": {
                                        "meaning": "ہم اللہ کے نام پر داخل ہوتے ہیں اور اللہ کے نام پر چھوڑ دیتے ہیں اور اپنے پروردگار پر توکل کرتے ہیں۔"
                                }
                        }
                },
                {
                        "title": "When looking into the mirror",
                        "arabic": "اللَّهُمَّ أَنْتَ حَسَّنْتَ خَلْقِي فَحَسِّنْ خُلُقِي",
                        "english": "Allahumma antha hasantha khalqi fa hasintha khulqi",
                        "titleName": {
                                "Tamil": "கண்ணாடியில் பார்க்கும்போது",
                                "English": "When looking into the mirror",
                                "Urdu": "جب آئینے میں دیکھ رہا ہو"
                        },
                        "language": {
                                "English": {
                                        "meaning": "O Allah, just as You have made my external features beautiful, make my character beautiful as well."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வே, நீ என் வெளிப்புற அம்சங்களை அழகாக ஆக்கியது போலவே, என் கதாபாத்திரத்தையும் அழகாக ஆக்குங்கள்."
                                },
                                "Urdu": {
                                        "meaning": "اے اللہ جس طرح تو نے میری خارجی خصوصیات کو خوبصورت بنایا ہے اسی طرح میرے کردار کو بھی خوبصورت بنا دو۔"
                                }
                        }
                }
        ],
        "Travelling": [
                {
                        "icon": travel,
                        "title": "Dua for travelling",
                        "arabic": "سُبْحَانَ الَّذِي سَخَّرَ لَنَا هَذَا وَمَا كُنَّا لَهُ مُقْرِنِينَ وَإِنَّا إِلَى رَبِّنَا لَمُنْقَلِبُونَ.",
                        "english": "Subhana-alladhi sakh-khara la-na hadha wa ma kunna la-hu muqrinin. Wa inna ila Rabbi-na la munqalibun.",
                        "titleDua": {
                                "Tamil": "பயணம்",
                                "English": "Travelling",
                                "Urdu": "سفر کرنا"
                        },
                        "titleName": {
                                "Tamil": "பயணத்திற்கான துவா",
                                "English": "Dua for travelling",
                                "Urdu": "سفر کے لئے دعا"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Glory unto Him Who created this transportation, for us, though we were unable to create it on our own. And unto Ya Allah we shall return."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வின் திருபேயரால்.. எல்லாப் புகமும் அல்லாஹ்வுக்கே! அவனை இந்த வாகனத்தை நமக்கு வசப்பதுதிக் கொடுத்தான்! உண்மையில் அதற்க்கான சக்தியை நாம் பெற்றிருக்கவில்லை! மேலும் நிச்சயமாக நாம் நம் இரட்சகன் பக்கமே திரும்பி செல்பவர்கள்."
                                },
                                "Urdu": {
                                        "meaning": "اس کا پاک ہے جس نے یہ آمدورفت ہمارے لئے پیدا کی ، حالانکہ ہم خود ہی اس کو پیدا کرنے سے قاصر تھے۔ اور ہم اپنے رب کی طرف لوٹ کر جائیں گے۔"
                                }
                        }
                },
                {
                        "title": "While returning from travel",
                        "arabic": "ا للهُ أَكْـبَر، ا للهُ أَكْـبَر، ا للهُ أَكْـبَر،لا إلهَ إلاّ اللّهُ وَحْـدَهُ لا شريكَ لهُ، لهُ الملكُ ولهُ الحَمْد، وهُوَ على كُلّ شَيءٍ قَـدير، آيِبـونَ تائِبـونَ عابِـدونَ لِرَبِّـنا حـامِـدون، صَدَقَ اللهُ وَعْـدَه، وَنَصَـرَ عَبْـدَه، وَهَزَمَ الأَحْـزابَ وَحْـدَه.",
                        "english": "Allahu Akbar, Allahu Akbar, Allahu Akbar, Laa ilaaha illallaahu wahdahu laa shareeka lahu, lahul-mulku, wa lahul-hamdu, wa Huwa alaa kulli shay in Qadeer, aaiboona, taaiboona, aabidoona, lirabbinaa haamidoona, sadaqallaahu wadahu, wa nasara abdahu, wa hazamal-ahzaaba wahdahu.",
                        "titleName": {
                                "Tamil": "பயணத்திலிருந்து திரும்பும் போது",
                                "English": "While returning from travel",
                                "Urdu": "سفر سے واپسی کے دوران"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Allah is the greatest, Allah is the greatest, Allah is the greatest.None has the right to be worshipped except Allah, alone, without partner. To Him belongs all sovereignty and praise, and He is over all things omnipotent. We return, repent, worship and praise Ya Allah. Allah fulfilled His promise, aided His Servant, and single-handedly defeated the allies."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ் மிகப் பெரியவன், ��ல்லாஹ் மிகப் பெரியவன், அல்லாஹ் மிகப் பெரியவன். அல்லாஹ்வைத் தவிர, தனியாக, கூட்டாளர் இல்லாமல் வணங்க யாருக்கும் உரிமை இல்லை. எல்லா இறையாண்மையும் புகழும் அவருக்கே உரியது, அவர் எல்லாவற்றிற்கும் மேலானவர். நாங்கள் திரும்பி வருகிறோம், மனந்திரும்புகிறோம், வணங்குகிறோம், எங்கள் இறைவனைத் துதிக்கிறோம். அல்லாஹ் தனது வாக்குறுதியை நிறைவேற்றினான், அவனுடைய வேலைக்காரனுக்கு உதவினான், கூட்டாளிகளைத் தோற்கடித்தான்"
                                },
                                "Urdu": {
                                        "meaning": "اللہ سب سے بڑا ہے ، اللہ سب سے بڑا ہے ، اللہ سب سے بڑا ہے۔ کسی کو بھی شریک نہیں بغیر ، صرف اللہ کے سوا ، کسی کی عبادت کا حق نہیں ہے۔ اسی کی ساری بادشاہت اور حمد ہے ، اور وہ ہر چیز پر قادر ہے۔ ہم لوٹتے ہیں ، توبہ کرتے ہیں ، عبادت کرتے ہیں اور اپنے رب کی تعریف کرتے ہیں۔ اللہ نے اپنا وعدہ پورا کیا ، اپنے خادم کی مدد کی ، اور اتحادیوں کو اکیلے ہاتھ سے شکست دی"
                                }
                        }
                },
                {
                        "title": "For accomodation",
                        "arabic": "رَّبِّ أَنزِلْنِي مُنزَلًا مُّبَارَكًا وَأَنتَ خَيْرُ الْمُنزِلِينَ",
                        "english": "Rabbi anzilnee munzalan mubarakanwaanta khayru almunzileen",
                        "titleName": {
                                "Tamil": "தங்குவதற்கு",
                                "English": "For accomodation",
                                "Urdu": "رہائش کے لئے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Ya Alaah, let me land at a blessed landing place, and You are the best to accommodate [us]."
                                },
                                "Tamil": {
                                        meaning: "யா அல்லாஹ், என்னை ஒரு சிறந்த இடத்தில் தரையிறக்குங்கள், [எங்களுக்கு] இடமளிக்க நீங்கள் சிறந்தவர்கள்."
                                },
                                "Urdu": {
                                        "meaning": "میرے پروردگار ، مجھے ایک بابرکت لینڈنگ لینڈ پر اترنے دو ، اور آپ ہمارے لئے سب سے بہتر ہیں۔"
                                }
                        }
                },
                {
                        "title": "When entering market ",
                        "arabic": "لَا إِلَهَ إِلَّا اللَّهُ وَحْدَهُ لَا شَرِيكَ لَهُ لَهُ الْمُلْكُ وَلَهُ الْحَمْدُ يُحْيِي وَيُمِيتُ وَهُوَ حَيٌّ لَا يَمُوتُ بِيَدِهِ الْخُيْرُ وَهُوَ عَلَى كُلِّ شَيْءٍ قَدِيرٍ",
                        "english": "Laa ilaaha illallaahu wahdahu laa shareeka lahu, lahul-mulku wa lahul-hamdu, yuhyee wa yumeetu, wa Huwa hayyun laa yamootu, biyadihil-khayru, wa Huwa alaa kulli shayin Qadeer.",
                        "titleName": {
                                "Tamil": "சந்தையில் நுழையும் போது",
                                "English": "When entering market",
                                "Urdu": "جب بازار میں داخل ہوں"
                        },
                        "language": {
                                "English": {
                                        "meaning": "There is no Lord except Allah. He is One and has no partners. His is the Kingdom and for Him are all praises. He gives life and gives death. He is eternal and everlasting In His control is goodness, and He has power over everything."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வைத் தவிர வேறு இறைவன் இல்லை. அவர் ஒருவர், கூட்டாளிகள் யாரும் இல்லை. அவனுடைய ராஜ்யம் அவனுக்கே எல்லாப் புகழும். அவர் உயிரைக் கொடுக்கிறார், மரணத்தைத் தருகிறார். அவர் நித்தியமானவர், அவருடைய கட்டுப்பாட்டில் நன்மை இருக்கிறது, எல்லாவற்றிற்கும் அவர் அதிகாரம் கொண்டவர்."
                                },
                                "Urdu": {
                                        "meaning": "اللہ کے سوا کوئی رب نہیں ہے۔ وہ ایک ہے اور اس کا کوئی شریک نہیں ہے۔ اسی کی بادشاہی ہے اور اسی کے لئے سب تعریفیں ہیں۔ وہ زندگی دیتا ہے اور موت دیتا ہے۔ وہ ابدی اور ابدی ہے اس کے اختیار میں ہے نیکی ہے ، اور وہ ہر چیز پر قادر ہے۔"
                                }
                        }
                }
        ],
        "Restroom": [
                {
                        "icon": toilet,
                        "title": "Before entering toilet",
                        "arabic": "(بِسْمِ اللَّهِ). اللَّهُـمَّ إِنِّي أَعُـوذُ بِـكَ مِـنَ الْخُـبْثِ وَالْخَبَائِثِ.",
                        "english": "(Bismil-lah) allahumma innee aAAoothu bika minal-khubthi wal-khaba-ith",
                        "titleDua": {
                                "Tamil": "கழிப்பறை",
                                "English": "Restroom",
                                "Urdu": "بیت الخلاء"
                        },
                        "titleName": {
                                "Tamil": "கழிப்பறைக்குள் நுழைவதற்கு முன்",
                                "English": "Before entering toilet",
                                "Urdu": "بیت الخلا میں داخل ہونے سے پہلے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "(In the name of Allah). O Allah, I take refuge with you from all evil and evil-doers."
                                },
                                "Tamil": {
                                        "meaning": "இறைவா! ஆண், பெண் ஷைத்தான்களிடமிருந்து உன்னிடம் பாதுகாப்புத் தேடுகிறேன்."
                                },
                                "Urdu": {
                                        "meaning": "(اللہ کے نام پر)۔ اے اللہ ، میں تمہارے ساتھ تمام برائیوں اور بدکاروں سے پناہ لیتا ہوں۔"
                                }
                        }
                },
                {
                        "title": "After leaving toilet",
                        "arabic": "غُفْرَانَكَ",
                        "english": "Ghufranak",
                        "titleName": {
                                "Tamil": "கழிப்பறையை விட்டு வெளியேறிய பிறகு",
                                "English": "After leaving toilet",
                                "Urdu": "بیت الخلا میں داخل ہونے کے بعد"
                        },
                        "language": {
                                "English": {
                                        "meaning": "I ask You (Allah) for forgiveness."
                                },
                                "Tamil": {
                                        "meaning": "நான் உங்களிடம் (அல்லாஹ்விடம்) மன்னிப்பு கேட்கிறேன்."
                                },
                                "Urdu": {
                                        "meaning": "میں تم سے (اللہ) معافی مانگتا ہوں۔"
                                }
                        }
                }
        ],
        "Garment": [
                {
                        "icon": garment,
                        "title": "Before undressing",
                        "arabic": "بِسمِ الله",
                        "english": "bismillaah",
                        "titleDua": {
                                "Tamil": "ஆடை",
                                "English": "Garment",
                                "Urdu": "لباس"
                        },
                        "titleName": {
                                "Tamil": "அவிழ்ப்பதற்கு முன்",
                                "English": "Before undressing",
                                "Urdu": "کپڑے اتارنے سے پہلے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "In the name of Allah."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாவின் பெயரில்."
                                },
                                "Urdu": {
                                        "meaning": "اللہ کے نام پر۔"
                                }
                        }
                },
                {
                        "title": "when putting on a garment",
                        "arabic": "الحَمْدُ لِلهِ الَّذِي كَسَانِي هَذَا الثَّوْبَ وَرَزَقَنِيهِ مِنْ غَيْرِ حَوْلٍ مِنِّي وَلَا قُوَّةٍ",
                        "english": "alḥamdu lillaahil-ladhee kasaanee haadhath-thawba wa razaqaneehi min ghayri ḥawlin minnee wa laa quwwah",
                        "titleName": {
                                "Tamil": "ஒரு ஆடை அணியும்போது",
                                "English": "when putting on a garment",
                                "Urdu": "جب کسی لباس پہنے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "All Praise is for Allah who has clothed me with this garment and provided it for me, with no power nor might from myself."
                                },
                                "Tamil": {
                                        "meaning": "எல்லா புகழும் அல்லாஹ் ஒருவனுக்கே! அவனே இந்த ஆடையை எனக்கு அணிவித்தான். என்னிடத்தில் எந்த ஆற்றலும் திறமையுமின்றி இதனை எனக்கு அணிவித்தான்"
                                },
                                "Urdu": {
                                        "meaning": "ساری تعریف اس اللہ کے لئے ہے جس نے مجھے یہ لباس پہن رکھا ہے اور اسے میرے لئے مہیا کیا ہے ، بغیر کسی طاقت اور نہ ہی مجھ سے۔"
                                }
                        }
                },
                {
                        "title": "when putting on a new garment",
                        "arabic": "اللَّهُمَّ لَكَ الْحَمْدُ أَنْتَ كَسَوْتَنِيهِ ، أَسْأَلُكَ مِنْ خَيْرِهِ وَخَيْرِ مَا صُنِعَ لَهُ ، وَأَعُوذُ بِكَ مِنْ شَرِّهِ وَشَرِّ مَا صُنِعَ لَهُ",
                        "english": "allaahumma lakal-ḥamdu anta kasawtaneehi, as’aluka min khayrihi wa khayri maa ṣuni‛a lahu, wa ’a‛oodhu bika min sharrihi wa sharri maa ṣuni‛a lah",
                        "titleName": {
                                "Tamil": "ஒரு புதிய ஆடை அணியும்போது",
                                "English": "when putting on a new garment",
                                "Urdu": "جب ایک نیا لباس پہننا"
                        },
                        "language": {
                                "English": {
                                        "meaning": "O Allah, to You belongs all praise, You have clothed me with it (i.e. the garment), I ask You for the good of it and the good for which it was made, and I seek refuge with You from the evil of it and the evil for which it was made."
                                },
                                "Tamil": {
                                        "meaning": "யா அல்லாஹ்! உனக்கே எல்லா புகழும். நீதான் எனக்கு இதனை அணிவித்தாய். இதன் நன்மையும் எதற்காக இது தயாரிக்கப்பட்டதோ அதன் நன்மையையும் நான் உன்னிடம் கேட்கிறேன். மேலும் இதன் தீமையை விட்டும் எதற்க்காக இது தயார் செய்யப்பட்டதோ அதன் தீமையை விட்டும் நான் உன்னிடம் பாதுகாப்பு தேடுகிறேன்."
                                },
                                "Urdu": {
                                        "meaning": "اے اللہ ، آپ کی ہی ساری تعریف ہے ، آپ نے مجھے اس (لباس) سے ملبوس کیا ، میں آپ سے اس کی بھلائی اور بھلائی کا مطالبہ کرتا ہوں ، جس کی وجہ سے یہ بنایا گیا ہے ، اور میں اس کی برائی سے آپ سے پناہ چاہتا ہوں اور برائی جس کے ل. اسے بنایا گیا تھا۔"
                                }
                        }
                }
        ],
        "sleep": [
                {
                        "icon": sleep,
                        "title": "Before sleeping",
                        "arabic": "اللَّهُمَّ بِاسْـمِكَ أَمُوتُ وَأَحْيَا",
                        "english": "Bismikal-lahumma amootu wa-ahya.",
                        "titleDua": {
                                "Tamil": "தூக்கம்",
                                "English": "sleep",
                                "Urdu": "نیند"
                        },
                        "titleName": {
                                "Tamil": "தூங்குவதற்கு முன்",
                                "English": "Before sleeping",
                                "Urdu": "سونے سے پہلے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "In Your name O Allah, I live and die."
                                },
                                "Tamil": {
                                        "meaning": "இறைவா! உன் பெயரால் நான் மரணிக்கிறேன்; (தூங்குகிறேன்) உன் பெயரால் உயிர் பெறுகிறேன். (விழிக்கிறேன்)"
                                },
                                "Urdu": {
                                        "meaning": "تیرے نام پر اے اللہ ، میں زندہ رہتا ہوں اور مرتا ہوں۔"
                                }
                        }
                },
                {
                        "title": "when waking up",
                        "arabic": "الحَمْدُ لِلهِ الَّذِي أَحْيَانَا بَعْدَ مَا أَمَاتَنَا وَإِلَيْهِ النُّشُورُ",
                        "english": "alḥamdu lillaahil-ladhee aḥyaanaa ba‛da maa amaatanaa wa ilayhin-nushoor",
                        "titleName": {
                                "Tamil": "எழுந்திருக்கும் போது",
                                "English": "when waking up",
                                "Urdu": "جاگتے وقت"
                        },
                        "language": {
                                "English": {
                                        "meaning": "All praise is for Allah who gave us life after causing us to die, and unto Him is the resurrection."
                                },
                                "Tamil": {
                                        "meaning": "எங்களை மரணிக்கச் செய்த பின் உயிர்ப்பித்த அல்லாஹ்வுக்கே புகழனைத்தும். மேலும் அவனிடமே (நமது) திரும்பிச் செல்லுதல் உள்ளது."
                                },
                                "Urdu": {
                                        "meaning": "ساری تعریفیں اللہ کے لئے ہیں جنہوں نے ہمیں مرنے کے بعد زندگی بخشی اور اسی کی طرف قیامت ہے۔"
                                }
                        }
                },
                {
                        "title": "when seeing a bad dream",
                        "arabic": "أَعُوذُ بِاللهِ مِنَ الشَّيْطَانِ الرَّجِيمِ",
                        "english": "a‛oodhu billaahi minash-shayṭaanir-rajeem",
                        "titleName": {
                                "Tamil": "ஒரு கெட்ட கனவைப் பார்க்கும்போது",
                                "English": "when seeing a bad dream",
                                "Urdu": "ایک برا خواب دیکھ کر جب"
                        },
                        "language": {
                                "English": {
                                        "meaning": "The righteous dream is from Allah and the bad dream is from the devil, so if anyone sees something which pleases him then he should only relate it to one whom he loves…"
                                },
                                "Tamil": {
                                        "meaning": "எடுத்தெறியப்பட்ட ஷைத்தானை விட்டும் அல்லாஹ்விடம் பாதுகாவல் தேடுகிறேன்."
                                },
                                "Urdu": {
                                        "meaning": "راستباز خواب اللہ کی طرف سے ہے اور برا خواب شیطان کا ہے ، لہذا اگر کوئی ایسی چیز دیکھے جو اس سے خوش ہو تو اسے صرف اس سے ہی تعلق رکھنا چاہئے جس سے وہ محبت کرتا ہے…"
                                }
                        }
                }
        ],
        "Food": [
                {
                        "icon": food,
                        "title": "before eating and drinking",
                        "arabic": "بِسْمِ اللهِ",
                        "english": "bismillaah",
                        "titleDua": {
                                "Tamil": "உணவு",
                                "English": "Food",
                                "Urdu": "کھانا"
                        },
                        "titleName": {
                                "Tamil": "சாப்பிடுவதற்கும் குடிப்பதற்கும் முன்",
                                "English": "before eating and drinking",
                                "Urdu": "کھانے پینے سے پہلے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "In the name of Allah."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாவின் பெயரில்."
                                },
                                "Urdu": {
                                        "meaning": "اللہ کے نام پر۔"
                                }
                        }
                },
                {
                        "title": "After finishing a meal",
                        "arabic": "الْحَمْدُ لِلَّهِ الَّذِى اطْعَمَنَا وَسَقَانَا ، وَجَعَلنَا مُسْلِمِينَ",
                        "english": "Alhamdulilahil ladhi at’amana, wasaqana, waj’alna min-al Muslimeen",
                        "titleName": {
                                "Tamil": "உணவை முடித்த பிறகு",
                                "English": "After finishing a meal",
                                "Urdu": "کھانا ختم کرنے کے بعد"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Praise be to Allah Who has fed us and given us drink and made us Muslims."
                                },
                                "Tamil": {
                                        "meaning": "எல்லா புகழும் அல்லாஹ்வுக்கே உரியது, அவர் எங்களுக்கு உணவளித்து, எங்கள் தாகத்தைத் தணித்து, எங்களை முஸ்லிம்களாக ஆக்கியுள்ளார்"
                                },
                                "Urdu": {
                                        "meaning": "الحمد للہ جس نے ہمیں کھانا کھلایا اور ہمیں شراب پی اور ہمیں مسلمان کردیا۔"
                                }
                        }
                },
                {
                        "title": "when forget to say Bismillah ",
                        "arabic": "بِسْمِ اللهِ فِي أَوَّلِهِ وَآخِرِهِ",
                        "english": "bismillaahi fee awwalihi wa aakhirihi",
                        "titleName": {
                                "Tamil": "பிஸ்மில்லா என்று சொல்ல மறந்தால்",
                                "English": "when forget to say Bismillah",
                                "Urdu": "بسم اللہ کہنا جب بھول جائیں"
                        },
                        "language": {
                                "English": {
                                        "meaning": "In the name of Allah in it’s beginning and end."
                                },
                                "Tamil": {
                                        "meaning": "இதன் ஆரம்பத்திலும் இறுதியிலும் அல்லாஹ்வின் திருப்பெயரால்... (நான் உண்கிறேன்)."
                                },
                                "Urdu": {
                                        "meaning": "اللہ کے نام پر اس کا آغاز اور اختتام ہے۔"
                                }
                        }
                },
                {
                        "title": "Dua after drinking milk",
                        "arabic": "اللَّهُمَّ بَارِكْ لَنَا فِيهِ وَزِدْنَا مِنْهُ",
                        "english": "allaahumma baarik lanaa feehi wa zidnaa minh",
                        "titleName": {
                                "Tamil": "பால் குடித்த பிறகு துவா",
                                "English": "Dua after drinking milk",
                                "Urdu": "دودھ پینے کے بعد دعا"
                        },
                        "language": {
                                "English": {
                                        "meaning": "O Allah, bless it for us and give us more of it."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வே, அதை எங்களுக்காக ஆசீர்வதித்து, அதில் அதிகமானதை எங்களுக்குக் கொடுங்கள். "
                                },
                                "Urdu": {
                                        "meaning": "اے اللہ ہمارے لئے اس پر احسان فرمائے اور اس میں سے زیادہ عطا فرما۔"
                                }
                        }
                },
                {
                        "title": "Dua For someone who offers you a meal",
                        "arabic": "اَللّهُمَّ بَارِكْ لَهُمْ فِيْ مَا رَزَقْتَهُمْ وَاغْفِرْ لَهُمْ وَارْحَمْهُمْ",
                        "english": "Allahumma baarik lahum feema razakthahum vagfirlahum varfahum",
                        "titleName": {
                                "Tamil": "உங்களுக்கு ஒரு உணவை வழங்கும் ஒருவருக்கு துவா",
                                "English": "Dua For someone who offers you a meal",
                                "Urdu": "کسی کے ل  جو آپ کو کھانے کی دعا پیش کرتا ہے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "O Allah, feed the one who has fed me and drink to the one who has given me drink."
                                },
                                "Tamil": {
                                        "meaning": "இறைவா! இவர்களுக்கு நீ வழங்கியதில் பரகத் (மறைமுகமான பேரருள்) செய்வாயாக. இவர்களை மன்னிப்பாயாக! இவர்களுக்கு கருணை காட்டுவாயாக"
                                },
                                "Urdu": {
                                        "meaning": "اے اللہ اسے کھلاؤ جس نے مجھے کھلایا ہے اور اس کو پلائے جس نے مجھے پلایا ہے۔"
                                }
                        }
                },
        ],
        "Ablution": [
                {
                        "icon": ablution,
                        "title": "when starting ablution",
                        "arabic": "بِسْمِ اللهِ",
                        "english": "bismillaah",
                        "titleDua": {
                                "Tamil": "ஒழிப்பு",
                                "English": "Ablution",
                                "Urdu": "وضو"
                        },
                        "titleName": {
                                "Tamil": "உளூச் செய்யத் துவங்கும் போது",
                                "English": "when starting ablution",
                                "Urdu": "جب وضو کرنا شروع کریں"
                        },
                        "language": {
                                "English": {
                                        "meaning": "In the name of Allah"
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வின் திருப்பெயரால்..."
                                },
                                "Urdu": {
                                        "meaning": "اللہ کے نام پر"
                                }
                        }
                },
                {
                        "title": "upon completing ablution",
                        "arabic": "أَشْهَدُ أَنْ لَا إِلَهَ إِلَّا اللَّهُ وَحْدَهُ لَا شَرِيكَ لَهُ، وَأَشْهَدُ أَنَّ مُحَمَّدًا عَبْدُهُ وَرَسُولُهُ،اللَّهُمَّ اجْعَلْنِي مِنَ التَّوَّابِينَ، وَاجْعَلْنِي مِنَ المُتَطَهِّرِينَ",
                        "english": "ash-hadu an laa ilaha ill-allaahu waḥdahu laa shareeka lahu, wa ash-hadu anna muḥammadan ‛abduhu wa rasooluhu,allaahum-maj-‘alnee mi-nat taw-waabeen, waj-‘alnee mi-nal mutaṭah-hir-reen",
                        "titleName": {
                                "Tamil": "உளூச் செய்து முடித்த பின்",
                                "English": "upon completing ablution",
                                "Urdu": "وضو مکمل کرنے پر"
                        },
                        "language": {
                                "English": {
                                        "meaning": " bear witness that none has the right to be worshipped except Allah, alone, without partner, and I bear witness that Muhammad is His slave and Messenger. O Allah, make me of those who return to You often in repentance and make me of those who remain clean and pure."
                                },
                                "Tamil": {
                                        "meaning": "வணக்கத்திற்குரியவன் அல்லாஹ்வைத் தவிர யாருமில்லை என்றும் முஹம்மது (ஸல்) அவர்கள் அல்லாஹ்வின் அடியார் என்றும் அவனது தூதர் என்றும் உறுதியாக நம்புகிறேன்."
                                },
                                "Urdu": {
                                        "meaning": "گواہ رہو کہ اللہ کے سوا کسی کی شریک نہیں ہوسکتی ہے ، اور میں گواہی دیتا ہوں کہ محمد اس کا غلام اور رسول ہیں۔ اے اللہ مجھے ان لوگوں میں سے بنائے جو اکثر توبہ کرتے ہوئے آپ کی طرف لوٹ جاتے ہیں اور مجھے ان لوگوں میں سے بنادیں جو پاک صاف رہتے ہیں۔"
                                }
                        }
                }
        ],
        "Mosque": [
                {
                        "icon": mosque,
                        "title": "when going to the mosque",
                        "arabic": "اللَّهُمَّ اجْعَلْ فِي قَلْبِي نُورًا ، وَفِي لِسَانِي نُورًا ، وَاجْعَلْ فِي سَمْعِي نُورًا ، وَاجْعَلْ فِي بَصَرِي نُورًا ، وَاجْعَلْ مِنْ خَلْفِي نُورًا ، وَمِنْ أَمَامِي نُورًا ، وَاجْعَلْ مِنْ فَوْقِي نُورًا ، وَمِنْ تَحْتِي نُورًا ، اللَّهُمَّ أَعْطِنِي نُورًا",
                        "english": "allaahumma-j‛al fee qalbee noor-an, wa fee lisaanee noor-an, waj‛al fee sam‛ee noor-an, waj‛al fee baṣaree noor-an , waj‛al min khalfee noor-an, wamin amaamee noor-an, waj‛al min fawqee noor-an, wa min taḥtee noor-an, allahumma a‛ṭinee noor-an",
                        "titleDua": {
                                "Tamil": "பள்ளிவாசல்",
                                "English": "Mosque",
                                "Urdu": "مسجد"
                        },
                        "titleName": {
                                "Tamil": "மசூதிக்குச் செல்லும் போது",
                                "English": "when going to the mosque",
                                "Urdu": "جب مسجد جاتے ہو"
                        },
                        "language": {
                                "English": {
                                        "meaning": "O Allah, place within my heart light, and upon my tongue light, and within my ears light, and within my eyes light, and place behind me light, and in front of me light, and above me light, and beneath me light. O Allah, bestow upon me light."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வே, என் இருதய ஒளியிலும், என் நாவின் வெளிச்சத்திலும், என் காதுகளுக்குள்ளும், என் கண்களுக்குள்ளும் வெளிச்சமாகவும், எனக்குப் பின்னால் வெளிச்சமாகவும், எனக்கு முன்னால் ஒளியாகவும், எனக்கு முன்னால் வெளிச்சமாகவும், எனக்கு கீழே வெளிச்சமாகவும் வைக்கவும். அல்லாஹ்வே, எனக்கு ஒளி கொடு."
                                },
                                "Urdu": {
                                        "meaning": "اللہ ، میرے دل کے اندر روشنی ، اور میری زبان پر روشنی ، اور کانوں میں روشنی ، اور میری آنکھوں کے اندر روشنی ، اور میرے پیچھے روشنی رکھو ، اور میرے سامنے روشنی ، اور میرے اوپر روشنی ، اور میرے نیچے روشنی۔ اے اللہ مجھے نور عطا فرما۔"
                                }
                        }
                },
                {
                        "title": "Dua upon entering the mosque",
                        "arabic": "اللَّهُمَّ افْتَحْ لِي أَبْوَابَ رَحْمَتِكَ",
                        "english": "allaahum-maf taḥ lee abwaaba raḥmatik",
                        "titleName": {
                                "Tamil": "மசூதிக்குள் நுழைந்ததும் துவா",
                                "English": "Dua upon entering the mosque",
                                "Urdu": "دعا مسجد میں داخل ہونے پر"
                        },
                        "language": {
                                "English": {
                                        "meaning": "O Allah, open the gates of Your mercy for me."
                                },
                                "Tamil": {
                                        "meaning": "இறைவா! உனது அருள் வாசல்களை எனக்காகத் திறப்பாயாக."
                                },
                                "Urdu": {
                                        "meaning": "اللہ ، میرے لئے اپنی رحمت کے دروازے کھول دے۔"
                                }
                        }
                },
                {
                        "title": "Dua upon leaving the mosque ",
                        "arabic": "السَّلامُ عَلَى رَسُولِ اللهِ، اللَّهُمَّ إِنِّي أَسْأَلُكَ مِنْ فَضْلِكَ",
                        "english": "as-salaamu ‛alaa rasool-lil-laah,  allaa-hum-ma innee as’aluka min faḍ-lik",
                        "titleName": {
                                "Tamil": "மசூதியை விட்டு வெளியேறியதும் துவா",
                                "English": "Dua upon leaving the mosque ",
                                "Urdu": "دعا مسجد سے رخصت ہونے پر"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Peace be upon the Messenger of Allah. O Allah, I ask You from Your favour. "
                                },
                                "Tamil": {
                                        "meaning": "இறைவா! உனது அருளை வேண்டுகிறேன்."
                                },
                                "Urdu": {
                                        "meaning": "السلام علیکم اے اللہ ، میں تجھ سے تیرے حق میں پوچھتا ہوں۔"
                                }
                        }
                }
        ],
        "Adhaan": [
                {
                        "icon": adhaan,
                        "title": "Dua after the adhaan",
                        "arabic": "اللَّهُمَّ رَبَّ هَذِهِ الدَّعْوَةِ التَّامَّةِ وَالصَّلاةِ الْقَائِمَةِ آتِ مُحَمَّدًا الوَسِيلَةَ وَالْفَضِيلَةَ وَابْعَثْهُ مَقَامًا مَحْمُودًا الَّذِي وَعَدْتَه.",
                        "english": "allaahumma rabba haadhi-hid-da‛watit-taammah, waṣ-ṣalaatil-qaa’imah, aati muḥammadan-il-waseelata wal-faḍeelah, wab‛ath-hu maqaaman maḥmoodan-illadhee wa‛adtah",
                        "titleDua": {
                                "Tamil": "அதான்",
                                "English": "Adhaan",
                                "Urdu": "اذان"
                        },
                        "titleName": {
                                "Tamil": "அதானுக்குப் பிறகு துவா",
                                "English": "Dua after the adhaan",
                                "Urdu": "اذان کے بعد دعا"
                        },
                        "language": {
                                "English": {
                                        "meaning": "O Allah, Owner of this perfect call and Owner of this prayer to be performed, bestow upon Muhammad al-waseelah and al-fadeelah and raise him upon a praised platform which You have promised him."
                                },
                                "Tamil": {
                                        "meaning": "இறைவா! இந்த முழுமையான அழைப்பிற்கும், நிலையான தொழுகைக்கும் சொந்தக்காரனே! முஹம்மத் (ஸல்) அவர்களுக்கு (சொர்க்கத்தின் மிக உயர்ந்த பதவியான) வஸீலா எனும் பதவியினையும், சிறப்பையும் வழங்குவாயாக! நீ அவர்களுக்காக வாக்களித்த புகழப்பட்ட இடத்தில் அவர்களை எழுப்புவாயாக!"
                                },
                                "Urdu": {
                                        "meaning": "اللہ ، اس کامل اذان کا مالک اور اس دعا کا مالک ، محمد الوصیلہ اور الفادیلہ کو عطا فرمائے اور اسے ایک تعریفی پلیٹ فارم پر اٹھائے جس کا آپ نے وعدہ کیا ہے۔"
                                }
                        }
                },
                {
                        "title": "Dua while hearing the adhaan",
                        "arabic": "لَا حَوْلَ وَلَا قُوَّةَ إِلَّا بِاللهِ",
                        "english": "laa ḥawla wa laa quwwata illaa billaah",
                        "titleName": {
                                "Tamil": "அதானைக் கேட்கும்போது துவா",
                                "English": "Dua while hearing the adhaan",
                                "Urdu": "دعا سنتے ہوئے دعا"
                        },
                        "language": {
                                "English": {
                                        "meaning": "There is no might nor power except with Allah"
                                },
                                "Tamil": {
                                        "meaning": "நன்மையை செய்ய சக்தி பெறுவதும் தீமையை விட்டு விலகுவதும் அல்லாஹ்வின் உதவி கொண்டே தவிர வேறில்லை."
                                },
                                "Urdu": {
                                        "meaning": "اللہ کے سوا کوئی طاقت یا طاقت نہیں ہے"
                                }
                        }
                }
        ],
        "Al-'Ayn (evil eye)": [
                {
                        "icon": alayn,
                        "title": "Dua to heal the afflicted by the Evil eye or other afflictions",
                        "arabic": "بِاسْمِ اللهِ أَرْقِيكَ، مِنْ كُلِّ شَيْءٍ يُؤْذِيكَ، مِنْ شَرِّ كُلِّ نَفْسٍ أَوْ عَيْنِ حَاسِدٍ، اللهُ يَشْفِيكَ بِاسْمِ اللهِ أَرْقِيكَ",
                        "english": "Bismil-laahi ar-qeek, min kul-li shai’in yu’dheek, min shar-ri kul-li naf-sin aw ‘ayni kul-li ḥaa-sid, al-laah yash-feek, bismil-laahi ar-qeek",
                        "titleDua": {
                                "Tamil": "அல்-அய்ன் (தீய கண்)",
                                "English": "Al-'Ayn (evil eye)",
                                "Urdu": "العین (بری نظر"
                        },
                        "titleName": {
                                "Tamil": "தீய கண் அல்லது பிற துன்பங்களால் பாதிக்கப்பட்டவர்களை குணப்படுத்த துவா",
                                "English": "Dua to heal the afflicted by the Evil eye or other afflictions",
                                "Urdu": "شیطان آنکھ یا دیگر تکلیفوں سے مصیبتوں کو شفا بخش کرنے کے لئے دعا"
                        },
                        "language": {
                                "English": {
                                        "meaning": "In the Name of Allah. I recite over you [for purpose of healing] from all that troubles you, from the evil of every soul or of the eye of an envier. May Allah  cure you; with the Name of Allah, I recite over you [for purpose of healing]."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாவின் பெயரில். உங்களைத் தொந்தரவு செய்யும் எல்லாவற்றிலிருந்தும், ஒவ்வொரு  தீமையிலிருந்தோ அல்லது ஒரு பொறாமைக்காரனின் கண்ணிலிருந்தோ [குணப்படுத்தும் நோக்கத்திற்காக] நான் உங்களைப் பற்றி ஓதுகிறேன். அல்லாஹ் உங்களை குணமாக்குவான்; அல்லாஹ்வின் பெயரில், நான் [குணப்படுத்தும் நோக்கத்திற்காக] உங்களைப் பற்றி ஓதுகிறேன்."
                                },
                                "Urdu": {
                                        "meaning": "اللہ کے نام پر۔ میں تمہیں ان تمام پریشانیوں سے ، ہر جان کی برائی سے یا کسی حسد کرنے والے کی نگاہ سے (تندرستی کے مقصد کے لئے) سناتا ہوں۔ اللہ آپ کا علاج فرمائے۔ اللہ کے نام کے ساتھ ، میں تم پر (تندرستی کے ساتھ) تلاوت کرتا ہوں۔"
                                }
                        }
                },
                {
                        "title": "Dua to be protected from all types of evil",
                        "arabic": "اللهمَّ إنِّي أعُوذُ بِكَ مِنْ جَهْدِ البَلاَءِ، وَدَرَكِ الشَّقَاءِ، وَسُوءِ القَضَاءِ، وَشَمَاتَةِ الأَعْدَاءِ",
                        "english": "Allaahum-ma inni a‛oodhu bika min jah-dil-balaa’, wa darak-ish-shaqaa’, wa soo’il-qaḍaa’, wa shamaata-til a‘daa’",
                        "titleName": {
                                "Tamil": "அனைத்து வகையான தீமைகளிலிருந்தும் பாதுகாக்கப்பட வேண்டிய துவா",
                                "English": "Dua to be protected from all types of evil",
                                "Urdu": "دعا ہے کہ ہر طرح کی برائی سے محفوظ رہے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "O Allah I seek refuge with You from severe calamity, and from misery to fall upon me, and from a bad fate and from the gloating of [my] enemies."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வே, கடுமையான பேரழிவிலிருந்தும், துன்பத்திலிருந்து என்மேல் விழுவதற்கும், ஒரு மோசமான தலைவிதியிலிருந்தும், [என்] எதிரிகளின் மகிழ்ச்சியிலிருந்தும் நான் உன்னிடம் அடைக்கலம் தேடுகிறேன்."
                                },
                                "Urdu": {
                                        "meaning": "اے اللہ میں آپ سے سخت مصیبت ، اور مجھ پر آنے والے مصائب سے ، اور بد قسمتی سے اور [میرے] دشمنوں کی گمراہی سے پناہ مانگتا ہوں۔"
                                }
                        }
                }
        ],
        "Sorrow & Joy": [
                {
                        "icon": anxiety,
                        "title": "If you fall on hard times",
                        "arabic": "أَنِّي مَسَّنِيَ الضُّرُّ وَأَنتَ أَرْحَمُ الرَّاحِمِينَ",
                        "english": "Annee massaniya addurru waanta arhamuarrahimeen",
                        "titleDua": {
                                "Tamil": "துக்கம் & மகிழ்ச்சி",
                                "English": "Sorrow & Joy",
                                "Urdu": "غم & خوشی"
                        },
                        "titleName": {
                                "Tamil": "நீங்கள் கடினமான காலங்களில் விழுந்தால்",
                                "English": "If you fall on hard times",
                                "Urdu": "اگر آپ مشکل وقت پر پڑتے ہیں"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Indeed, adversity has touched me, and you are the Most Merciful of the merciful."
                                },
                                "Tamil": {
                                        "meaning": "உண்மையில், துன்பம் என்னைத் தொட்டது, நீங்கள் இரக்கமுள்ளவர்களில் மிக்க கருணையாளர்."
                                },
                                "Urdu": {
                                        "meaning": "بے شک ، مجھے تکلیف نے چھوا ہے ، اور آپ رحم کرنے والے پر رحم کرنے والے ہیں۔"
                                }
                        }
                },
                {
                        "title": "In times of happiness ",
                        "arabic": "سُبْحَانَ اللهِ اللهُ أَكْبرُ",
                        "english": "Subhaanallaah Allaahu 'Akbar",
                        "titleName": {
                                "Tamil": "மகிழ்ச்சியான காலங்களில்",
                                "English": "In times of happiness ",
                                "Urdu": "خوشی کے وقت"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Glory is to Allah. Allah is the Most Great."
                                },
                                "Tamil": {
                                        "meaning": "பெருமை அல்லாஹ்வுக்கு. அல்லாஹ் மிகப் பெரியவன்."
                                },
                                "Urdu": {
                                        "meaning": "پاک ہے اللہ کا۔ اللہ سب سے بڑا ہے۔"
                                }
                        }
                },
                {
                        "title": "On hearing a bad news",
                        "arabic": "الْحَمْـدُ للهِ على كُـلِّ حَالٍ",
                        "english": "Alhamdu lillaahi 'alaa kulli haal",
                        "titleName": {
                                "Tamil": "ஒரு மோசமான செய்தியைக் கேட்டதும்",
                                "English": "On hearing a bad news",
                                "Urdu": "ایک بری خبر سننے پر"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Praise is to Allah in all circumstances."
                                },
                                "Tamil": {
                                        "meaning": "எல்லா சூழ்நிலைகளிலும் எல்லா புகழும் அல்லாஹ்வுக்கே"
                                },
                                "Urdu": {
                                        "meaning": "ہر حال میں اللہ کی حمد ہے۔"
                                }
                        }
                },
                {
                        "title": "On hearing good news ",
                        "arabic": "الْحَمْدُ لِلَّهِ مَاشَاء اللَّهُ تبارک اللهُ",
                        "english": "Alhamdhulillahi Masha Allah Thabarak 'Allah",
                        "titleName": {
                                "Tamil": "நல்ல செய்தியைக் கேட்டதும்",
                                "English": "On hearing good news",
                                "Urdu": "خوشخبری سننے پر"
                        },
                        "language": {
                                "English": {
                                        "meaning": "All praise is to Allah, Just as Allah willed Blessed is Allah"
                                },
                                "Tamil": {
                                        "meaning": "எல்லா புகழும் அல்லாஹ்வுக்கே,"
                                },
                                "Urdu": {
                                        "meaning": "ساری تعریفیں اللہ ہی کے لئے ہیں ، جس طرح اللہ چاہتا ہے اللہ پاک ہے"
                                }
                        }
                },
                {
                        "title": "When someone insults you ",
                        "arabic": "رَبِّ احْكُم بِالْحَقِّ ۗ وَرَبُّنَا الرَّحْمَٰنُ الْمُسْتَعَانُ عَلَىٰ مَا تَصِفُونَ",
                        "english": "Rabbi ohkum bilhaqqi wa rabbuna arrahmanul musta'aanu alaa ma tasifoon",
                        "titleName": {
                                "Tamil": "யாராவது உங்களை அவமதிக்கும் போது",
                                "English": "When someone insults you",
                                "Urdu": "جب کوئی آپ کی توہین کرتا ہے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Ya Allah, judge [between us] in truth. And he is the Most Merciful, the one whose help is sought against that which you describe."
                                },
                                "Tamil": {
                                        meaning: "யா அல்லாஹ், சத்தியத்தில் [எங்களுக்கிடையில்] தீர்ப்பளிக்கவும். அவர் மிக்க கருணையாளர், நீங்கள் விவரிக்கும் விஷயங்களுக்கு எதிராக உதவி கேட்கப்படுபவர்."
                                },
                                "Urdu": {
                                        "meaning": "اے میرے پروردگار ، سچ میں انصاف کرو۔ اور ہمارا پروردگار بڑا رحم کرنے والا ہے ، جس کی مدد کے لئے اس کے مقابلہ میں مدد طلب کی گئی ہے جو تم بیان کرتے ہو۔"
                                }
                        }
                },
                {
                        "title": "When someone praises you ",
                        "arabic": "اللَّهُمّ لاَ تُؤاَخِذْنِي ِبَما يَقُولُونُ ، وَاغْفِرْ لِي مَالا يَعْلَمُونَ وَاجْعَلْنِي خَيْراً مِمَّا َيظُنُّونَ",
                        "english": "Allaahumma laa tu'aakhithnee bimaa yaqooloona, waghfir lee maa laa ya'lamoona [waj'alnee khayram-mimmaa yadhunnoon]",
                        "titleName": {
                                "Tamil": "யாராவது உங்களைப் புகழ்ந்தால்",
                                "English": "When someone praises you ",
                                "Urdu": "جب کوئی آپ کی تعریف کرتا ہے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "O Allah, do not call me to account for what they say and forgive me for what they have no knowledge of [and make me better than they imagine]."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வே, அவர்கள் சொல்வதைக் கணக்கிட்டு என்னை அழைக்காதீர்கள், அவர்களுக்கு எதுவும் தெரியாததற்கு என்னை மன்னியுங்கள் [மேலும் அவர்கள் கற்பனை செய்வதை விட என்னை சிறந்தவராக்குவார்கள்]."
                                },
                                "Urdu": {
                                        "meaning": "اے اللہ ، مجھے ان کی باتوں کا محاسبہ کرنے کے لئے نہ کہو اور مجھے ان چیزوں کے لئے معاف کرو جن کا انہیں کوئی علم نہیں ہے [اور مجھے ان کے تصور سے بہتر بنائیں]۔"
                                }
                        }
                },
                {
                        "title": "Dua for anxiety and sorrow ",
                        "arabic": "اللَّهُمَّ إِنِّي أَعُوذُ بِكَ مِنَ الْهَمِّ وَ الْحَزَنِ ، والْعَجْزِ ، والْكَسَلِ ، والْبُخْلِ ، والْجُبْنِ ، وضَلَعِ الدَّيْنِ ، وغَلَبَةِ الرِّجَالِ",
                        "english": "allaa-humma innee a‛oodhu bika mi-nal-ham-mi wal-ḥazan, wal-‛ajzi wal-kasal, wal-bukhli wal-jubn, wa ḍa-la‛id-dai-ni, wa ghalaba-tir-rijaal",
                        "titleName": {
                                "Tamil": "கவலை மற்றும் துக்கத்திற்கு துவா",
                                "English": "Dua for anxiety and sorrow  ",
                                "Urdu": "پریشانی اور غم کی دعا"
                        },
                        "language": {
                                "English": {
                                        "meaning": "O Allah, I seek refuge with You from anxiety, and sorrow, and weakness, and laziness, and miserliness, and cowardice, and the burden of debts and from being overpowered by men."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வே, கவலை, துக்கம், பலவீனம், சோம்பல், துயரம், கோழைத்தனம், கடன்களின் சுமை மற்றும் மனிதர்களால் வெல்லப்படுவதிலிருந்து நான் உன்னிடம் அடைக்கலம் தேடுகிறேன்."
                                },
                                "Urdu": {
                                        "meaning": "اے اللہ ، میں تم سے اضطراب ، غم ، اور کمزوری ، اور سستی ، بدکاری ، اور بزدلی ، اور قرضوں کے بوجھ اور مردوں کے دباؤ ہونے سے پناہ مانگتا ہوں۔"
                                }
                        }
                },
                {
                        "title": "Dua for one in distress",
                        "arabic": "لَا إِلَهَ إِلَّا أَنْتَ سُبْحَانَكَ إِنِّي كُنْتُ مِنَ الظَّالِمِينَ",
                        "english": "laa ilaaha illaa anta subḥaanaka innee kuntu minaẓ-ẓaalimeen",
                        "titleName": {
                                "Tamil": "துயரத்தில் உள்ள ஒருவருக்கு துவா",
                                "English": "Dua for one in distress",
                                "Urdu": "دباؤ دعا"
                        },
                        "language": {
                                "English": {
                                        "meaning": "None has the right to be worshipped except You. How far from imperfections You are, verily I was among the wrong-doers."
                                },
                                "Tamil": {
                                        "meaning": "உன்னைத் தவிர வேறு யாருக்கும் வழிபட உரிமை இல்லை. நீங்கள் குறைபாடுகளிலிருந்து எவ்வளவு தூரம் இருக்கிறீர்கள், நிச்சயமாக நான் தவறு செய்பவர்களில் ஒருவன்."
                                },
                                "Urdu": {
                                        "meaning": "آپ کے سوا کسی کی عبادت کا حق نہیں ہے۔ آپ کو کس حد تک نااہلی ہے ، بے شک میں ظالموں میں شامل تھا۔"
                                }
                        }
                },
                {
                        "title": "For curbing fear ",
                        "arabic": "اللَّهُمَّ اكْفِنِيهِمْ بِماَ شِئْتَ",
                        "english": "Allaahummak-fineehim bimaa shi'ta",
                        "titleName": {
                                "Tamil": "பயத்தைத் தடுக்க துவா",
                                "English": "For curbing fear",
                                "Urdu": "خوف کو روکنے کے لئے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "O Allah, suffice (i.e. protect) me against them however You wish."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வே, உங்கள் விருப்பத்துடன் அவர்களுக்கு எதிராக என்னைப் பாதுகாக்கவும்."
                                },
                                "Urdu": {
                                        "meaning": "اے اللہ ، ان کے مقابلہ میں مجھے کافی (یعنی حفاظت کرو) اگر آپ چاہیں۔"
                                }
                        }
                },
                {
                        "title": "When stricken by tragedy",
                        "arabic": "إِنّا للهِ وَإِنَا إِلَـيْهِ رَاجِِعُـونَ ، اللهُـمِّ اْجُـرْني فِي مُصِـيبَتي، وَاخْلُـفْ لِي خَيْـراً مِنْـها",
                        "english": "Innaa lillaahi wa 'innaa 'ilayhi raaji'oon, Allaahumma'-jurni fee museebatee wa 'akhliflee khayran minhaa",
                        "titleName": {
                                "Tamil": "சோகம் நிகழும்போது  துவா",
                                "English": "When stricken by tragedy",
                                "Urdu": "جب سانحہ سے دوچار ہوتا ہے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "We are from Allah and unto Him we return. O Allah take me out of my plight and bring to me after it something better."
                                },
                                "Tamil": {
                                        "meaning": "நாங்கள் அல்லாஹ்விடமிருந்து வந்தவர்கள், அவரிடம் திரும்புவோம். அல்லாஹ், என் அவலநிலையிலிருந்து என்னை வெளியே எடுத்து, அதற்குப் பிறகு என்னிடம் சிறந்ததைக் கொண்டு வாருங்கள்."
                                },
                                "Urdu": {
                                        "meaning": "ہم اللہ کی طرف سے ہیں اور ہم اسی کی طرف لوٹ رہے ہیں۔ اے اللہ مجھے میری حالت زار سے دور فرما اور اس کے بعد کچھ اور بھی بہتر چیز لاؤ۔"
                                }
                        }
                },
                {
                        "title": "At times of worry and sorry",
                        "arabic": "اللّهُـمَّ إِنِّي أَعْوذُ بِكَ مِنَ الهَـمِّ وَ الْحُـزْنِ، والعًجْـزِ والكَسَلِ والبُخْـلِ والجُـبْنِ، وضَلْـعِ الـدَّيْنِ وغَلَبَـةِ الرِّجال",
                        "english": "Allaahumma 'innee 'a'oothu bika minal-hammi walhazani, wal'ajzi walkasali, walbukhli waljubni, wa dhala'id-dayni wa ghalabatir-rijaal",
                        "titleName": {
                                "Tamil": "கவலை மற்றும் மன்னிப்பு நேரங்களில்",
                                "English": "At times of worry and sorry",
                                "Urdu": "پریشانی اور افسوس کے وقت"
                        },
                        "language": {
                                "English": {
                                        "meaning": "O Allah, I seek refuge in you from grief and sadness, from weakness and from laziness, from miserliness and from cowardice, from being overcome by debt and overpowered by men (i .e . others)."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வே, துக்கத்திலிருந்தும், சோகத்திலிருந்தும், பலவீனத்திலிருந்தும் சோம்பலிலிருந்தும், துயரத்திலிருந்தும், கோழைத்தனத்திலிருந்தும், கடனிலிருந்து முறியடிக்கப்படுவதிலிருந்தும், மனிதர்களால் வெல்லப்படுவதிலிருந்தும் நான் உன்னை அடைக்கலம் தேடுகிறேன்."
                                },
                                "Urdu": {
                                        "meaning": "اے اللہ ، میں آپ سے غم اور افسردگی ، کمزوری اور کاہلی ، گمراہی اور بزدلی سے پناہ مانگتا ہوں ، قرض پر قابو پانے اور مردوں کے ذریعہ دباؤ ڈالنے سے (یعنی دوسرے)۔"
                                }
                        }
                },
                {
                        "title": "For overcoming your weaknesses",
                        "arabic": "اللَّهُمَّ إنِّي أعُوذُ بِكَ مِنَ الْهَمِّ وَ الْحَزَنِ وَ الْعَجْزِ وَ الْكَسَلِ وَ الْبُخْلِ وَ الْجُبْنِ وَ ضَلَعِ الدِّيْنِ وَ غَلَبَةِ الرِّجَالِ",
                        "english": "Allahumma inni a'udhubika minal hammi wal hazan, wal 'ajzi wal kasal, wal bukhli wal jubn, wa dhala'id-dayni wa ghalabatir rijaal",
                        "titleName": {
                                "Tamil": "உங்கள் பலவீனங்களை சமாளிக்க",
                                "English": "For overcoming your weaknesses",
                                "Urdu": "اپنی کمزوریوں پر قابو پانے کے لئے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "O Allah! I seek refuge in You from grief and sadness, from weakness and from laziness, from miserliness and from cowardice, from being overcome by debt and from being overpowered by men (other people)."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வே! துக்கம் மற்றும் சோகம், பலவீனம் மற்றும் சோம்பல், துன்பம் மற்றும் கோழைத்தனம், கடனால் கடக்கப்படுவதிலிருந்தும், மனிதர்களால் (பிற மக்கள்) அதிகப்படியாக இருப்பதிலிருந்தும் நான் உங்களிடம் அடைக்கலம் தேடுகிறேன்."
                                },
                                "Urdu": {
                                        "meaning": "اے اللہ! میں غم اور افسردگی ، کمزوری اور کاہلی ، بداخلاقی اور بزدلی سے ، قرض پر قابو پانے اور مردوں (دوسرے لوگوں) سے دبے ہوئے ہونے سے پناہ مانگتا ہوں۔"
                                }
                        }
                }
        ],
        "Debt": [
                {
                        "icon": debts,
                        "title": "Dua when in debt ",
                        "arabic": "اللَّهُمَّ اكْفِنِي بِحَلالِكَ عَنْ حَرَامِكَ ، وَأَغْنِنِي بِفَضْلِكَ عَمَّنْ سِوَاكَ",
                        "english": "allaahummak-finee bi ḥalaalika ‛an ḥaraamika, wa aghninee bi faḍlika ‛amman siwaak",
                        "titleDua": {
                                "Tamil": "கடன்",
                                "English": "Debt",
                                "Urdu": "قرض"
                        },
                        "titleName": {
                                "Tamil": "கடனில் இருக்கும்போது துவா",
                                "English": "Dua when in debt ",
                                "Urdu": "دعا جب قرض میں ہو"
                        },
                        "language": {
                                "English": {
                                        "meaning": "O Allah, make what is lawful enough for me, as opposed to what is unlawful, and spare me by Your grace of the need for others"
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வே, சட்டவிரோதமானதை எதிர்த்து, எனக்குப் போதுமான சட்டபூர்வமானதைச் செய்யுங்கள், மற்றவர்களின் தேவையைப் பற்றிய உமது கிருபையால் என்னைக் காப்பாற்றுங்கள்"
                                },
                                "Urdu": {
                                        "meaning": "اے اللہ جو حرام ہے اس کے مقابلہ میں میرے لئے کافی حد تک جائز ہے اور دوسروں کی ضرورت کے اپنے فضل سے مجھے بچا۔"
                                }
                        }
                },
                {
                        "title": "Dua For someone who lends you money",
                        "arabic": "بارَكَ اللهُ لَكَ في أَهْلِكَ وَمالِك، إِنَّما جَـزاءُ السَّلَفِ الْحَمْدُ والأَدَاء",
                        "english": "Baarakallaahu laka fee 'ahlika wa maalika, 'innamaa jazaa'us-salafil-hamdu wal'adaa'",
                        "titleName": {
                                "Tamil": "உங்களுக்கு பணம் கொடுக்கும் ஒருவருக்கு துவா",
                                "English": "Dua For someone who lends you money",
                                "Urdu": "دعا کسی ایسے شخص کے لئے جو آپ کو قرض دیتا ہے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "May Allah bless you in your family and your wealth, surely the reward for a loan is praise and returning (what was borrowed)."
                                },
                                "Tamil": {
                                        "meaning": "உங்கள் குடும்பத்திலும் உங்கள் செல்வத்திலும் அல்லாஹ் உங்களுக்குக் ரஹ்மத் கொடுப்பான், நிச்சயமாக கடனுக்கான வெகுமதி புகழும் திரும்பும் (கடன் வாங்கப்பட்டவை)."
                                },
                                "Urdu": {
                                        "meaning": "اللہ آپ کو اپنے گھر والوں اور آپ کی دولت میں برکت دے ، یقینا a قرض کا بدلہ تعریف اور لوٹنا ہے (جو قرض لیا گیا تھا)۔"
                                }
                        }
                }
        ],
        "Health": [
                {
                        "icon": pain,
                        "title": "Dua when feeling pain in the body",
                        "arabic": "أَعُوذُ بِاللهِ وَقُدْرَتِهِ مِنْ شَرِّ مَا أَجِدُ وَأُحَاذِرُ (سبع مرات)",
                        "english": "’a‛oodhu bial-laahi wa qudratih min shar-ri maa ajidu wa uḥaadhir (7 Times)",
                        "titleDua": {
                                "Tamil": "ஆரோக்கியம்",
                                "English": "Health",
                                "Urdu": "صحت"
                        },
                        "titleName": {
                                "Tamil": "உடலில் வலியை உணரும்போது துவா",
                                "English": "Dua when feeling pain in the body",
                                "Urdu": "دعا جب جسم میں درد محسوس ہوتا ہو"
                        },
                        "language": {
                                "English": {
                                        "meaning": "I seek refuge with Allah and His omnipotence from the evil of what I feel and that which I am wary of.” (Seven times)"
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வின் கண்ணியம் மற்றும் ஆற்றலை கொண்டு நான் உணர்கின்ற அஞ்சுகின்ற (இந்த வலியின்) தீமையை விட்டு பாதுகாவல் தேடுகிறேன். தனது கையை உடலில் வலியுள்ள பகுதியின் மீது வைத்து ‘பிஸ்மில்லாஹி’ என்று மூன்று தடவை சொல்ல வேண்டும். பிறகு ஏழு தடவை மேற்கூறப்பட்டதை ஓதவேண்டும்."
                                },
                                "Urdu": {
                                        "meaning": "میں اللہ کے اور اس کی قدرت سے پناہ مانگتا ہوں اس کے شر سے جو میں محسوس کرتا ہوں اور جس سے میں محتاط ہوں۔ (سات بار)"
                                }
                        }
                },
                {
                        "title": "Dua To alleviate pain ",
                        "arabic": "بِسْمِ اللهِ , بِسْمِ اللهِ , بِسْمِ اللهِ أَعُوذُ باللهِ وَقُدْرَتِهِ مَنْ شَرِّ مَا أَجِدُ وَأُحَاذِرُ",
                        "english": "Bismillaah, Bismillaah, Bismillaah 'A'oothu billaahi wa qudratihi min sharri maa 'ajidu wa 'uhaathiru",
                        "titleName": {
                                "Tamil": "வலியைப் போக்க துவா",
                                "English": "Dua To alleviate pain",
                                "Urdu": "درد کو دور کرنے کے لئے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "In the Name of Allah I seek refuge in Allah and in His Power from the evil of what I find and of what I guard against."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வின் பெயரில் நான் காணும் தீமைகளிலிருந்தும் அல்லாஹ்விடமிருந்தும் அவருடைய சக்தியிலிருந்தும் நான் தஞ்சம் அடைகிறேன்."
                                },
                                "Urdu": {
                                        "meaning": "اللہ کے نام پر میں اللہ کی اور اس کی قدرت میں پناہ مانگتا ہوں اس برائی سے جو مجھے ملتا ہے اور جس سے میں بچتا ہوں۔"
                                }
                        }
                },
                {
                        "title": "Dua when visiting the sick ",
                        "arabic": "لَا بَأْسَ طَهُورٌ إِنْ شَاءَ اللَّهُ",
                        "english": "Laa ba'sa tahoorun 'inshaa'Allaah.",
                        "titleName": {
                                "Tamil": "நோயுற்றவர்களைப் பார்க்கும்போது துவா",
                                "English": "Dua When visiting the sick ",
                                "Urdu": "جب بیمار کی عیادت کرتے ہو"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Do not worry, it will be a purification (for you), Allah willing."
                                },
                                "Tamil": {
                                        "meaning": "கவலைப்பட வேண்டாம், அது உங்களுக்கு சுத்திகரிப்பு, அல்லாஹ்வின் விருப்பத்துடன்."
                                },
                                "Urdu": {
                                        "meaning": "پریشان نہ ہوں ، یہ پاک ہے (آپ کے لئے) ، اللہ چاہے۔"
                                }
                        }
                },
                {
                        "title": "For a healthy life ",
                        "arabic": "اللّهُـمَّ عافِـني في بَدَنـي ، اللّهُـمَّ عافِـني في سَمْـعي ، اللّهُـمَّ عافِـني في بَصَـري ، لا إلهَ إلاّ أَنْـتَ. اللّهُـمَّ إِنّـي أَعـوذُبِكَ مِنَ الْكُـفر ، وَالفَـقْر ، وَأَعـوذُبِكَ مِنْ عَذابِ القَـبْر ، لا إلهَ إلاّ أَنْـتَ",
                        "english": "Allaahumma 'aafinee fee badanee, Allaahumma 'aafinee fee sam'ee, Allaahumma 'aafinee fee basaree, laa 'ilaaha 'illaa 'Anta. Allaahumma 'innee 'a'oothu bika minal-kufri, walfaqri, wa 'a'oothu bika min 'athaabil-qabri, laa 'ilaaha 'illaa 'Anta.",
                        "titleName": {
                                "Tamil": "ஆரோக்கியமான வாழ்க்கைக்கு",
                                "English": "For a healthy life ",
                                "Urdu": "صحت مند زندگی کے لئے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "O Allah, make me healthy in my body. O Allah, preserve for me my hearing. O Allah, preserve for me my sight. There is none worthy of worship but You . O Allah , I seek refuge in You from disbelief and poverty and I seek refuge in You from the punishment of the grave . There is none worthy of worship but You."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வே, என் உடலை ஆரோக்கியமாக்கு. அல்லாஹ்வே, என் செவிப்புலனைக் காத்துக்கொள். அல்லாஹ்வே, என் பார்வையை எனக்குக் காத்துக்கொள். உன்னை தவிர வணக்கத்திற்கு தகுதியானவர்கள் யாரும் இல்லை. அல்லாஹ்வே, நான் அவநம்பிக்கையிலிருந்தும் வறுமையிலிருந்தும் உன்னிடம் அடைக்கலம் தேடுகிறேன், கப்ர் தண்டனையிலிருந்து உன்னிடம் அடைக்கலம் தேடுகிறேன். உங்கள் தவிர வணக்கத்திற்கு தகுதியானவர்கள் யாரும் இல்லை."
                                },
                                "Urdu": {
                                        "meaning": "اے اللہ مجھے اپنے جسم میں صحت مند بنائے۔ اے اللہ ، میری سماعت کو میرے لئے محفوظ رکھنا۔ اے اللہ میری نگاہ میرے لئے محفوظ فرما۔ تیرے سوا کوئی عبادت کا لائق نہیں ہے۔ اے اللہ میں کفر اور غربت سے تیری پناہ مانگتا ہوں اور قبر کے عذاب سے تیری پناہ مانگتا ہوں۔ تیرے سوا کوئی عبادت کا لائق نہیں ہے۔"
                                }
                        }
                }
        ],
        "Success & Failure": [
                {
                        "icon": successfailure,
                        "title": "Dua For success ",
                        "arabic": "وَمَا تَوْفِيقِي إِلَّا بِاللَّهِ ۚ عَلَيْهِ تَوَكَّلْتُ وَإِلَيْهِ أُنِيبُ",
                        "english": "Wama tawfeeqee illa billahiAAalayhi tawakkaltu wa-ilayhi oneeb",
                        "titleDua": {
                                "Tamil": "வெற்றி & தோல்வி",
                                "English": "Success & Failure",
                                "Urdu": "کامیابی & ناکامی"
                        },
                        "titleName": {
                                "Tamil": "வெற்றிக்கான துவா",
                                "English": "Dua For success",
                                "Urdu": "کامیابی کے ل"
                        },
                        "language": {
                                "English": {
                                        "meaning": "My success is not but through Allah. Upon him I have relied, and to Him I return."
                                },
                                "Tamil": {
                                        "meaning": "எனது வெற்றி அல்லாஹ்வின் மூலமே. அவர்மீது நான் தங்கியிருக்கிறேன், அவரிடம் நான் திரும்புவேன்."
                                },
                                "Urdu": {
                                        "meaning": "میری کامیابی اللہ کے ذریعہ نہیں ہے۔ اسی پر میں نے بھروسہ کیا ہے ، اور میں اسی کی طرف لوٹ رہا ہوں۔"
                                }
                        }
                },
                {
                        "title": "When you fail or lose at something ",
                        "arabic": "قَدَّرَ اللهُ وَما شـاءَ فَعَـلَ",
                        "english": "Qadarullaahu wa maa shaa'afa'ala",
                        "titleName": {
                                "Tamil": "நீங்கள் ஏதாவது தோல்வியுற்றால் அல்லது இழக்கும்போது",
                                "English": "When you fail or lose at something",
                                "Urdu": "جب آپ کسی چیز میں ناکام یا کھو جاتے ہیں"
                        },
                        "language": {
                                "English": {
                                        "meaning": "It is the Decree of Allah and He does whatever He wills."
                                },
                                "Tamil": {
                                        "meaning": "இது அல்லாஹ்வின் ஆணை மற்றும் அவர் விரும்பியதைச் செய்கிறார்."
                                },
                                "Urdu": {
                                        "meaning": "یہ اللہ کا فرمان ہے اور وہ جو چاہے کرتا ہے۔"
                                }
                        }
                }
        ],
        "Patience": [
                {
                        "icon": patience,
                        "title": "Dua for controlling your anger",
                        "arabic": "أَعُوذُ بِاللهِ مِنَ الشَّيْطَانِ الرَّجِيمِ ",
                        "english": "a‛oodhu billaahi minash-shayṭaanir-rajeem",
                        "titleDua": {
                                "Tamil": "பொறுமை",
                                "English": "Patience",
                                "Urdu": "صبر"
                        },
                        "titleName": {
                                "Tamil": "உங்கள் கோபத்தை கட்டுப்படுத்த துவா",
                                "English": "Dua for controlling your anger",
                                "Urdu": "اپنے غصے پر قابو پانے کے لئے دعا"
                        },
                        "language": {
                                "English": {
                                        "meaning": "I seek refuge with Allah from the accursed devil (shaytaan)."
                                },
                                "Tamil": {
                                        "meaning": "சபிக்கப்பட்ட ஷைத்தானிடமிருந்து நான் அல்லாஹ்விடம் அடைக்கலம் தேடுகிறேன்"
                                },
                                "Urdu": {
                                        "meaning": "میں ملعون شیطان (شیطان) سے اللہ کی پناہ مانگتا ہوں۔"
                                }
                        }
                },
                {
                        "title": "Dua when longing for something in this life",
                        "arabic": "اللَّهُمَّ لاَ عَيْشَ إِلَّا عَيْشُ الآخِرَهْ",
                        "english": "al-laa-hum-ma laa ‘ai-sha il-laa ‘ai-shul aa-khi-rah",
                        "titleName": {
                                "Tamil": "இந்த வாழ்க்கையில் எதையாவது ஏங்கும்போது துவா",
                                "English": "Dua when longing for something in this life",
                                "Urdu": "دعا جب اس زندگی میں کسی چیز کے لئے ترس جائے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "O Allah, there is no [true] life but the life of the hereafter."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வே, மறுமையின் வாழ்க்கையைத் தவிர வேறு [உண்மையான] வாழ்க்கை இல்லை."
                                },
                                "Urdu": {
                                        "meaning": "اے اللہ ، آخرت کی زندگی کے سوا کوئی اور حقیقی زندگی نہیں ہے۔"
                                }
                        }
                },
                {
                        "title": "When you are in need",
                        "arabic": "رَبِّ إِنِّي لِمَا أَنزَلْتَ إِلَيَّ مِنْ خَيْرٍ فَقِيرٌ",
                        "english": "Rabbi innee lima anzalta ilayya min khayrin faqeer",
                        "titleName": {
                                "Tamil": "உங்களுக்கு தேவைப்படும்போது",
                                "English": "When you are in need",
                                "Urdu": "جب آپ محتاج ہوں"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Ya Allah! Truly, I am in need of whatever good that You bestow on me!"
                                },
                                "Tamil": {
                                        meaning: "யா அல்லாஹ்! மெய்யாகவே, நீங்கள் எனக்கு அளித்த அனைத்து நன்மையும் எனக்குத் தேவை!"
                                },
                                "Urdu": {
                                        "meaning": "میرے مالک! واقعتا! ، مجھے ہر اس اچھ !ی چیز کا محتاج ہے جو آپ مجھ پر دیں۔"
                                }
                        }
                }
        ],
        "Nature": [
                {
                        "icon": nature,
                        "title": "Dua when it is raining",
                        "arabic": "اللَّهُمَّ صَيِّبًا نَافِعًا",
                        "english": "allaahumma ṣayyiban naafi‛aa",
                        "titleDua": {
                                "Tamil": "இயற்கை",
                                "English": "Nature",
                                "Urdu": "فطرت"
                        },
                        "titleName": {
                                "Tamil": "மழை பெய்யும்போது துவா",
                                "English": "Dua when it is raining",
                                "Urdu": "دعا جب بارش ہو رہی ہو"
                        },
                        "language": {
                                "English": {
                                        "meaning": "O Allah, may it be a beneficial rain."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வே, இது ஒரு நன்மை பயக்கும் மழையாக இருக்கட்டும்."
                                },
                                "Urdu": {
                                        "meaning": "اے اللہ ، یہ فائدہ مند بارش ہو۔"
                                }
                        }
                },
                {
                        "title": "Dua after the rain has fallen",
                        "arabic": "مُطِرْنَا بِفَضْلِ اللهِ وَرَحْمَتِهِ",
                        "english": "muṭirnaa bi faḍlil-laahi wa raḥmatih",
                        "titleName": {
                                "Tamil": "மழை பெய்த பிறகு துவா",
                                "English": "Dua after the rain has fallen",
                                "Urdu": "دعا بارش گرنے کے بعد"
                        },
                        "language": {
                                "English": {
                                        "meaning": "We have been given rain by the grace and mercy of Allah."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வின் கிருபையினாலும் கருணையினாலும் எங்களுக்கு மழை வழங்கப்பட்டுள்ளது."
                                },
                                "Urdu": {
                                        "meaning": "ہمیں اللہ کے فضل و کرم سے بارش ہوئی ہے۔"
                                }
                        }
                },
                {
                        "title": "Dua for the rain to stop",
                        "arabic": "اللَّهُمَّ حَوْلَنَا وَلَا عَلَيْنَا ، اللَّهُمَّ عَلَى الآ كَامِ وَالظِّرَابِ ، وَبُطُونِ الأَوْدِيَةِ ، وَمَنَابِتِ الشَّجَرِ",
                        "english": "allaahumma ḥawlanaa wa laa ‛alaynaa, allaahumma ‛alal-aakaami waẓ-ẓiraabi, wa buṭoonil-awdiyati, wa manaabitish-shajar",
                        "titleName": {
                                "Tamil": "மழை நிறுத்த துவா",
                                "English": "Dua for the rain to stop",
                                "Urdu": "بارش رکنے کے لئے دعا"
                        },
                        "language": {
                                "English": {
                                        "meaning": "O Allah, let the rain fall around us and not upon us, O Allah, (let it fall) on the pastures, hills, valleys and the roots of trees."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வே, மேய்ச்சல் நிலங்கள், மலைகள், பள்ளத்தாக்குகள் மற்றும் மரங்களின் வேர்கள் மீது, நம்மீது அல்ல, மழை பெய்யட்டும்."
                                },
                                "Urdu": {
                                        "meaning": "اے اللہ ، چراگاہوں ، پہاڑیوں ، وادیوں اور درختوں کی جڑوں پر ہمارے گرد بارش نہ ہم پر برسنے دو ، اے اللہ!"
                                }
                        }
                },
                {
                        "title": "Dua upon hearing thunder",
                        "arabic": "سُبْحَانَ الَّذِي يُسَبِّحُ الرَّعْدُ بِحَمْدِهِ ، وَالْمَلائِكَةُ مِنْ خِيفَتِهِ",
                        "english": "subḥaan-alladhee yusabbiḥ-ur-ra‛du bi ḥamdihi, wal-malaa’ikatu min kheefatih",
                        "titleName": {
                                "Tamil": "இடி கேட்டவுடன் துவா",
                                "English": "Dua upon hearing thunder",
                                "Urdu": "گرج کی آواز سننے پر دعا"
                        },
                        "language": {
                                "English": {
                                        "meaning": "How far from imperfections He is, (The One) Whom the thunder declares His perfection with His praise, as do the angels out of fear of Him."
                                },
                                "Tamil": {
                                        "meaning": "அவர் குறைபாடுகளிலிருந்து எவ்வளவு தூரம் இருக்கிறார், மலக்குகள் அவரைப் பயப்படுவதால், இடி முழுமையை அவருடைய புகழுடன் அறிவிக்கிறது."
                                },
                                "Urdu": {
                                        "meaning": "وہ کس طرح ناپائیدگیوں سے دور ہے ، (ایک) جس کی گرج اس کی تعریف کے ساتھ اپنے کمال کا اعلان کرتی ہے ، اسی طرح اس کے خوف سے فرشتے بھی۔"
                                }
                        }
                },
                {
                        "title": "Dua during a wind storm ",
                        "arabic": "اللَّهُمَّ إِنِّي أَسْأَلُكَ خَيْرَهَا ، وَأَعُوذُ بِكَ مِنْ شَرِّهَا",
                        "english": "allaahumma innee as’aluka khayrahaa, wa a‛oodhu bika min sharrihaa",
                        "titleName": {
                                "Tamil": "ஒரு புயலின் போது துவா",
                                "English": "Dua during a wind storm",
                                "Urdu": "ہوا کے طوفان کے دوران دعا"
                        },
                        "language": {
                                "English": {
                                        "meaning": "O Allah, I ask You for it’s goodness and I seek refuge with You from it’s evil."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வே, இது நன்மைக்காக நான் உங்களிடம் கேட்கிறேன், அது தீமையிலிருந்து உங்களிடம் அடைக்கலம் தேடுகிறேன்."
                                },
                                "Urdu": {
                                        "meaning": "اے اللہ ، میں تم سے اس کی بھلائی کے لئے پوچھتا ہوں اور میں اس کی برائی سے تیری پناہ مانگتا ہوں۔"
                                }
                        }
                }
        ],
        "Forgiveness": [
                {
                        "icon": repentance,
                        "title": "Dua when a sin is committed",
                        "arabic": "أَسْتَغْفِرُ اللهَ ، أَسْتَغْفِرُ اللهَ ، أَسْتَغْفِرُ اللهَ",
                        "english": "astaghfirullaah, astaghfirullaah, astaghfirullaah",
                        "titleDua": {
                                "Tamil": "மன்னிப்பு",
                                "English": "Forgiveness",
                                "Urdu": "معافی"
                        },
                        "titleName": {
                                "Tamil": "ஒரு பாவம் செய்யப்படும்போது",
                                "English": "Dua when a sin is committed",
                                "Urdu": "جب گناہ کا ارتکاب ہوتا ہے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "I seek Allah's forgiveness, I seek Allah's forgiveness, I seek Allah's forgiveness."
                                },
                                "Tamil": {
                                        "meaning": "நான் அல்லாஹ்வின் மன்னிப்பை நாடுகிறேன், அல்லாஹ்வின் மன்னிப்பை நாடுகிறேன், அல்லாஹ்வின் மன்னிப்பை நாடுகிறேன்."
                                },
                                "Urdu": {
                                        "meaning": "میں اللہ کی مغفرت طلب کرتا ہوں ، اللہ کی مغفرت چاہتا ہوں ، اللہ کی مغفرت چاہتا ہوں۔"
                                }
                        }
                },
                {
                        "title": "For forgiveness for your parents and all Muslims ",
                        "arabic": "رَبَّنَا اغْفِرْ لِي وَلِوَالِدَيَّ وَلِلْمُؤْمِنِينَ يَوْمَ يَقُومُ الْحِسَابُ",
                        "english": "Rabbana ghfir li wa li wallidayya wa lil Mu'mineena yawma yaqumul hisaab",
                        "titleName": {
                                "Tamil": "உங்கள் பெற்றோர் மற்றும் அனைத்து முஸ்லிம்களுக்கும் மன்னிப்புக்காக",
                                "English": "For forgiveness for your parents and all Muslims",
                                "Urdu": "اپنے والدین اور تمام مسلمانوں کے لئے مغفرت کے لئے"
                        },
                        "language": {
                                "English": {
                                        "meaning": " Ya Allah! Cover (us) with Thy Forgiveness - me, my parents, and (all) Believers, on the Day that the Reckoning will be established!"
                                },
                                "Tamil": {
                                        meaning: "யா அல்லாஹ்! கணக்கீடு நிறுவப்படும் நாளில், உங்கள் மன்னிப்பு - என் பெற்றோர் மற்றும் (அனைத்து) விசுவாசிகளுக்கும் எங்களுக்கு வழங்குங்கள்!"
                                },
                                "Urdu": {
                                        "meaning": "اے ہمارے رب! مجھے ، اپنے والدین اور (سب) مومنوں کو اپنی مغفرت سے ڈھانپ دو ، جس دن حساب قائم ہوگا!"
                                }
                        }
                },
                {
                        "title": "For repentance ",
                        "arabic": "أَسْتَغْفِرُ اللهَ الَّذِي لاَ إِلَهَ إلاَّ هُوَ الحَيُّ القَيّوُمُ وأَتُوبُ إِلَيهِ",
                        "english": "Astaghfirullaah alladhee laa ilaaha illaa huwal hayyul qayyoomu wa atoobu ilayhi",
                        "titleName": {
                                "Tamil": "மனந்திரும்புதலுக்காக",
                                "English": "For repentance",
                                "Urdu": "توبہ کے ل"
                        },
                        "language": {
                                "English": {
                                        "meaning": "I seek the forgiveness of Allah the Mighty, Whom there is none worthy of worship except Him, the Living, the Eternal, and I repent to Him, Allah will forgive him even if he has deserted the army's ranks."
                                },
                                "Tamil": {
                                        "meaning": "நான் வல்லமையுள்ள அல்லாஹ்விடம் மன்னிப்புக் கோருகிறேன், அவரைத் தவிர வணக்கத்திற்கு தகுதியானவர் யாரும் இல்லை, உயிருள்ளவர், நித்தியமானவர், நான் அவரிடம் மனந்திரும்புகிறேன், அவர் இராணுவத்தின் அணிகளைத் துறந்தாலும் அல்லாஹ் அவனை மன்னிப்பான்."
                                },
                                "Urdu": {
                                        "meaning": "میں اللہ سبحانہ وتعالی کی مغفرت چاہتا ہوں ، جس کے سوا کوئی دوسرا لائق نہیں ، اس کے سوا زندہ ، ابدی ہے ، اور میں اس سے توبہ کرتا ہوں ، اللہ اسے معاف کردے گا چاہے وہ فوج کی صفوں سے ہٹ گیا ہو۔"
                                }
                        }
                },
                {
                        "title": "Forgiveness for your siblings",
                        "arabic": "رَبِّ اغْفِرْ لِي وَلِأَخِي وَأَدْخِلْنَا فِي رَحْمَتِكَ ۖ وَأَنْتَ أَرْحَمُ الرَّاحِمِينَ",
                        "english": "Rabbi ighfir lee wali akhee wa adkhilna fee rahmatika wa anta arhamur rahimeen",
                        "titleName": {
                                "Tamil": "உங்கள் உடன்பிறப்புகளுக்கு மன்னிப்பு",
                                "English": "Forgiveness for your siblings",
                                "Urdu": "اپنے بہن بھائیوں کے لئے معافی"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Ya Allah! Forgive me and my brother, and make us enter into Your Mercy, for you are the Most Merciful of those who show mercy."
                                },
                                "Tamil": {
                                        meaning: "யா அல்லாஹ்! என்னையும் என் சகோதரனையும் மன்னித்து, உமது கருணைக்குள் நுழையும்படி செய்யுங்கள், ஏனென்றால் கருணை காட்டுபவர்களில் நீங்களும் மிக்க கருணையாளர்."
                                },
                                "Urdu": {
                                        "meaning": "اے میرے رب! مجھے اور میرے بھائی کو بخش دے ، اور ہمیں اپنی رحمت میں داخل فرما ، کیونکہ تو رحم کرنے والوں میں بڑا رحم کرنے والا ہے۔"
                                }
                        }
                }
        ],
        "Family": [
                {
                        "icon": family,
                        "title": "Dua For parents",
                        "arabic": "رَّبِّ ارْحَمْهُمَا كَمَا رَبَّيَانِي صَغِيرًا",
                        "english": "Rabbi irhamhuma kama rabbayani sagheera",
                        "titleDua": {
                                "Tamil": "குடும்பம்",
                                "English": "Family",
                                "Urdu": "کنبہ"
                        },
                        "titleName": {
                                "Tamil": "பெற்றோருக்கு துவா",
                                "English": "Dua For parents",
                                "Urdu": "دعا والدین کے لئے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Ya Allah, have mercy upon them (parents) as they brought me up [when i was] small."
                                },
                                "Tamil": {
                                        "meaning": "[நான்] சிறியவனாக இருந்தபோது அவர்கள் என்னை வளர்த்ததால் யா (அல்லாஹ்) அவர்கள் மீது கருணை காட்டுங்கள்."
                                },
                                "Urdu": {
                                        "meaning": "یا اللہ ان پر (والدین) رحم کریں جیسے انہوں نے مجھے [جب میں چھوٹا تھا) پالا تھا۔"
                                }
                        }
                },
                {
                        "title": "Dua For a blissful family ",
                        "arabic": "رَبَّنَا هَبْ لَنَا مِنْ أَزْوَاجِنَا وَذُرِّيَّاتِنَا قُرَّةَ أَعْيُنٍ وَاجْعَلْنَا لِلْمُتَّقِينَ إِمَامًا",
                        "english": "Rabbana Hablana min azwaajina wadhurriy-yatina, qurrata 'ayioni wa-jalna lil-muttaqeena Imaama",
                        "titleName": {
                                "Tamil": "துவா ஒரு ஆனந்தமான குடும்பத்திற்கு",
                                "English": "Dua For a blissful family",
                                "Urdu": "دعا ایک خوش کن خاندان کے لئے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Ya Allah! Grant unto us wives and offspring who will be the comfort of our eyes, and give us (the grace) to lead the righteous."
                                },
                                "Tamil": {
                                        "meaning": "யா அல்லாஹ்! எங்கள் கண்களுக்கு ஆறுதலாக இருக்கும் மனைவியையும் சந்ததியையும் எங்களுக்குக் கொடுங்கள், நீதிமான்களை வழிநடத்த எங்களுக்கு (கிருபையை) கொடுங்கள்."
                                },
                                "Urdu": {
                                        "meaning": "اے میرے رب! ہمیں ایسی بیویاں اور اولاد عطا فرما جو ہماری آنکھوں کی راحت ہوں اور ہمیں نیک لوگوں کی رہنمائی کرنے کی توفیق عطا کریں۔"
                                }
                        }
                },
                {
                        "title": "Dua when Having Relation With Wife ",
                        "arabic": "بِسْمِ اللَّهِ اللَّهُمَّ جَنِّبْنَا الشَّيْطَانَ وَجَنِّبِ الشَّيْطَانَ مَا رَزَقْتَنَا",
                        "english": "Bismillah, Allahumma Jannibna-sh-Shaitan, Wa Jannibi-sh-Shaitana ma Razaqtana",
                        "titleName": {
                                "Tamil": "மனைவியுடன் உறவு கொள்ளும்போது துவா",
                                "English": "Dua when Having Relation With Wife ",
                                "Urdu": "دعا جب بیوی سے رشتہ لے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "I am having relations in the name of Allah. O Allah save us from Satan and keep him away from the children You grant us. The child that is born after the recitation of this dua will never be harmed by Satan"
                                },
                                "Tamil": {
                                        "meaning": "நான் அல்லாஹ்வின் பெயரால் உறவு கொண்டிருக்கிறேன். அல்லாஹ் எங்களை ஷைத்தானிடமிருந்து காப்பாற்றி, நீ எங்களுக்கு கொடுக்கும் பிள்ளைகளிடமிருந்து அவனை விலக்கி வைக்கவும். இந்த துவா பாராயணம் செய்தபின் பிறந்த குழந்தை ஒருபோதும் ஷைத்தானால் பாதிக்கப்படாது"
                                },
                                "Urdu": {
                                        "meaning": "اللہ کے نام پر میرے تعلقات ہیں۔ اے اللہ ہمیں شیطان سے بچائے اور ان بچوں سے دور رکھے جو تو نے ہمیں دیا ہے۔ اس دعا کی تلاوت کے بعد جو بچہ پیدا ہوتا ہے اسے کبھی بھی شیطان نقصان نہیں پہنچائے گا"
                                }
                        }
                },
                {
                        "title": "Asking Allah to grant you a child ",
                        "arabic": "رَبِّ ھَبْ لِيْ مِنْ لَّدُنْكَ ذُرِّيَّةً طَيِّبَةً ۚ اِنَّكَ سَمِيْعُ الدُّعَاۗءِ",
                        "english": "Rabbi Hab Lee Mil Ladunka D’urriyyatan T’ayyibah Innaka Samee-u’d Du’aa",
                        "titleName": {
                                "Tamil": "உங்களுக்கு ஒரு குழந்தையை வழங்குமாறு அல்லாஹ்விடம் கேட்பது",
                                "English": "Asking Allah to grant you a child",
                                "Urdu": "اللہ سے دعا ہے کہ آپ کو بچہ عطا کرے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Ya Allah! Grant me from You, a good offspring. You are indeed the All-Hearer of invocation."
                                },
                                "Tamil": {
                                        "meaning": "யா அல்லாஹ்! ஒரு நல்ல சந்ததியினான உங்களிடமிருந்து எனக்கு கொடுங்கள். நீங்கள் உண்மையிலேயே அனைத்தையும் கேட்பவர். "
                                },
                                "Urdu": {
                                        "meaning": "اے میرے رب! مجھے ایک اچھی اولاد عطا فرما۔ آپ واقعی دعا کے سننے والے ہیں۔"
                                }
                        }
                }
        ],
        "Faith(Imaan)": [
                {
                        "icon": faith,
                        "title": "Dua For righteous company",
                        "arabic": "فَاطِرَ السَّمَاوَاتِ وَالْأَرْضِ أَنْتَ وَلِيِّي فِي الدُّنْيَا وَالْآخِرَةِ ۖ تَوَفَّنِي مُسْلِمًا وَأَلْحِقْنِي بِالصَّالِحِينَ",
                        "english": "fatira assamawatiwal-ardi anta waliyyee fee addunyawal-akhirati tawaffanee musliman waalhiqneebissaliheen",
                        "titleDua": {
                                "Tamil": "நம்பிக்கை",
                                "English": "Faith(Imaan)",
                                "Urdu": "عقیدہ"
                        },
                        "titleName": {
                                "Tamil": "நீதியான நிறுவனத்திற்கு துவா",
                                "English": "Dua For righteous company",
                                "Urdu": "دعا صالح کمپنی کے لئے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Creator of the heavens and earth, You are my protector in this world and in the Hereafter. Cause me to die a Muslim and join me with the righteous."
                                },
                                "Tamil": {
                                        "meaning": "வானங்களையும் பூமியையும் படைத்தவர், நீங்கள் இந்த உலகத்திலும் மறுமையிலும் என் பாதுகாவலர். என்னை ஒரு முஸ்லீமாக இறக்கச் செய்து, இமான் உல்லாவர்கலுடான் என்னை சேருங்கள்."
                                },
                                "Urdu": {
                                        "meaning": "آسمانوں اور زمین کے خالق ، آپ ہی دنیا اور آخرت میں میرے محافظ ہیں۔ مجھے ایک مسلمان کی موت کا سبب بن اور مجھے نیک لوگوں میں شامل فرما۔"
                                }
                        }
                },
                {
                        "title": "Dua For Rizq (sustenance)",
                        "arabic": "اللَّهُمَّ إِنِّي أَسْأَلُكَ عِلْماً نَافِعاً، وَرِزْقاً طَيِّباً، وَعَمَلاً مُتَقَبَّلاً",
                        "english": "Allaahumma 'innee 'as'aluka 'ilman naafi'an, wa rizqan tayyiban, wa 'amalan mutaqabbalan",
                        "titleName": {
                                "Tamil": "ரிஸ்க் துவா",
                                "English": "Dua For Rizq (sustenance)",
                                "Urdu": "رزق دعا"
                        },
                        "language": {
                                "English": {
                                        "meaning": "O Allah, I ask You for knowledge that is of benefit , a good provision , and deeds that will be accepted."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வே, நன்மை பயக்கும் அறிவு, ஒரு நல்ல ஏற்பாடு மற்றும் ஏற்றுக்கொள்ளப்படும் செயல்களை நான் உங்களிடம் கேட்கிறேன்."
                                },
                                "Urdu": {
                                        "meaning": "اے اللہ ، میں آپ سے ایک ایسے علم کے ل ask دعا گو ہوں جو فائدہ مند ہو ، ایک اچھی رزق ، اور اعمال جو قبول ہوں گے۔"
                                }
                        }
                },
                {
                        "title": "For thanking Allah (SWT)",
                        "arabic": "سُبْحَانَ رَبِّيَ الْعَظِيمِ",
                        "english": "Subhaana Rabbiyal-'Adheem",
                        "titleName": {
                                "Tamil": "அல்லாஹ்வுக்கு நன்றி தெரிவித்ததற்காக",
                                "English": "For thanking Allah (SWT)",
                                "Urdu": "اللہ کا شکریہ ادا کرنے کے لئے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Glory to my Lord the Exalted."
                                },
                                "Tamil": {
                                        "meaning": "உயர்ந்த என் இறைவனுக்கு எல்லா புகழ்."
                                },
                                "Urdu": {
                                        "meaning": "میرے رب پاک کی ذات پاک ہے۔"
                                }
                        }
                },
                {
                        "title": "Pledge to Allah",
                        "arabic": "إِنِّي وَجَّهْتُ وَجْهِيَ لِلَّذِي فَطَرَ السَّمَاوَاتِ وَالْأَرْضَ حَنِيفًا ۖ وَمَا أَنَا مِنَ الْمُشْرِكِينَ",
                        "english": "Innee wajjahtu wajhiya lillathee fataraassamawati wal-arda haneefanwama ana mina almushrikeen",
                        "titleName": {
                                "Tamil": "அல்லாஹ்விடம் உறுதிமொழி",
                                "English": "Pledge to Allah",
                                "Urdu": "اللہ سے عہد کرو"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Indeed, I have turned my face toward He who created the heavens and the earth, inclining toward truth, and I am not of those who associate others with Allah ."
                                },
                                "Tamil": {
                                        "meaning": "உண்மையில், வானங்களையும் பூமியையும் படைத்தவர், சத்தியத்தை நோக்கி சாய்ந்தவர் ஆகியோருக்கு நான் முகம் திருப்பினேன், மற்றவர்களை அல்லாஹ்வுடன் தொடர்புபடுத்துபவர்களில் நான் இல்லை."
                                },
                                "Urdu": {
                                        "meaning": "بے شک میں نے اس کی طرف منہ موڑا ہے جس نے آسمانوں اور زمین کو پیدا کیا ، حق کی طرف مائل تھا ، اور میں ان لوگوں میں سے نہیں ہوں جو دوسروں کو اللہ کے ساتھ شریک کرتے ہیں۔"
                                }
                        }
                },
                {
                        "title": "To Strengthen your Imaan ",
                        "arabic": "رَضِيتُ باللَّهِ رَبًّا، وَبِالْإِسْلَامِ دِيناً، وَبِمُحَمَّدٍ صَلَى اللَّهُ عَلِيهِ وَسَلَّمَ نَبِيَّاً. (ثلاثاً)",
                        "english": "Radeetu billahi rabban wabil-islami deenan wabiMuhammadin peace be upon to him nabiyya.",
                        "titleName": {
                                "Tamil": "உங்கள் இமானை பலப்படுத்த",
                                "English": "To Strengthen your Imaan",
                                "Urdu": "اپنے امین کو مضبوط بنانا"
                        },
                        "language": {
                                "English": {
                                        "meaning": "I am pleased with Allah as a Lord, and Islam as a religion and Muhammad peace be upon to him as a Prophet. (three times)"
                                },
                                "Tamil": {
                                        "meaning": "நான் ஒரு இறைவனாக அல்லாஹ்வைப் பற்றி மகிழ்ச்சியடைகிறேன், இஸ்லாம் ஒரு மதமாகவும், முஹம்மது(ஸல்) ஒரு நபியாக அவருக்கு இருக்கட்டும். (மூன்று முறை)"
                                },
                                "Urdu": {
                                        "meaning": "��یں اللہ سے بحیثیت خداوندی خوش ہوں ، اور اسلام بطور مذہب اور محمد صلی اللہ علیہ وآلہ وسلم بحیثیت نبی۔ (تین بار)"
                                }
                        }
                },
                {
                        "title": "To be a pious Muslim",
                        "arabic": "رَبَّنَا لاَ تَجْعَلْنَا مَعَ الْقَوْمِ الظَّالِمِينَ",
                        "english": "Rabbanaa Laa Taj-a’lnaa Ma – A’l Qawmiz’ Z’aalimeen",
                        "titleName": {
                                "Tamil": "ஒரு பக்தியுள்ள முஸ்லிமாக இருக்க வேண்டும்",
                                "English": "To be a pious Muslim",
                                "Urdu": "ایک متقی مسلمان ہونا"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Ya Allah! Place us not with the people who are Zaalimoon (polytheists and wrong doers)."
                                },
                                "Tamil": {
                                        "meaning": "யா அல்லாஹ்! ஜாலிமூன் (ஷிர்க் மற்றும் தவறான செயல்கள்) செய்யும் நபர்களுடன் எங்களை வைக்காதீர்கள்."
                                },
                                "Urdu": {
                                        "meaning": "ہمارے رب! ہمیں ان لوگوں کے ساتھ نہ رکھنا جو ظالیمون ہیں۔"
                                }
                        }
                },
                {
                        "title": "To make us practising Muslims",
                        "arabic": "رَبَّنَا آمَنَّا بِمَا أَنزَلَتْ وَاتَّبَعْنَا الرَّسُولَ فَاكْتُبْنَا مَعَ الشَّاهِدِينَِ",
                        "english": "Rabbana amanna bima anzalta wattaba 'nar-Rusula fak-tubna ma'ash-Shahideen",
                        "titleName": {
                                "Tamil": "எங்களை நல்ல முஸ்லிம்களாக மாற��ற",
                                "English": "To make us practising Muslims",
                                "Urdu": "ہمیں مسلمان پر عمل کرنے کے لئے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Ya Allah! We believe in what Thou hast revealed, and we follow the Messenger. Then write us down among those who bear witness."
                                },
                                "Tamil": {
                                        "meaning": "யா அல்லாஹ்! நீ வெளிப்படுத்தியதை நாங்கள் நம்புகிறோம், நாங்கள் தூதரைப் பின்பற்றுகிறோம். சாட்சி கொடுப்பவர்களிடையே எங்களை எழுதுங்கள்."
                                },
                                "Urdu": {
                                        "meaning": "ہمارے رب! ہم اس پر یقین رکھتے ہیں جو تو نے نازل کیا ہے ، اور ہم رسول کی پیروی کرتے ہیں۔ پھر ہمیں گواہوں میں لکھیں"
                                }
                        }
                },
                {
                        "title": "To trust upon Allah",
                        "arabic": "حَسْبِيَ اللّٰهُ لا إِلَـهَ إِلاَّ هُوَ عَلَيْهِ تَوَكَّلْتُ وَهُوَ رَبُّ الْعَرْشِ الْعَظِيمِ",
                        "english": "H’asbiyallaah Laaa Ilaaha Illaa – Huw A’layhi Tawakkaltu Wa Huwa Rabbul A’rshil A’z’eem",
                        "titleName": {
                                "Tamil": "அல்லாஹ்வின் மீது நம்பிக்கை வைக்க",
                                "English": "To trust upon Allah",
                                "Urdu": "اللہ پر بھروسہ کرنا"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Allah is sufficient for me. Laa ilaaha illa Huwa (none has the right to be worshipped but He), in Him I put my trust and He is the Lord of the Mighty Throne."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ் எனக்குப் போதும். லா இலாஹா இல்ல ஹுவ (அவரைத் தவிர வேறு யாருக்கும் வழிபட உரிமை இல்லை), அவர் மீது நான் நம்பிக்கை வைத்தேன், அவர் வல்லமை வாய்ந்த சிம்மாசனத்தின் இறைவன்."
                                },
                                "Urdu": {
                                        "meaning": "اللہ میرے لئے کافی ہے۔ لا الہ الا اللہ ہوا (اس کے سوا کسی کی عبادت کا حق نہیں ہے) ، اسی پر میں نے بھروسہ کیا اور وہی عرش کا مالک ہے۔"
                                }
                        }
                }
        ],
        "Prayer": [
                {
                        "icon": qunoot,
                        "title": "After Takbeer (Start of prayer) ",
                        "arabic": "سُبْحَانَكَ اللَّهُمَّ وَبِحَمْدِكَ، وَتَبَارَكَ اسْمُكَ، وَتَعَالَى جَدُّكَ، وَلَا إِلَهَ غَيْرُكَ",
                        "english": "Subhaanaka Allaahumma wa bihamdika, wa tabaarakasmuka, wa ta'aalaa jadduka, wa laa 'ilaaha ghayruka",
                        "titleDua": {
                                "Tamil": "தொழுகை",
                                "English": "Prayer",
                                "Urdu": "ناماز"
                        },
                        "titleName": {
                                "Tamil": "தக்பீருக்குப் பிறகு (தொழுகையின் ஆரம்பம்)",
                                "English": "After Takbeer (Start of prayer)",
                                "Urdu": "تکبیر کے بعد"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Glory is to You O Allah, and praise. Blessed is Your Name and Exalted is Your Majesty. There is none worthy of worship but You."
                                },
                                "Tamil": {
                                        "meaning": "எல்லா புகழும் அல்லாஹ்வுக்கே. உம்முடைய பெயர் பாக்கியம், உயர்ந்தது உமது மாட்சிமை.உங்களை தவிர வணக்கத்திற்கு தகுதியானவர்கள் யாரும் இல்லை."
                                },
                                "Urdu": {
                                        "meaning": "اے اللہ آپ کی ذات پاک ہے ، آپ کا نام مبارک ہے اور آپ کی عظمت ہے۔ تیرے سوا کوئی عبادت کا لائق نہیں ہے۔"
                                }
                        }
                },
                {
                        "title": "During Ruku (bowing down in prayer)",
                        "arabic": "سُبْحَانَ رَبِّيَ الْعَظِيمِ",
                        "english": "Subhaana Rabbiyal-'Adheem",
                        "titleName": {
                                "Tamil": "ருகுவின் போது (தோலுகாயில் குனிந்து)",
                                "English": "During Ruku (bowing down in prayer)",
                                "Urdu": "رکوع کے دوران"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Glory to my Lord the Exalted."
                                },
                                "Tamil": {
                                        "meaning": "உயர்ந்த என் இறைவனுக்கு எல்லா புகழும்."
                                },
                                "Urdu": {
                                        "meaning": "میرے رب پاک کی ذات پاک ہے۔"
                                }
                        }
                },
                {
                        "title": "While prostrating before Allah (in Sujood)",
                        "arabic": "سُبْحَانَ رَبِّيَ الأَعْلَى",
                        "english": "Subhaana Rabbiyal-A 'laa",
                        "titleName": {
                                "Tamil": "அல்லாஹ்வின் முன் ஸஜ்தா செய்யும் போது (சுஜூத்தில்)",
                                "English": "While prostrating before Allah (in Sujood)",
                                "Urdu": "اللہ کے حضور سجدہ کرتے ہوئے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Glory is to my Lord, the Most High."
                                },
                                "Tamil": {
                                        "meaning": "எல்லா புகழும் என் இறைவனுக்கு, மிக உயர்ந்தவர்."
                                },
                                "Urdu": {
                                        "meaning": "پاک میرے پروردگار کی ذات پاک ہے"
                                }
                        }
                },
                {
                        "title": "When sitting between two Sujood (Prostrations)",
                        "arabic": "رَبِّ اغْفِرْ لِي رَبِّ اغْفِرْ لِي",
                        "english": "Rabbighfir lee, Rabbighfir lee",
                        "titleName": {
                                "Tamil": "இரண்டு சுஜூத் இடையே அமர்ந்திருக்கும் போது",
                                "English": "When sitting between two Sujood (Prostrations)",
                                "Urdu": "جب دو سجدہ کے درمیان بیٹھا ہو"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Ya Allah, forgive me. My Lord, forgive me."
                                },
                                "Tamil": {
                                        "meaning": "யா அல்லாஹ், என்னை மன்னியுங்கள். என் இறைவா, என்னை மன்னியுங்கள்."
                                },
                                "Urdu": {
                                        "meaning": "خداوند ، مجھے معاف کردے۔ اے میرے رب مجھے معاف کردے۔"
                                }
                        }
                },
                {
                        "title": "When sitting in Prayer (Tashahhud) ",
                        "arabic": "التَّحِيَّاتُ للهِ، وَالصَّلَوَاتُ، وَالطَّيِّبَاتُ، السَّلَامُ عَلَيْكَ أَيُّهَا النَّبِيُّ وَرَحْمَةُ اللهِ وَبَرَكَاتُهُ، السَّلَامُ عَلَيْنَا وَعَلَى عِبَادِ اللهِ الصَّالِحِينَ. أّشَْدُ أَنْ لَا إِلَهَ إِلَّا اللهُ وَأَشْهَدُ أَنَّ مُحَمَّداً عَبْدُهُ وَرَسُولُهُ",
                        "english": "Attahiyyaatu lillaahi wassalawaatu , wattayyibaatu , assalaamu 'alayka 'ayyuhan-Nabiyyu wa rahmatullaahi wa barakaatuhu, assalaamu 'alaynaa wa 'alaa 'ibaadillaahis-saaliheen. 'Ash-hadu 'an laa 'ilaaha 'illallaahu wa 'ash-hadu 'anna Muhammadan 'abduhu wa Rasooluhu",
                        "titleName": {
                                "Tamil": "தோலுகாயில் அமர்ந்திருக்கும் போது (தாஷாஹுத்)",
                                "English": "When sitting in Prayer (Tashahhud)",
                                "Urdu": "جب نماز (تشہد) میں بیٹھیں"
                        },
                        "language": {
                                "English": {
                                        "meaning": "All greetings of humility are for Allah, and all prayers and goodness. Peace be upon you, O Prophet, and the mercy of Allah and His blessings. Peace be upon us and upon the righteous slaves of Allah. I bear witness that there is none worthy of worship but Allah, and I bear witness that Muhammad is His slave and His Messenger."
                                },
                                "Tamil": {
                                        "meaning": "மனத்தாழ்மையின் அனைத்து வாழ்த்துக்கள் மற்றும் அனைத்து தோலுகை மற்றும் நன்மை அல்லாஹ்வுக்கானது. நபியே! அல்லாஹ்வைத் தவிர வேறு எவரும் வணக்கத்திற்கு தகுதியற்றவர் என்பதற்கு நான் சாட்சியம் அளிக்கிறேன், முஹம்மது அவருடைய அடிமை மற்றும் அவரது தூதர் என்பதற்கு நான் சாட்சி கூறுகிறேன்."
                                },
                                "Urdu": {
                                        "meaning": "عاجزی کے تمام سلام اللہ کے لئے ہیں ، اور تمام دعائیں اور نیکی ہے۔ اے نبی کریم صلی اللہ علیہ وآلہ وسلم ، اور اللہ کی رحمت اور اس کی برکات۔ سلام ہو ہم پر اور اللہ کے نیک بندوں پر۔ میں گواہی دیتا ہوں کہ اللہ کے سوا عبادت کے لائق کوئی نہیں ، اور میں گواہی دیتا ہوں کہ محمد اس کا غلام اور اس کا رسول ہے۔"
                                }
                        }
                },
                {
                        "title": "After Tashahhud ",
                        "arabic": "اللَّهُمَّ إِنِّي أَعُوذُ بِكَ مِنْ عَذَابِ الْقَبْرِ، وَأَعُوذُ بِكَ مِنْ فِتْنَةِ الْمَسِيحِ الدَّجَّالِ، وَأَعُوذُ بِكَ مِنْ فِتْنَةِ الْمَحْيَا وَالْمَمَاتِ. اللَّهُمَّ إِنِّي أَعُوذُ بِكَ مِنْ الْمَأْثَمِ وَالْمَغْرَمِ",
                        "english": "Allaahumma 'innee 'a'oothu bika min 'athaabil-qabri, wa 'a'oothu bika min fitnatil-maseehid-dajjaali, wa 'a'oothu bika min fitnatil-mahyaa walmamaati. Allaahumma 'innee 'a'oothu bika minal-ma'thami walmaghrami",
                        "titleName": {
                                "Tamil": "தாஷாஹூத் பிறகு",
                                "English": "After Tashahhud",
                                "Urdu": "تشہد کے بعد"
                        },
                        "language": {
                                "English": {
                                        "meaning": "O Allah, I seek refuge in You from the punishment of the grave, and I seek refuge in You from the trial of the False Messiah, and I seek refuge in You from the trials of life and death. O Allah, I seek refuge in You from sin and from debt."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வே, கப்ர் தண்டனையிலிருந்து நான் உன்னிடம் அடைக்கலம் தேடுகிறேன், பொய்யான மேசியாவின் விசாரணையிலிருந்து நான் உன்னிடம் அடைக்கலம் தேடுகிறேன், வாழ்க்கை மற்றும் மரணத்தின் சோதனைகளிலிருந்து உன்னிடம் அடைக்கலம் தேடுகிறேன். அல்லாஹ்வே, நான் பாவத்திலிருந்தும் கடனிலிருந்தும் உன்னிடம் அடைக்கலம் தேடுகிறேன்."
                                },
                                "Urdu": {
                                        "meaning": "اے اللہ ، میں قبر کے عذاب سے تیری پناہ مانگتا ہوں ، اور میں جھوٹے مسیحا کے امتحان سے تیری پناہ مانگتا ہوں ، اور زندگی اور موت کی آزمائشوں سے تیری پناہ مانگتا ہوں۔ اے اللہ میں گناہ اور قرض سے تیری پناہ مانگتا ہوں۔"
                                }
                        }
                },
                {
                        "tittle": "Dua-e -Qunoot",
                        "arabic": "اَللَّهُمَّ إنا نَسْتَعِينُكَ وَنَسْتَغْفِرُكَ وَنُؤْمِنُ بِكَ وَنَتَوَكَّلُ عَلَيْكَ وَنُثْنِئْ عَلَيْكَ الخَيْرَ وَنَشْكُرُكَ وَلَا نَكْفُرُكَ وَنَخْلَعُ وَنَتْرُكُ مَنْ ئَّفْجُرُكَ اَللَّهُمَّ إِيَّاكَ نَعْبُدُ وَلَكَ نُصَلِّئ وَنَسْجُدُ وَإِلَيْكَ نَسْعأئ وَنَحْفِدُ وَنَرْجُو رَحْمَتَكَ وَنَخْشآئ عَذَابَكَ إِنَّ عَذَابَكَ بِالكُفَّارِ مُلْحَقٌ",
                        "english": "Allah humma inna nasta-eenoka wa nastaghfiruka wa nu'minu bika wa natawakkalu alaika wa nusni alaikal khair, wa nashkuruka wala nakfuruka wa nakhla-oo wa natruku mai yafjuruka, Allah humma iyyaka na'budu wa laka nusalli wa nasjud wa ilaika nas aaa wa nahfizu wa narju rahma taka wa nakhshaa azaabaka inna azaabaka bil kuffari mulhik",
                        "titleDua": {
                                "Tamil": "துவா-இ-குனூட்",
                                "English": "Dua-e -Qunoot",
                                "Urdu": "دعا-قنوت"
                        },
                        "titleName": {
                                "Tamil": "துவா-இ-குனூட்",
                                "English": "Dua-e -Qunoot",
                                "Urdu": "دعا-قنوت"
                        },
                        "language": {
                                "English": {
                                        "meaning": "O Allah! We implore You for help and beg forgiveness of You and believe in You and rely on You and extol You and we are thankful to You and are not ungrateful to You and we alienate and forsake those who disobey You. O Allah! You alone do we worship and for You do we pray and prostrate and we betake to please You and present ourselves for the service in Your cause and we hope for Your mercy and fear Your chastisement. Undoubtedly, Your torment is going to overtake infidels O Allah!"
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வே! உதவிக்காக நாங்கள் உங்களைக் கோருகிறோம், உன்னிடம் மன்னிப்புக் கோருகிறோம், உன்னை நம்புகிறோம், உன்னை நம்புகிறோம், உன்னைப் புகழ்ந்து பேசுகிறோம், நாங்கள் உங்களுக்கு நன்றி செலுத்துகிறோம், உங்களுக்கு நன்றியற்றவர்களாக இருக்கிறோம், உங்களுக்கு கீழ்ப்படியாதவர்களை நாங்கள் அந்நியப்படுத்துகிறோம், கைவிடுகிறோம். அல்லாஹ்வே! உங்களை மட்டுமே நாங்கள் வணங்குகிறோம், உங்களுக்காக நாங்கள் இபாதத் செய்கிறோம், வணங்குகிறோம், உங்களைப் பிரியப்படுத்தவும், உமது நோக்கத்திற்காக சேவைக்காக எங்களை முன்வைக்கவும் நாங்கள் துடிக்கிறோம், உங்கள் கருணைக்காக நாங்கள் நம்புகிறோம், உங்கள் தண்டனைக்கு அஞ்சுகிறோம். சந்தேகத்திற்கு இடமின்றி, உங்கள் வேதனை அல்லாஹ்வை மீறுபவர்களை முறியடிக்கப் போகிறது!"
                                },
                                "Urdu": {
                                        "meaning": "اے اللہ! ہم آپ سے مدد کے لئے التجا کرتے ہیں اور آپ سے معافی مانگتے ہیں اور آپ پر بھروسہ کرتے ہیں اور آپ پر بھروسہ کرتے ہیں اور آپ کی مدد کرتے ہیں اور ہم آپ کے شکر گزار ہیں اور آپ کے ناشکرا نہیں ہیں اور ہم آپ کو انکار کرنے والوں سے الگ اور ترک کرتے ہیں۔ اے اللہ! ہم ہی آپ کی عبادت کرتے ہیں اور آپ کے لئے ہم نماز پڑھتے ہیں اور سجدہ کرتے ہیں اور ہم آپ کو خوش کرنے اور اپنے مقصد کے لئے خدمت کے ل present پیش کرتے ہیں اور ہم آپ کی رحمت کی امید کرتے ہیں اور آپ کے عذاب سے ڈرتے ہیں۔ بلاشبہ ، آپ کا عذاب کافروں پر قابو پانے والا ہے اے اللہ!"
                                }
                        }
                }
        ],
        "Ramadan": [
                {
                        "icon": ramandan,
                        "title": "Upon sighting of the crescent moon ",
                        "arabic": "اللهُ أَكْـبَر، اللّهُمَّ أَهِلَّـهُ عَلَيْـنا بِالأمْـنِ وَالإيمـان، والسَّلامَـةِ والإسْلامِ، وَالتَّـوْفيـقِ لِما تُحِـبُّ رَبُّنـا وَتَـرْضَـى، رَبُّنـا وَرَبُّكَ اللهُ",
                        "english": "Allaahu 'Akbar, Allaahumma 'ahillahu 'alayna bil'amni wal'eemaani, wassalaamati wal-'Islaami, wattawfeeqi limaa tuhibbu Rabbanaa wa tardhaa, Rabbunaa wa Rabbukallaahu.",
                        "titleDua": {
                                "Tamil": "ரமலான்",
                                "English": "Ramadan",
                                "Urdu": "رمضان"
                        },
                        "titleName": {
                                "Tamil": "பிறை நிலவைப் பார்த்தவுடன்",
                                "English": "Upon sighting of the crescent moon",
                                "Urdu": "ہلال چاند دیکھنے کے بعد"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Allah is the Most Great. O Allah, bring us the new moon with security and Faith, with peace and in Islam, and in harmony with what Ya Allah loves and what pleases Him. Ya Allah and your Lord is Allah."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ் மிகப் பெரியவன். அல்லாஹ்வே, ரம்ஜான் பிறை பாதுகாப்பையும் நம்பிக்கையுடனும், அமைதியுடனும் இஸ்லாத்துடனும் கொண்டு வாருங்கள். என் அல்லாஹ் மற்றும் உங்கள் இறைவன் அல்லாஹ்."
                                },
                                "Urdu": {
                                        "meaning": "اللہ سب سے بڑا ہے۔ اے اللہ ، ہمیں نیا چاند سلامتی اور ایمان کے ساتھ ، سلامتی اور اسلام کے ساتھ ، اور ہمارا رب جو اس سے محبت کرتا ہے اور جو اس سے راضی ہوتا ہے اس کے مطابق بنائے۔ ہمارا رب اور تمہارا رب اللہ ہے۔"
                                }
                        }
                },
                {
                        "title": "Dua at the Beginning of the Fast",
                        "arabic": "نـَوَيْتُ صَوْمَ غـَدٍ عَـنْ ا َدَاءِ فـَرْضِ شـَهْرِ رَمـَضَانَ هـَذِهِ السَّـنـَةِ لِلـّهِ تـَعَالىَ",
                        "english": "Nawaitu sauma ghadin anadai fardu shahri ramadhana hazihissanati lillahitaala",
                        "titleName": {
                                "Tamil": "நோன்பின் தொடக்கத்தில் துவா",
                                "English": "Dua at the Beginning of the Fast",
                                "Urdu": "روزہ کے آغاز میں دعا"
                        },
                        "language": {
                                "English": {
                                        "meaning": "I intend to do obligatory fast tomorrow in the month of Ramadan this year because of Allah"
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வுக்காக இந்த ஆண்டு ரமலான் மாதத்தில் நாளை கட்டாய நோம்பு வைத்திருக்க விரும்புகிறேன்"
                                },
                                "Urdu": {
                                        "meaning": "میں اللہ کی وجہ سے اس سال رمضان کے مہینے میں کل روزہ رکھنا چاہتا ہوں"
                                }
                        }
                },
                {
                        "title": "Dua upon breaking the fast",
                        "arabic": " اللَّهُمَّ اِنِّى لَكَ صُمْتُ وَبِكَ امنْتُ وَعَليْكَ تَوَكّلتُ وَ عَلى رِزْقِكَ اَفْطَرْتُ",
                        "english": "Allahumma inni laka sumtu wa bika aamantu wa alayka tawakkaltu wa ala rizq-ika-aftartu",
                        "titleName": {
                                "Tamil": "நோன்பை முறித்தவுடன் துவா",
                                "English": "Dua upon breaking the fast",
                                "Urdu": "نماز افطار کرنے پر دعا"
                        },
                        "language": {
                                "English": {
                                        "meaning": "O Allah! I fasted for You and I believe in You and I put my trust in You and I break my fast with Your sustenance"
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வே! நான் உங்களுக்காக நோம்பு இருந்தேன், நான் உன்னை நம்புகிறேன், நான் உன்னை நம்புகிறேன், உன்னுடைய வாழ்வாதாரத்துடன் என் நோம்பு முறித்துக் கொள்கிறேன்"
                                },
                                "Urdu": {
                                        "meaning": "اے اللہ! میں نے آپ کے لئے روزہ رکھا تھا اور میں نے آپ پر بھروسہ کیا تھا اور میں نے آپ پر بھروسہ کیا تھا اور میں نے آپ کے رزق سے روزہ توڑا ہے"
                                }
                        }
                },
                {
                        "title": "Dua to say when anticipating the Night of Power",
                        "arabic": "اللَّهُمَّ إِنَّكَ عُفُوٌّ تُحِبُّ الْعَفْوَ فَاعْفُ عَنِّي",
                        "english": "Allaahumma Innaka ‛afu-wun tuḥibul ‛afwa fa‛afu ‛anni",
                        "titleName": {
                                "Tamil": "லைலாத்துல் காத்ர் இரவில் சொல்ல துவா",
                                "English": "Dua to say when anticipating the Night of Power",
                                "Urdu": "دعا کی رات کا انتظار کرتے وقت کہنا"
                        },
                        "language": {
                                "English": {
                                        "meaning": "O Allah, You are pardoning and You love to pardon, so pardon me."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வே, நீ மன்னிக்கிறாய், மன்னிப்பதை விரும்புகிறாய், எனவே என்னை மன்னித்துவிடு."
                                },
                                "Urdu": {
                                        "meaning": "اے اللہ ، تو معاف کر رہا ہے اور آپ کو معاف کرنا پسند ہے ، تو مجھے معاف کردے۔"
                                }
                        }
                }
        ],
        "Hajj & Umrah": [
                {
                        "icon": haaj,
                        "title": "Talbiyah",
                        "arabic": "لَبَّيْكَ اللَّهُمَّ لَبَّيْكَ، لَبَّيْكَ لَا شَرِيكَ لَكَ لَبَّيْكَ، انَّالْحَمْدَ، وَالنِّعْمَةَ، لَكَ وَالْمُلْكَ، لا شَرِيكَ لَكَ",
                        "english": "Labbayk Allaahumma labbayk, labbayk laa shareeka laka labbayk, 'innal-hamda, wanni'mata, laka walmulk, laa shareeka laka.",
                        "titleDua": {
                                "Tamil": "ஹஜ் & உம்ரா",
                                "English": "Hajj & Umrah",
                                "Urdu": "حج / عمرہ"
                        },
                        "titleName": {
                                "Tamil": "தல்பியா",
                                "English": "Talbiyah",
                                "Urdu": "تلبیہ"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Ever at Your service, O Allah, every at Your service. Ever at Your Service, You have no partner, ever at Your service. Verily all praise, blessings and dominions are Yours. You have no partner"
                                },
                                "Tamil": {
                                        "meaning": "உங்கள் சேவையில் எப்போதும், உங்களைத் தவிர வேறு இறைவன் இல்லை. நிச்சயமாக எல்லா புகழும், ரஹ்மத்தும் ஆதிக்கங்களும் உங்களுடையவை. உங்களுக்கு பங்குதாரர் இல்லை"
                                },
                                "Urdu": {
                                        "meaning": "اے اللہ ہر ایک تیرے خدمت میں۔ کبھی آپ کی خدمت میں ، آپ کا کوئی شریک نہیں ، کبھی بھی آپ کی خدمت میں۔ بے شک تمام تعریفیں ، برکتیں اور تسلط آپ کے ہیں۔ آپ کا کوئی شریک نہیں ہے"
                                }
                        }
                },
                {
                        "title": "Takbeer when passing the black stone ",
                        "arabic": "اللهُ أكْبَر",
                        "english": "Allaahu 'Akbar",
                        "titleName": {
                                "Tamil": "கருங்கல்லைக் கடக்கும்போது தக்பீர்",
                                "English": "Takbeer when passing the black stone ",
                                "Urdu": "سیاہ پتھر گزرتے وقت تکبیر"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Allah is the Most Great!"
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ் மிகப் பெரியவன்!"
                                },
                                "Urdu": {
                                        "meaning": "اللہ سبحانہ وتعالی ہے!"
                                }
                        }
                },
                {
                        "title": "Upon reaching the Yemeni corner during Tawaf ",
                        "arabic": "رَبَّنآ ءَاتِنَا فِى اْلدُّنْيَا حَسَنَةً وَ فى الاخِرَةِ حَسَنَةً وَ قِنَا عَذَابَ اْلنَّارِ",
                        "english": "Rabbana aatina fid dunniyya hasanatan wa fil akhirati hasanatan wa qina ‘adhaban nar",
                        "titleName": {
                                "Tamil": "தவாப்பின் போது யேமன் மூலையை அடைந்ததும்",
                                "English": "Upon reaching the Yemeni corner during Tawaf",
                                "Urdu": "طواف کے دوران یمنی کونے پہنچنے پر"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Ya Allah! Grant us good in this world and good in the hereafter, and save us from the punishment of the Fire"
                                },
                                "Tamil": {
                                        "meaning": "யா அல்லாஹ்! இந்த உலகில் எங்களுக்கு நல்லதையும், மறுமையில் நல்லதையும் கொடுங்கள், மேலும் நெருப்பின் தண்டனையிலிருந்து எங்களைக் காப்பாற்றுங்கள்"
                                },
                                "Urdu": {
                                        "meaning": "ہمارے رب! ہمیں دنیا میں بھلائی اور آخرت میں بھلائی عطا فرما اور ہمیں دوزخ کے عذاب سے بچا"
                                }
                        }
                },
                {
                        "title": "When at Mount Safa and Mount Marwah",
                        "arabic": "أَبْدَأُ بِمَا بَدَأَ اللهُ بِهِ. لَا إِلهَ إِلَّا اللهُ وَ اللهُ أَكْـبَر لَا إِلهَ إِلَّا اللهُ وَحْدَهُ لَا شَرِيكَ لَهُ، لَهُ المُلْكُ وَلَهُ الحَمْدُ وهُوَ عَلى كُلِّ شَيءٍ قَديرٌ، لَا إِلَهَ إِلَّا اللهُ وَحْدَهُ أَنْجَزَ وَعْدَهُ، وَنَصَرَ عَبْدَهُ وَهَزَمَ الأَحْزَابَ وَحْدَهُ",
                        "english": "Abda’u bi maa bada’-allaahu bih allaahu akbar, allaahu akbar, allaahu akbar laa ilaaha ill-allaahu waḥdahu laa shareeka lah, lahul-mulku wa lahul-ḥamdu wa huwa ‛alaa kulli shay’in qadeer, laa ilaaha ill-allaahu waḥdahu, anjaza wa‛dahu, wa naṣara ‛abdahu, wa hazam-al-’aḥzaaba waḥdah",
                        "titleName": {
                                "Tamil": "சஃபா மற்றும் மார்வாவில் இருக்கும்போது",
                                "English": "When at Mount Safa and Mount Marwah",
                                "Urdu": "جب صفا اور مروہ میں"
                        },
                        "language": {
                                "English": {
                                        "meaning": "I begin with what Allah began with.Allah is the greatest, Allah is the greatest, Allah is the greatest. None has the right to be worshipped except Allah, alone, without partner. To Him belongs all sovereignty and praise and He is over all things omnipotent. None has the right to be worshipped except Allah alone. He fulfilled His promise, aided His Servant and single-handedly defeated the allies."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ் மிகப் பெரியவன், அல்லாஹ் மிகப் பெரியவன், அல்லாஹ் மிகப் பெரியவன். யாரும் பங்குதாரரும் இல்லாமல், அல்லாஹ், தனியாக ஒருவனை மட்டும் வணங்க வேண்டும் உரிமை உண்டு. எல்லா இறையாண்மையும் புகழும் அவருக்கே உரியது, அவர் எல்லாவற்றிற்கும் மேலானவர். அல்லாஹ்வைத் தவிர வேறு யாருக்கும் வழிபட உரிமை இல்லை. அவர் தனது வாக்குறுதியை நிறைவேற்றினார், அவருடைய ஊழியருக்கு உதவினார், கூட்டாளிகளைத் தோற்கடித்தார்."
                                },
                                "Urdu": {
                                        "meaning": "میں اس سے شروع کرتا ہوں جس کی ابتدا اللہ نے کی تھی۔ اللہ سب سے بڑا ہے ، اللہ سب سے بڑا ہے ، اللہ سب سے بڑا ہے۔ اللہ کے سوا کسی کو شریک نہیں بنا ، کسی کی عبادت کا حق نہیں ہے۔ اسی کی ساری بادشاہت و حمد ہے اور وہ ہر چیز پر قادر ہے۔ اللہ کے سوا کسی کی عبادت کا حق نہیں ہے۔ اس نے اپنا وعدہ پورا کیا ، اپنے خادم کی مدد کی اور اتحادیوں کو اکیلے ہاتھ سے شکست دی۔"
                                }
                        }
                },
                {
                        "title": "For reciting at Al-Mash'ar Al-Haraam",
                        "arabic": "أَللّهُ أَكْبَرُ أَللّهُ أَحَدٌ لاَإِلَهَ إِلاَّ اللهُ",
                        "english": "Allaahu 'Akbar Allaahu 'Ahad Laa 'ilaaha 'illallaah",
                        "titleName": {
                                "Tamil": "அல்-மஷார் அல்-ஹராமில் பாராயணம் செய்ய",
                                "English": "For reciting at Al-Mash'ar Al-Haraam",
                                "Urdu": "المشر'حرام میں تلاوت کے ل."
                        },
                        "language": {
                                "English": {
                                        "meaning": "Allah is the Most Great. Allah is One. There is none worthy of worship but Allah."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ் மிகப் பெரியவன். அல்லாஹ் ஒருவன். வணக்கத்திற்கு தகுதியானவர் அல்லாஹ்வைத் தவிர வேறு யாரும் இல்லை."
                                },
                                "Urdu": {
                                        "meaning": "اللہ سب سے بڑا ہے۔ اللہ ایک ہے۔ اللہ کے سوا کوئی لائق عبادت نہیں ہے۔"
                                }
                        }
                },
                {
                        "title": "When throwing stones at Jamaraat",
                        "arabic": "اللهُ أكْبَر",
                        "english": "Allaahu 'Akbar",
                        "titleName": {
                                "Tamil": "ஜமராத் மீது கற்களை வீசும்போது",
                                "English": "When throwing stones at Jamaraat",
                                "Urdu": "جمارات پر پتھر پھینکتے وقت"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Allah is the Most Great!"
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ் மிகப் பெரியவன்!"
                                },
                                "Urdu": {
                                        "meaning": "اللہ سبحانہ وتعالی ہے!"
                                }
                        }
                },
                {
                        "title": "Dua on the day of Arafah",
                        "arabic": "لَا إِلَهَ إِلَّا اللهُ ، وَحْدَهُ لَا شَرِيكَ لَهُ ، لَهُ الْمُلْكُ وَلَهُ الْحَمْدُ ، وهُوَ عَلَى كُلِّ شَيْءٍ قَدِيرٌ",
                        "english": "laa ilaaha ill-allaahu, waḥdahu laa shareeka lah, lahul-mulku wa lahul-ḥamdu, wa huwa ‛alaa kulli shay’in qadeer",
                        "titleName": {
                                "Tamil": "அரஃபா நாளில் துவா",
                                "English": "Dua on the day of Arafah",
                                "Urdu": "دعائے عرفہ کے دن"
                        },
                        "language": {
                                "English": {
                                        "meaning": "None has the right to be worshipped except Allah, alone, without partner. To Him belongs sovereignty and all praise and He is over all things omnipotent."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வைத் தவிர, தனியாக, கூட்டாளர் இல்லாமல் வணங்க யாருக்கும் உரிமை இல்லை. அவருக்கே இறையாண்மையும் எல்லா புகழும் உண்டு, அவர் எல்லாவற்றிற்கும் மேலானவர்."
                                },
                                "Urdu": {
                                        "meaning": "اللہ کے سوا کسی کی شریک نہیں ہوسکتی ، اس کی عبادت کا کوئی حق نہیں ہے۔ اسی کی حاکمیت ہے اور تمام تعریف ہے اور وہ ہر چیز پر قادر ہے۔"
                                }
                        }
                },
                {
                        "title": "Dua when slaughtering or offering a sacrifice",
                        "arabic": "بِسْمِ اللهِ وَاللهُ أَكْبَرُ ، اللَّهُمَّ هَذَا مِنْكَ وَلَكَ",
                        "english": "bismillaahi wallaahu akbar, allaahumma haa tha minka wa lak.",
                        "titleName": {
                                "Tamil": "குருபானி கொடுக்கும் போது துவா",
                                "English": "Dua when slaughtering or offering a sacrifice",
                                "Urdu": "دعا جب قربانی کرتے ہو"
                        },
                        "language": {
                                "English": {
                                        "meaning": "In the name of Allah, and Allah is the greatest. O Allah, (it is) from You and belongs to You."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வின் பெயரால், அல்லாஹ் மிகப் பெரியவன். அல்லாஹ்வே, அது உன்னிடமிருந்து வந்தது, உனக்கு சொந்தமானது."
                                },
                                "Urdu": {
                                        "meaning": "اللہ کے نام پر اور اللہ سب سے بڑا ہے۔ اے اللہ ، یہ تم سے ہے اور تمہارا ہے۔"
                                }
                        }
                }
        ],
        "Protection": [
                {
                        "icon": protection,
                        "title": "Dua seeking the protection of Allah for children",
                        "arabic": "أُعِيذُكَ بِكَلِمَاتِ اللهِ التَّامَّةِ مِنْ كُلِّ شَيْطَانٍ ، وَهَامَّةٍ ، وَمِنْ كُلِّ عَيْنٍ لَامَّةٍ",
                        "english": "u‛eedhuka bi kalimaat-illaahit-taammati min kulli shayṭaanin, wa haammatin, wa min kulli ‛aynin laammah",
                        "titleDua": {
                                "Tamil": "பாதுகாப்பு",
                                "English": "Protection",
                                "Urdu": "تحفظ"
                        },
                        "titleName": {
                                "Tamil": "குழந்தைகளுக்கு அல்லாஹ்வின் பாதுகாப்பை நாடும் துவா",
                                "English": "Dua seeking the protection of Allah for children",
                                "Urdu": "دعا ہے بچوں کے لئے اللہ کی حفاظت کے لئے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "I commend you to the protection of Allah’s perfect words from every devil, vermin, and every evil eye."
                                },
                                "Tamil": {
                                        "meaning": "ஒவ்வொரு ஷைத்தான், பூச்சிகள் மற்றும் ஒவ்வொரு தீய கண்ணிலிருந்தும் அல்லாஹ்வின் பாதுகாப்பை நான் பாராட்டுகிறேன். "
                                },
                                "Urdu": {
                                        "meaning": "میں آپ کو ہر شیطان ، کیڑے ، اور ہر بری نظر سے اللہ کے کامل الفاظ کے تحفظ کی تعریف کرتا ہوں۔"
                                }
                        }
                },
                {
                        "title": "Dua to seek protection of Allah from committing shirk",
                        "arabic": "اللَّهُمَّ إِنِّي أَعُوذُ بِكَ أَنْ أُشْرِكَ بِكَ وَأَنَا أَعْلَمُ ، وَأَسْتَغْفِرُكَ لِمَا لَا أَعْلَمُ",
                        "english": "allaahumma innee a‛oodhu bika an ushrika bika wa ana a‛lamu, wa astaghfiruka li maa laa a‛lam",
                        "titleName": {
                                "Tamil": "ஷிர்க் செய்வதிலிருந்து அல்லாஹ்வின் பாதுகாப்பைப் பெற துஆ",
                                "English": "Dua to seek protection of Allah from committing shirk",
                                "Urdu": "اللہ سے شرک کے ارتکاب کرنے سے بچنے کی دعا"
                        },
                        "language": {
                                "English": {
                                        "meaning": "O Allah, I seek refuge with You lest I should commit shirk with You knowingly and I seek Your forgiveness for what I do unknowingly."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வே, நான் உன்னுடன் தஞ்சம் அடைகிறேன், நான் தெரிந்தே உன்னுடன் ஷிர்க் செய்யக்கூடாது என்பதற்காகவும், நான் அறியாமல் செய்த காரியங்களுக்கு மன்னிப்புக் கோருகிறேன்."
                                },
                                "Urdu": {
                                        "meaning": "اے اللہ ، میں آپ سے پناہ مانگتا ہوں تاکہ ایسا نہ ہو کہ میں آپ کے ساتھ جان بوجھ کر شرک کروں اور میں اس کام کے لئے بخشش چاہتا ہوں جو میں نادانی سے کرتا ہوں۔"
                                }
                        }
                },
                {
                        "title": "For protection and help from Allah",
                        "arabic": "اللَّهُمَّ مُنْزِلَ اْلِكتَابِ ، سَرِيْعَ الْحِسَابِ ،اِهْزِمِ الإْحْزَابَ ،اللَّهُمَّ اِهْزِمْهُمْ وَزَلْزِلْهُمْ",
                        "english": "Allaahumma munzilal-kitaabi, saree'al-hisaabi, ihzimil-'ahzaaba, Allaahumma ihzimhum wa zalzilhum",
                        "titleName": {
                                "Tamil": "அல்லாஹ்விடமிருந்து பாதுகாப்பு மற்றும் உதவிக்காக துவா",
                                "English": " Dua For protection and help from Allah",
                                "Urdu": "اللہ کی حفاظت اور مدد کے لئے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Allah, Revealer of the Book, Swift to account, defeat the groups (of disbelievers). O Allah, defeat them and shake them."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ், குர்ஆனை வெளிப்படுத்துபவன், கணக்கிற்கு விரைவாக, காஃபிர்களின் குழுக்களை தோற்கடிக்கவும். "
                                },
                                "Urdu": {
                                        "meaning": "اللہ ، کتاب سنانے والا ، حساب کتاب کرنے والا ، گروہوں کو (کافروں کو) شکست دے۔ اے اللہ ان کو شکست دے اور ان کو ہلا دے۔"
                                }
                        }
                },
                {
                        "title": "For protection from ignorance ",
                        "arabic": "أَعُوذُ بِاللَّهِ أَنْ أَكُونَ مِنَ الْجَاهِلِينَ",
                        "english": "Aoothu billahi an akoona minal jahileen",
                        "titleName": {
                                "Tamil": "அறியாமையிலிருந்து பாதுகாப்புக்காக",
                                "English": "For protection from ignorance",
                                "Urdu": "جہالت سے بچانے کے لئے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "I seek refuge in Allah from being among the ignorant."
                                },
                                "Tamil": {
                                        "meaning": "நான் அறிவற்றவர்களிடையே இருப்பதிலிருந்து அல்லாஹ்விடம் அடைக்கலம் தேடுகிறேன்."
                                },
                                "Urdu": {
                                        "meaning": "میں جاہلوں میں شامل ہونے سے اللہ کی پناہ مانگتا ہوں۔"
                                }
                        }
                },
                {
                        "title": "For protection from oppressors",
                        "arabic": "رَبَّنَا أَخْرِجْنَا مِنْ هَٰذِهِ الْقَرْيَةِ الظَّالِمِ أَهْلُهَا وَاجْعَلْ لَنَا مِنْ لَدُنْكَ وَلِيًّا وَاجْعَلْ لَنَا مِنْ لَدُنْكَ نَصِيرًا",
                        "english": "rabbana akhrijna min hathihialqaryati aththalimi ahluhawajAAal lana min ladunka waliyyan wajAAallana min ladunka naseera",
                        "titleName": {
                                "Tamil": "அடக்குமுறையாளர்களிடமிருந்து பாதுகாப்புக்காக",
                                "English": "For protection from oppressors",
                                "Urdu": "ظالموں سے تحفظ کے ل."
                        },
                        "language": {
                                "English": {
                                        "meaning": "Ya Allah! Rescue us from this town whose people are oppressors; and raise for us from You one who will protect, and raise for us from You one who will help."
                                },
                                "Tamil": {
                                        "meaning": "யா அல்லாஹ்!  மக்கள் அடக்குமுறையாளர்களாக இருக்கும் இந்த ஊரிலிருந்து எங்களை மீட்டுங்கள்; அவர்களிடமிருந்து எங்களை காப்பாற்றுங்கள், உங்களிடமிருந்து எங்களுக்கு உதவுங்கள்."
                                },
                                "Urdu": {
                                        "meaning": "ہمارے رب! ہمیں اس بستی سے بچا جس کے لوگ ظالم ہیں۔ اور ہمارے لئے اپنے سے ایک بچاؤ جو حفاظت کرے گا ، اور اپنے لئے ہم سے ایک پیدا کرے گا جو مدد کرے گا۔"
                                }
                        }
                },
                {
                        "title": "For protection from the wrongdoers",
                        "arabic": "عَلَى اللَّهِ تَوَكَّلْنَا رَبَّنَا لَا تَجْعَلْنَا فِتْنَةً لِلْقَوْمِ الظَّالِمِينَ وَنَجِّنَا بِرَحْمَتِكَ مِنَ الْقَوْمِ الْكَافِرِينَ",
                        "english": "Alal Allahi thawakkalna rabbana la taj'alna fitnatal lil-qawmidh-Dhalimeen. Wa najjina bi-Rahmatika minal qawmil kafireen.",
                        "titleName": {
                                "Tamil": "தவறு செய்பவர்களிடமிருந்து பாதுகாப்புக்காக",
                                "English": "For protection from the wrongdoers",
                                "Urdu": "ظالموں سے تحفظ کے ل."
                        },
                        "language": {
                                "English": {
                                        "meaning": "Upon Allah do we rely. Ya Allah, make us not [objects of] trial for the wrongdoing people. And save us by Your mercy from the disbelieving people."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வின் மீது நாம் தங்கியிருக்கிறோம். யா அல்லாஹ், தவறு செய்தவர்களுக்காக எங்களை சோதனையிட வேண்டாம். அவிசுவாசிகளிடமிருந்து எங்களைக் காப்பாற்றுங்கள்."
                                },
                                "Urdu": {
                                        "meaning": "ہم اللہ پر بھروسہ کرتے ہیں۔ اے ہمارے پروردگار ، ہمیں ظالم لوگوں کے لئے آزمائش کا سامان نہ بنائے۔ اور ہمیں اپنی رحمت سے کافر لوگوں سے بچا۔"
                                }
                        }
                },
                {
                        "title": "Protection from foolishness",
                        "arabic": "الَّهُمَّ إِنِّي أَعُوذُ بِكَ أَنْ أَضِلَّ، أّوْ أُضَلَّ، أَوْ أَزِلَّ، أَوْ أُزَلَّ، أَوْ أَظْلِمَ، أَوْ أُظْلَمَ، أَوْ أَجْهَلَ، أَوْ يُجْهَلَ عَلَيَّ",
                        "english": "Allaahumma 'innee 'a'oothu bika 'an 'adhilla, 'aw 'udhalla, 'aw 'azilla, 'aw 'uzalla, 'aw 'adhlima, 'aw 'udhlama, 'aw 'ajhala 'aw yujhala 'alayya",
                        "titleName": {
                                "Tamil": "முட்டாள்தனத்திலிருந்து பாதுகாப்பு",
                                "English": "Protection from foolishness",
                                "Urdu": "حماقتوں سے تحفظ"
                        },
                        "language": {
                                "English": {
                                        "meaning": "O Allah, I seek refuge in You lest I misguide others , or I am misguided by others , lest I cause others to err or I am caused to err , lest I abuse others or be abused, and lest I behave foolishly or meet with the foolishness of others."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வே, நான் மற்றவர்களை தவறாக வழிநடத்தக்கூடாது என்பதற்காகவோ அல்லது மற்றவர்களால் தவறாக வழிநடத்தப்படாமலோ,துஷ்பிரயோகம் செய்ய கூடாது என்பதற்காகவும், நான் முட்டாள்தனமாக நடந்து கொள்ளவோ ​​அல்லது சிந்திக்கவோ கூடாது என்பதற்காக நான் உன்னிடம் அடைக்கலம் தேடுகிறேன்."
                                },
                                "Urdu": {
                                        "meaning": "اے اللہ ، میں آپ سے پناہ مانگتا ہوں کہ ایسا نہ ہو کہ میں دوسروں کو گمراہ کردوں ، یا میں دوسروں کے ذریعہ گمراہ ہوں ، ایسا نہ ہو کہ میں دوسروں کو گمراہ کردوں یا میں غلطی کا باعث ہوں ، ایسا نہ ہو کہ میں د��سروں کو گالیاں دیتا ہوں یا زیادتی کرتا ہوں ، اور ایسا نہ ہو کہ میں احمقانہ سلوک کروں یا اس سے مل جاؤں۔ دوسروں کی بے وقوفی۔"
                                }
                        }
                },
                {
                        "title": "Seek protection from culprits",
                        "arabic": "قَالَ رَبِّ إِنِّي ظَلَمْتُ نَفْسِي فَاغْفِرْ لِي فَغَفَرَ لَهُ ۚ إِنَّهُ هُوَ الْغَفُورُ الرَّحِيمُ رَبِّ بِمَا أَنْعَمْتَ عَلَيَّ فَلَنْ أَكُونَ ظَهِيرًا لِّلْمُجْرِمِينَ رَبِّ نَجِّنِي مِنَ الْقَوْمِ الظَّالِمِينَ",
                        "english": "Qala Rabbi innee thalamtunafsee faghfir lee faghafara lahu innahu huwa alghafooruarraheem Rabbi bima anAAamtaAAalayya falan akoona thaheeran lilmujrimeen Rabbi najjinee mina alqawmi aththalimeen",
                        "titleName": {
                                "Tamil": "குற்றவாளிகளிடமிருந்து பாதுகாப்பு",
                                "English": " protection from culprits",
                                "Urdu": "مجرموں سے تحفظ"
                        },
                        "language": {
                                "English": {
                                        "meaning": "He (Musa) said, 'My Lord, indeed I have wronged myself, so forgive me,' and He forgave him. Indeed, He is the Forgiving, the Merciful. 'My Lord, for the favor You bestowed upon me, I will never be an assistant to the criminals. My Lord, save me from the wrongdoing people.'"
                                },
                                "Tamil": {
                                        "meaning": "மூசா, 'என் இறைவா, உண்மையில் நான் எனக்கு அநீதி இழைத்தேன், எனவே என்னை மன்னியுங்கள்' என்று சொன்னார், அல்லாஹ் அவரை மன்னித்தார். உண்மையில், அவர் மன்னிப்பவர், இரக்கமுள்ளவர். 'என் இரைவா, நீங்கள் எனக்கு அளித்த தயவுக்கு, நான் ஒருபோதும் குற்றவாளிகளுக்கு உதவியாளராக இருக்க மாட்டேன். என் இரைவா, தவறு செய்தவர்களிடமிருந்து என்னைக் காப்பாற்றுங்கள்.'"
                                },
                                "Urdu": {
                                        "meaning": "اس نے کہا کہ میرے پروردگار ، بیشک میں نے اپنے آپ پر ظلم کیا ہے تو مجھے معاف فرما اور اس نے اسے معاف کردیا۔ بےشک وہ بخشنے والا مہربان ہے 'اے میرے رب ، اس احسان کے لئے جو تو نے مجھے دیا ہے ، میں مجرموں کا کبھی مددگار نہیں بنوں گا ، اے میرے رب ، مجھے ظالم لوگوں سے بچا۔'"
                                }
                        }
                }
        ],
        "Akhirah": [
                {
                        "icon": akhirah,
                        "title": "For this world and the aakhira ",
                        "arabic": "رَبَّنَآ اٰتِنَا فِي الدُّنْيَا حَسَنَةً وَّفِي الْاٰخِرَةِ حَسَـنَةً وَّقِنَا عَذَابَ النَّارِ",
                        "english": "Rabbanaaa Aatinaa Fiddunyaa H’asanata Wa Fil Aakhirati H’asanata Wa Qinaa A’d’aaban Naar",
                        "titleDua": {
                                "Tamil": "ஆகிரா",
                                "English": "Akhirah",
                                "Urdu": "اکھیرہ"
                        },
                        "titleName": {
                                "Tamil": "இந்த உலகத்துக்கும் ஆகிராவுக்கும்",
                                "English": "For this world and the aakhira",
                                "Urdu": "اس دنیا اورآخیرہ کے لئے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Ya Allah! Give us in this world that which is good and in the Hereafter that which is good, and save us from the torment of the Fire!"
                                },
                                "Tamil": {
                                        "meaning": "யா அல்லாஹ்! இந்த உலகத்திலும், மறுமையிலும் நல்லதை எங்களுக்குக் கொடுங்கள், நெருப்பின் வேதனையிலிருந்து எங்களைக் காப்பாற்றுங்கள்!"
                                },
                                "Urdu": {
                                        "meaning": "ہمارے رب! ہمیں دنیا میں جو بھلائی ہے اور آخرت میں بھی جو بھلائی عطا فرما ، اور ہمیں دوزخ کے عذاب سے بچا!"
                                }
                        }
                },
                {
                        "title": "For Jannah ",
                        "arabic": "رَبَّنَا اصْرِفْ عَنَّا عَذَابَ جَهَنَّمَ ۖ إِنَّ عَذَابَهَا كَانَ غَرَامًا إِنَّهَا سَاءَتْ مُسْتَقَرًّا وَمُقَامًا",
                        "english": "Rabbanas-rif 'anna 'adhaba jahannama inna 'adhabaha kana gharama innaha sa'at musta-qarranw wa muqama",
                        "titleName": {
                                "Tamil": "ஜன்னாவுக்கு துவா",
                                "English": "For Jannah",
                                "Urdu": "جناح کے لئے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Ya Allah! Avert from us the Wrath of Hell, for its Wrath is indeed an affliction grievous,- Evil indeed is it as an abode, and as a place to rest in."
                                },
                                "Tamil": {
                                        "meaning": "யா அல்லாஹ்! நரகத்தின் கோபத்தை எங்களிடமிருந்து விலக்குங்கள், ஏனென்றால் அதன் கோபம் உண்மையில் ஒரு துன்பம், - தீமை உண்மையில் அது ஒரு தங்குமிடமாகவும், ஓய்வெடுக்க ஒரு இடமாகவும் இருக்கிறது."
                                },
                                "Urdu": {
                                        "meaning": "ہمارے رب! ہم سے جہنم کے غضب کو دور کرو ، کیونکہ اس کا غضب بے شک ایک تکلیف دہ ہے ، اور یہ ٹھکانا اور ٹھکانا ہے ،"
                                }
                        }
                },
                {
                        "title": "For Justice",
                        "arabic": "رَبَّنَا افْتَحْ بَيْنَنَا وَبَيْنَ قَوْمِنَا بِالْحَقِّ وَأَنتَ خَيْرُ الْفَاتِحِينَ",
                        "english": "Rabbanaf-tah baynana wa bayna qawmina bil haqqi wa anta Khayrul Fatiheen",
                        "titleName": {
                                "Tamil": "நீதிக்கான துவா",
                                "English": "For Justice",
                                "Urdu": "دعا برائے انصاف"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Ya Allah! Decide Thou between us and our people in truth, for Thou art the best to decide."
                                },
                                "Tamil": {
                                        "meaning": "யா அல்லாஹ்! எங்களுக்கும் எங்கள் மக்களுக்கும் இடையில் உண்மையாகத் தீர்மானியுங்கள், ஏனென்றால் நீங்களே தீர்மானிப்பதில் சிறந்தவர்."
                                },
                                "Urdu": {
                                        "meaning": "ہمارے رب! ہمارے اور اپنے لوگوں کے مابین سچائی سے فیصلہ کرو کیونکہ فیصلہ کرنے میں تو ہی بہترین ہے۔"
                                }
                        }
                }
        ],
        "Death": [
                {
                        "icon": death,
                        "title": "Dua when visiting the graves",
                        "arabic": "السَّلامُ عَلَيْكُمْ أَهْلَ الدِّيَارِ مِنَ الْمُؤْمِنِينَ وَالْمُسْلِمِينَ ، وَإِنَّا إِنْ شَاءَ اللهُ بِكُمْ لَلَاحِقُونَ ، نَسْأَلُ اللهَ لَنَا وَلَكُمُ الْعَافِيَةَ",
                        "english": "as-salaamu ‛alaykum ahl-ad-diyaari mi-nal-mu’mineena wal-muslimeena, wa in-naa in shaa’-allaahu la-laaḥiqoona, nas’al-ullaaha lanaa wa-lakumul-‛aafiyah",
                        "titleDua": {
                                "Tamil": "இறப்பு",
                                "English": "Death",
                                "Urdu": "موت"
                        },
                        "titleName": {
                                "Tamil": "கல்லறைகளுக்குச் செல்லும்போது துவா",
                                "English": "Dua when visiting the graves",
                                "Urdu": "دعا جب قبروں پر جاتے ہو"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Peace be upon you all, O inhabitants of the dwellings (i.e. the graves), amongst the believers and the Muslims. Indeed we are, Allah willing, soon to follow (to die also), we ask Allah for well-being for us and for you."
                                },
                                "Tamil": {
                                        "meaning": " விசுவாசிகள் மற்றும் முஸ்லிம்களிடையே, கப்ரில் வசிப்பவர்கள், உங்கள் அனைவருக்கும் அமைதி உண்டாகும். உண்மையில் நாங்கள் தயாராக இருக்கிறோம், எங்களுக்கும் நல்வாழ்வைக் கேட்கிறோம்."
                                },
                                "Urdu": {
                                        "meaning": "اے مکانوں کے رہنے والے (یعنی قبروں) آپ سب پر سلام ہو ، مومنین اور مسلمانوں میں۔ بے شک ہم اللہ کی رضا رکھتے ہیں ، جلد ہی اس کی پیروی کریں گے ، ہم اللہ سے ہمارے اور آپ کے لئے بھلائی کے لئے دعا گو ہیں۔"
                                }
                        }
                },
                {
                        "title": "Dua seeking good in this world and in the hereafter",
                        "arabic": "رَبَّنَآ ءَاتِنَا فِى ٱلدُّنْيَا حَسَنَةً وَفِى ٱلْأَخِرَةِ حَسَنَةً وَقِنَا عَذَابَ ٱلنَّارِ",
                        "english": "rabbanaaa aatinaa fid-dunyaa ḥasanatan wa fil-aakhirati ḥasanatan wa qinaa ‛adhaab-an-naar",
                        "titleName": {
                                "Tamil": "இந்த உலகத்திலும் மறுமையிலும் நல்லதைத் தேடும் துவா",
                                "English": "Dua seeking good in this world and in the hereafter",
                                "Urdu": "دنیا اور آخرت میں بھلائی کے خواہاں ہیں"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Ya Allah! Give us in this world that which is good and in the Hereafter that which is good, and save us from the torment of the Hell Fire!"
                                },
                                "Tamil": {
                                        "meaning": "யா அல்லாஹ்! இந்த உலகத்திலும், மறுமையிலும் நல்லதை எங்களுக்குக் கொடுங்கள், நரக நெருப்பின் வேதனையிலிருந்து எங்களைக் காப்பாற்றுங்கள்!"
                                },
                                "Urdu": {
                                        "meaning": "ہمارے رب! ہمیں اس دنیا میں جو بھلائی ہے اور آخرت میں بھی جو بھلائی عطا فرما اور ہمیں جہنم کے عذاب سے بچا!"
                                }
                        }
                },
                {
                        "title": "Dua of the sick person who is close to death",
                        "arabic": "لَا إِلَهَ إِلَّا اللهُ",
                        "english": "laa ilaaha ill-allaah",
                        "titleName": {
                                "Tamil": "மரணத்திற்கு நெருக்கமான நோய்வாய்ப்பட்ட நபரின் துவா",
                                "English": "Dua of the sick person who is close to death",
                                "Urdu": "بیمار شخص کی دعا جو موت کے قریب ہے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "None has the right to be worshipped except Allah."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வைத் தவிர வேறு யாருக்கும் வழிபட உரிமை இல்லை. "
                                },
                                "Urdu": {
                                        "meaning": "اللہ کے سوا کسی کی عبادت کا حق نہیں ہے۔"
                                }
                        }
                },
                {
                        "title": "For the deceased at the funeral prayer ",
                        "arabic": "اللهُـمِّ اغْفِـرْ لَهُ وَارْحَمْـه ، وَعافِهِ وَاعْفُ عَنْـه ، وَأَكْـرِمْ نُزُلَـه ، وَوَسِّـعْ مُدْخَـلَه ، وَاغْسِلْـهُ بِالْمـاءِ وَالثَّـلْجِ وَالْبَـرَدْ ، وَنَقِّـهِ مِنَ الْخطـايا كَما نَـقّيْتَ الـثَّوْبُ الأَبْيَـضُ مِنَ الدَّنَـسْ ، وَأَبْـدِلْهُ داراً خَـيْراً مِنْ دارِه ، وَأَهْلاً خَـيْراً مِنْ أَهْلِـه ، وَزَوْجَـاً خَـيْراً مِنْ زَوْجِه، وَأَدْخِـلْهُ الْجَـنَّة ، وَأَعِـذْهُ مِنْ عَذابِ القَـبْر وَعَذابِ النّـار",
                        "english": "Allaahum-maghfir lahu warhamhu, wa 'aafihi, wa'fu 'anhu, wa 'akrim nuzulahu, wa wassi' mudkhalahu, waghsilhu bilmaa'i waththalji walbaradi, wa naqqihi minal-khataayaa kamaa naqqaytath-thawbal-'abyadha minad-danasi, wa 'abdilhu daaran khayran min daarihi, wa 'ahlan khayran min 'ahlihi, wa zawjan khayran min zawjihi, wa 'adkhilhul-jannata, wa. 'a'ithhu min 'athaabil-qabri[wa 'athaabin-naar]",
                        "titleName": {
                                "Tamil": "இறுதி பிரார்த்தனையில் இறந்தவர்களுக்கு",
                                "English": "For the deceased at the funeral prayer ",
                                "Urdu": "نماز جنازہ میں مرحوم کے لئے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "O Allah, forgive him and have mercy on him and give him strength and pardon him. Be generous to him and cause his entrance to be wide and wash him with water and snow and hail. Cleanse him of his transgressions as white cloth is cleansed of stains. Give him an abode better than his home, and a family better than his family and a wife better than his wife. Take him into Paradise and protect him from the punishment of the grave [and from the punishment of Hell-fire]."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வே, அவனை மன்னித்து அவனிடம் கருணை காட்டி அவனுக்கு பலம் அளித்து மன்னிப்பாயாக.அவரிடம் கருணை காட்டுங்கள், அவரை தண்ணீர் மற்றும் பனி மற்றும் ஆலங்கட்டி மழை கழுவவும். வெள்ளைத் துணி கறைகளால் சுத்தப்படுத்தப்படுவதால் அவனது மீறல்களை அவனைச் சுத்தப்படுத்துங்கள். அவனுடைய வீட்டை விட சிறந்த தங்குமிடத்தையும், குடும்பத்தை விட சிறந்த குடும்பத்தையும், மனைவியை விட சிறந்த மனைவியையும் அவனுக்குக் கொடுங்கள். அவரை சொர்க்கத்திற்கு அழைத்துச் சென்று கப்ர் தண்டனையிலிருந்து [மற்றும் நரக நெருப்பின் தண்டனையிலிருந்து] பாதுகாக்கவும்."
                                },
                                "Urdu": {
                                        "meaning": "اے اللہ اسے معاف فرما اور اس پر رحم فرما اور اسے توفیق عطا فرما اور اسے معاف کردے۔ اس کے ساتھ سخاوت کرو اور اس کے داخلی راستوں کو چوڑا بنا دو اور اسے پانی اور برف اور اولے سے دھو لو۔ اس کو اس کے گناہوں سے پاک کرو کیونکہ سفید کپڑے داغوں سے پاک ہے۔ اسے اپنے گھر سے بہتر ٹھکانا اور ایک کنبہ اپنے کنبہ سے بہتر اور بیوی اپنی بیوی سے بہتر۔ اسے جنت میں لے جاؤ اور اسے قبر کے عذاب [اور جہنم کے عذاب سے] بچاؤ۔"
                                }
                        }
                },
                {
                        "title": "In the last moments of one's life",
                        "arabic": "أللّهُـمَّ اغْفِـرْ لي وَارْحَمْـني وَأَلْحِقْـني بِالرَّفـيقِ الأّعْلـى",
                        "english": "Allaahum-maghfir lee warhamnee wa 'alhiqnee bir-rafeeqil-'a'laa",
                        "titleName": {
                                "Tamil": "ஒருவரின் வாழ்க்கையின் கடைசி தருணங்களில்",
                                "English": "In the last moments of one's life",
                                "Urdu": "کسی کی زندگی کے آخری لمحات میں"
                        },
                        "language": {
                                "English": {
                                        "meaning": "O Allah, forgive me and have mercy upon me and join me with the highest companions (in Paradise)."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வே, என்னை மன்னித்து, என்னிடம் கருணை காட்டி, மிக உயர்ந்த தோழர்களுடன் (சொர்க்கத்தில்) என்னுடன் சேருங்கள்."
                                },
                                "Urdu": {
                                        "meaning": "اے اللہ مجھے معاف فرما اور مجھ پر رحم فرما اور مجھے سب سے بڑے ساتھیوں (جنت میں) کے ساتھ شامل کرو۔"
                                }
                        }
                },
                {
                        "title": "When offering condolence ",
                        "arabic": "إِنَّ للهِ ما أَخَذ، وَلَهُ ما أَعْـطـى، وَكُـلُّ شَيءٍ عِنْـدَهُ بِأَجَلٍ مُسَـمَّى.فَلْتَصْـبِر وَلْتَحْـتَسِب",
                        "english": "Inna lillaahi maa 'akhatha, wa lahu maa 'a'taa, wa kullu shay'in 'indahu bi'ajalin musamman. Faltasbir waltahtasib",
                        "titleName": {
                                "Tamil": "இரங்கல் தெரிவிக்கும்போது",
                                "English": "When offering condolence",
                                "Urdu": "تعزیت پیش کرتے وقت"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Surely, Allah takes what is His, and what He gives is His, and to all things He has appointed a time. So, have patience and be rewarded."
                                },
                                "Tamil": {
                                        "meaning": "நிச்சயமாக, அல்லாஹ் தன்னுடையதை எடுத்துக்கொள்கிறான், அவன் கொடுப்பது அவனுடையது, எல்லாவற்றிற்கும் அவன் ஒரு நேரத்தை நியமித்திருக்கிறான். எனவே, பொறுமையாக இருங்கள், வெகுமதி கிடைக்கும்."
                                },
                                "Urdu": {
                                        "meaning": "بیشک اللہ جو کچھ اس کا ہے وہ لیتا ہے ، اور جو کچھ دیتا ہے وہ اس کا ہے ، اور ہر چیز کے لئے جس نے ایک وقت مقرر کیا ہے۔ لہذا ، صبر کرو اور اجروثواب حاصل کرو۔"
                                }
                        }
                },
                {
                        "title": "When placing the deceased in the grave",
                        "arabic": "بِسْـمِ اللهِ وَعَلـى سُـنَّةِ رَسـولِ الله",
                        "english": "Bismillaahi wa 'alaa sunnati Rasoolillaahi",
                        "titleName": {
                                "Tamil": "இறந்தவரை கல்லறையில் வைக்கும் போது",
                                "English": "When placing the deceased in the grave",
                                "Urdu": "جب میت کو قبر میں رکھنا"
                        },
                        "language": {
                                "English": {
                                        "meaning": "With the Name of Allah and according to the Sunnah of the Messenger of Allah"
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வின் பெயருடன் மற்றும் அல்லாஹ்வின் தூதரின் சுன்னத்தின் படி"
                                },
                                "Urdu": {
                                        "meaning": "اللہ کے نام کے ساتھ اور اللہ کے رسول کی سنت کے مطابق"
                                }
                        }
                }
        ],
        "Knowledge": [
                {
                        "icon": knowledge,
                        "title": "Dua For Seeking knowledge",
                        "arabic": "رَبِّ اشْرَحْ لِي صَدْرِي وَيَسِّرْ لِي أَمْرِي وَاحْلُلْ عُقْدَةً مِّن لِّسَانِي يَفْقَهُوا قَوْلِي",
                        "english": "Rabbishrah lee sadree Wayassir lee amree Wahlul ‘uqdatan min lisanee Yafqahoo qawlee",
                        "titleDua": {
                                "Tamil": "அறிவு",
                                "English": "Knowledge",
                                "Urdu": "علم"
                        },
                        "titleName": {
                                "Tamil": "அறிவைத் தேடுவதற்கான துவா",
                                "English": "Dua For Seeking knowledge",
                                "Urdu": "دعا کے حصول کے لئے دعا"
                        },
                        "language": {
                                "English": {
                                        "meaning": "O my Sustainer! Open up my heart and make my task easy for me, and loosen the knot from my tongue so that they might fully understand my speech."
                                },
                                "Tamil": {
                                        "meaning": "என் பராமரிப்பாளரே! என் இதயத்தைத் திறந்து, என் பணியை எனக்கு எளிதாக்குங்கள், என் பேச்சை அவர்கள் முழுமையாகப் புரிந்துகொள்ளும்படி என் நாக்கிலிருந்து முடிச்சைத் தளர்த்தவும்."
                                },
                                "Urdu": {
                                        "meaning": "اے میرے پالنے والے! میرا دل کھول کر میرے کام کو میرے لئے آسان بنادیں ، اور میری زبان سے گرہ کو ڈھیلا کریں تاکہ وہ میری تقریر کو پوری طرح سمجھ سکیں۔"
                                }
                        }
                },
                {
                        "title": "Dua for Increase in knowledge ",
                        "arabic": "اللَّهُمَّ إِنِّي أَسْأَلُكَ عِلْماً نَافِعاً، وَرِزْقاً طَيِّباً، وَعَمَلاً مُتَقَبَّلاً",
                        "english": "Allaahumma 'innee 'as'aluka 'ilman naafi'an, wa rizqan tayyiban, wa 'amalan mutaqabbalan",
                        "titleName": {
                                "Tamil": "அறிவின் அதிகரிப்புக்கான துவா",
                                "English": "Dua for Increase in knowledge",
                                "Urdu": "علم میں اضافے کے لئے دعا"
                        },
                        "language": {
                                "English": {
                                        "meaning": "O Allah, I ask You for knowledge that is of benefit , a good provision , and deeds that will be accepted."
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வே, நன்மை பயக்கும் அறிவு, ஒரு நல்ல ஏற்பாடு மற்றும் ஏற்றுக்கொள்ளப்படும் செயல்களை நான் உங்களிடம் கேட்கிறேன்."
                                },
                                "Urdu": {
                                        "meaning": "اے اللہ ، میں آپ سے ایک ایسے علم کے ل  دعا گو ہوں جو فائدہ مند ہو ، ایک اچھی رزق ، اور اعمال جو قبول ہوں گے۔"
                                }
                        }
                },
                {
                        "title": "Dua Before Studying",
                        "arabic": "للَّهُمَّ اَكْرِمْنْيْ بِنُوْرِ الْفَهْمِ وَ خَرَّجَنِيْ مِنْ ظُلُمَاتِ الْوَهْمِ وَ افْتَحْ عَلَيْنَا اَبْوَابَ عِلْمَكَ، وَ انْشُرْعَلَيْنَا خُزَّانَ مَعْرِفَتِكَ يَا اَرْحَمَ الرَّاحِمِيْنَ،اَللَّهُمَّ وَفِّقْنِيْ فِىْ الْمُطَالَعَةِ بِحَلِّ جَمِيْعِ مُشْكِلاَتِ الْمَسَآئِلِ مِنَ الْكُتُبِ بِرَحْمَتِكَ يَا اَرْحَمَ الرَّاحِمِيْنَ",
                        "english": "Allaahumma akrimnee binooril fahmi wa kharrajanee min z’ulumaatil wahmi waftah’ a’lainaa abwaaba i’lmak. Wan shur a’lainaa khuzzaanu ma’rifatika yaa arh’amar raah’imeen. Allaahumma waffiqnee fil mut’aala’ti bih’ablee jamee-i’ mushkilaatil masaa-ili minal kutubi birah’matika yaa arh’amar raah’imeen.",
                        "titleName": {
                                "Tamil": "படிப்பதற்கு முன் துவா",
                                "English": "Dua Before Studying",
                                "Urdu": "دعا سے پہلے مطالعہ"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Oh Allah, honor me by the light of understanding and take me out from the darkness of doubt and open upon us the doors of your knowledge and open upon us the treasure of your recognition, oh the best of the Merciful ones. Oh Allah, and give me Tawfeeq to study and solving all the difficult problems through books. By your mercy, oh the best of the merciful ones."
                                },
                                "Tamil": {
                                        "meaning": "யா அல்லாஹ், புரிந்துகொள்ளும் ஒளியால் என்னை மதித்து, சந்தேகத்தின் இருளிலிருந்து என்னை வெளியே அழைத்துச் சென்று, உன் அறிவின் கதவுகளை எங்கள் மீது திறந்து, உன் அங்கீகாரத்தின் புதையலை எங்களுக்குத் திறக்க,நீங்கள் மிக்க கருணையாளர்களில் மிகச் சிறந்தவன். ஓ அல்லாஹ், உங்கள் கருணையால், புத்தகங்கள் மூலம் கடினமான பிரச்சினைகள் அனைத்தையும் படிப்பதற்கும் தீர்ப்பதற்கும் எனக்கு தவ்ஃபீக் கொடுங்கள்."
                                },
                                "Urdu": {
                                        "meaning": "اے اللہ ، عقل کی روشنی سے میری عزت فرما اور مجھے شک کے اندھیروں سے نکال دے اور اپنے علم کے دروازے ہم پر کھول دے اور اپنی پہچان کا خزانہ ہم پر کھول دے ، اے بہترین رحم کرنے والوں میں۔ یا اللہ ، اور توفیق کو مطالعہ کرنے اور کتابوں کے ذریعے تمام مشکل مسائل حل کرنے کی توفیق عطا فرما۔ آپ کی رحمت سے ، اوہ سب سے اچھا رحم کرنے والا۔"
                                }
                        }
                },
                {
                        "title": "Dua After Studying",
                        "arabic": "اللَّهُمَّ إِنِّي أَسْتَوْدِعُكَ مَا قَرأتُ وَمَا حَفَظْتُ، فَرُضُهُ عَليّ عِنْدَ حَاجَتِي إِلَيهِ، إِنّكَ عَلى مَا تَشَاءُ قَدِيرُ وَأَنْتَ حَسْبِي وَنِعْمَ الوَكِيل",
                        "english": "Allahumma inni astaodeeka ma qara’tu wama hafaz-tu. Farudduhu ‘allaya inda hajati elahi. Innaka ‘ala ma-tasha’-u qadeer wa anta hasbeeya wa na’mal wakeel",
                        "titleName": {
                                "Tamil": "படித்த பிறகு துவா",
                                "English": "Dua After Studying",
                                "Urdu": "دعا کے بعد دعا"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Oh Allah! I entrust you with what I have read and I have studied. Oh Allah! Bring it back to me when I am in need of it. Oh Allah! You do whatever you wish, you are my availer and protector and the best of aid."
                                },
                                "Tamil": {
                                        "meaning": "யா அல்லாஹ்! நான் படித்ததையும், படித்ததையும் உங்களிடம் ஒப்படைக்கிறேன். ஓ அல்லாஹ்! எனக்கு தேவைப்படும்போது அதை என்னிடம் கொண்டு வாருங்கள். ஓ அல்லாஹ்! நீங்கள் எதை வேண்டுமானாலும் செய்கிறீர்கள், நீங்கள் என் பாதுகாவலர் மற்றும் சிறந்த உதவியாளர்."
                                },
                                "Urdu": {
                                        "meaning": "اے اللہ! میں آپ کو اس کے سپرد کرتا ہوں جو میں نے پڑھا ہے اور میں نے تعلیم حاصل کی ہے۔ اے اللہ! جب مجھے اس کی ضرورت ہو تو اسے میرے پاس واپس لاؤ۔ اے اللہ! آپ جو چاہیں کرتے ہو ، آپ میرے ہواباز اور محافظ اور بہترین معاون ہیں۔"
                                }
                        }
                },
                {
                        "title": "Dua for confidence and eloquence ",
                        "arabic": "رَبِّ اشْرَحْ لِيْ صَدْرِيْ. وَيَسِّرْ لِيْٓ اَمْرِيْ. وَاحْلُلْ عُقْدَةً مِّنْ لِّسَانِيْ. يَفْقَـــهُوْا قَوْلِيْ.",
                        "english": "Rabbishrah’ Lee S’adree wa Yassir Leee Amree Wah’–Lul U’qdatam Mil Lisaanee Yafqahoo Qawlee",
                        "titleName": {
                                "Tamil": "நம்பிக்கை மற்றும் சொற்பொழிவுக்கான துவா",
                                "English": "Dua for confidence and eloquence",
                                "Urdu": "اعتماد اور فصاحت کے لئے دعا"
                        },
                        "language": {
                                "English": {
                                        "meaning": "Ya Allah! Open for me my chest. And ease my task for me. And make loose the knot from my tongue, that they understand my speech."
                                },
                                "Tamil": {
                                        "meaning": "யா அல்லாஹ்! எனக்காக என் பணியை எளிதாக்குங்கள். என் பேச்சை அவர்கள் புரிந்துகொள்ளும்படி, என் நாக்கிலிருந்து முடிச்சு அவிழ்த்து விடுங்கள்."
                                },
                                "Urdu": {
                                        "meaning": "اے میرے رب! میرے سینے کو کھول دو۔ اور میرے لئے اپنا کام آسان کردے۔ اور میری زبان سے گرہ کو کھو دو ، تاکہ وہ میری تقریر کو سمجھیں۔ "
                                }
                        }
                }
        ],
        "Decision & Guidance": [
                {
                        "icon": decision,
                        "title": " Dua For Istikhara",
                        "arabic": "اللَّهُمَّ إِنِّي أَسْتَخِيرُكَ بِعِلْمَكَ، وَأَسْتَقْدِرُكَ بِقُدْرَتِكَ، وَأَسْأَلُكَ مِنْ فَضْلِكَ الْعَظِيمِ، فَإِنَّكَ تَقْدِرُ وَلَا أَقْدِرُ، وَتَعْلَمُ، وَلَا أَعْلَمُ، وَأَنْتَ عَلَّامُ الْغُيُوبِ، اللَّهُمَّ إِنْ كُنْتَ تَعْلَمُ أَنَّ هَذَا الْأَمْرَ- خَيْرٌ لِي فِي دِينِي وَمَعَاشِي وَعَاقِبَةِ أَمْرِي- عَاجِلِهِ وَآجِلِهِ- فَاقْدُرْهُ لِي وَيَسِّرْهُ لِي ثُمَّ بَارِكْ لِي فِيهِ، وَإِنْ كُنْتَ تَعْلَمُ أَنَّ هَذَا الْأَمْرَ شَرٌّ لِي فِي دِينِي وَمَعَاشِي وَعَاقِبَةِ أَمْرِي- عَاجِلِهِ وَآجِلِهِ- فَاصْرِفْهُ عَنِّي وَاصْرِفْنِي عَنْهُ وَاقْدُرْ لِيَ الْخَيْرَ حَيْثُ كَانَ ثُمَّ أَرْضِنِي بِهِ",
                        "english": "Allaahumma 'innee 'astakheeruka bi'ilmika, wa 'astaqdiruka biqudratika, wa 'as'aluka min fadhtikal-'Adheemi, fa'innaka taqdiru wa laa 'aqdiru, wa ta'lamu, wa laa 'a'lamu, wa 'Anta 'Allaamul-Ghuyoobi, Allaahumma 'in kunta ta'lamu 'anna haathal-'amra-[then mention the thing to be decided] Khayrun lee fee deenee wa ma'aashee wa 'aaqibati 'amree - [or say] 'Aajilihi wa 'aajilihi - Faqdurhu lee wa yassirhu lee thumma baarik lee feehi, wa 'in kunta ta'lamu 'anna haathal-'amra sharrun lee fee deenee wa ma'aashee wa 'aaqibati 'amree - [or say] 'Aajilihi wa 'aajilihi - Fasrifhu 'annee wasrifnee 'anhu waqdur liyal-khayra haythu kaana thumma 'ardhinee bihi",
                        "titleDua": {
                                "Tamil": "முடிவு & வழிகாட்டுதல் துவா",
                                "English": "Dua for making Decision/Guidance",
                                "Urdu": "فیصلہ / رہنمائی"
                        },
                        "titleName": {
                                "Tamil": "இஸ்திகாரா துவா",
                                "English": " Dua For Istikhara",
                                "Urdu": "دعا استخارہ کے لئے"
                        },
                        "language": {
                                "English": {
                                        "meaning": "O Allah, I seek the counsel of Your Knowledge, and I seek the help of Your Omnipotence, and I beseech You for Your Magnificent Grace. Surely, You are Capable and I am not. You know and I know not, and You are the Knower of the unseen. O Allah, if You know that this matter [then mention the thing to be decided] is good for me in my religion and in my life and for my welfare in the life to come, - [or say: in this life and the afterlife] - then ordain it for me and make it easy for me, then bless me in it. And if You know that this matter is bad for me in my religion and in my life and for my welfare in the life to come, - [or say: in this life and the afterlife] - then distance it from me, and distance me from it, and ordain for me what is good wherever it may be, and help me to be content with it. Whoever seeks the counsel of the Creator will not regret it and whoever seeks the advice of the believers will feel confident about his decisions. Allah said in the Qur'an: 'And consult them in the affair. Then when you have taken a decision, put your trust in Allah'"
                                },
                                "Tamil": {
                                        "meaning": "அல்லாஹ்வே, நான் உமது அறிவின் ஆலோசனையை நாடுகிறேன், உன்னுடைய சர்வ வல்லமையின் உதவியை நாடுகிறேன். நிச்சயமாக, நீங்கள் திறமையானவர், நான் இல்லை. உங்களுக்குத் தெரியும், எனக்குத் தெரியாது, நீங்கள் காணாததை அறிந்தவர். அல்லாஹ்வே, இந்த விஷயம் என் மதத்திலும் என் வாழ்க்கையிலும், வரவிருக்கும் வாழ்க்கையில் என் நலனுக்காகவும் நல்லது என்று உங்களுக்குத் தெரிந்தால், அதை எனக்காக நியமித்து எனக்கு எளிதாக்குங்கள், பின்னர் அதில் என்னை ஆசீர்வதியுங்கள். இந்த விஷயம் என் மதத்திலும், என் வாழ்க்கையிலும், வரவிருக்கும் வாழ்க்கையில் மோசமானது என்பதை நீங்கள் அறிந்திருந்தால், - அதை என்னிடமிருந்து விலக்கி, அதிலிருந்து என்னை விலக்கி, எங்கிருந்தாலும் நல்லது எது என்று எனக்குத் தெரியப்படுத்துங்கள், அதில் திருப்தி அடைய எனக்கு உதவுங்கள். படைப்பாளரின் ஆலோசனையை நாடுபவர் வருத்தப்பட மாட்டார், விசுவாசிகளின் ஆலோசனையை நாடுபவர் அவருடைய முடிவுகளைப் பற்றி நம்பிக்கையுடன் இருப்பார். அல்லாஹ் குர்ஆனில் கூறினார்: 'மேலும் இந்த விவகாரத்தில் அவர்களைக் கலந்தாலோசிக்கவும். நீங்கள் ஒரு முடிவை எடுத்ததும், அல்லாஹ்வின் மீது நம்பிக்கை வைக்கவும்."
                                },
                                "Urdu": {
                                        "meaning": ""
                                }
                        }
                }
        ]
}
export default duas;